(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var _regenerator = __webpack_require__(15);

	var _regenerator2 = _interopRequireDefault(_regenerator);

	var _asyncToGenerator2 = __webpack_require__(14);

	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

	var _preactHabitat = __webpack_require__(119);

	var _preactHabitat2 = _interopRequireDefault(_preactHabitat);

	var _Root = __webpack_require__(3);

	var _Root2 = _interopRequireDefault(_Root);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	window.renderCowi = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	  var g;
	  return _regenerator2.default.wrap(function _callee$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          // moving stuff from loader.js to here
	          if (window.Shopify) {
	            g = null;

	            g = document.createElement("div");
	            g.setAttribute("class", "coca-widget");
	            g.setAttribute("data-prop-id", "corner-widget");
	            g.setAttribute("data-prop-type", "corner-widget");

	            document.body.appendChild(g);
	          }
	          (0, _preactHabitat2.default)(_Root2.default).render({
	            selector: ".coca-widget",
	            inline: false,
	            clean: false
	          });

	        case 2:
	        case "end":
	          return _context.stop();
	      }
	    }
	  }, _callee, undefined);
	}));

	// in development, set up HMR:
	if (false) {
	  // require("preact/devtools"); // enables React DevTools, be careful on IE
	  module.hot.accept("./Root", function () {
	    return requestAnimationFrame(init);
	  }); // eslint-disable-line
	}

	window.renderCowi();

	// re-render on dom ready
	document.addEventListener("DOMContentLoaded", function () {
	  window.renderCowi();
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	var n,l,u,t,i,o,r,f={},e=[],c=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord/i;function s(n,l){for(var u in l)n[u]=l[u];return n}function a(n){var l=n.parentNode;l&&l.removeChild(n)}function p(n,l,u){var t,i,o,r,f=arguments;if(l=s({},l),arguments.length>3)for(u=[u],t=3;t<arguments.length;t++)u.push(f[t]);if(null!=u&&(l.children=u),null!=n&&null!=n.defaultProps)for(i in n.defaultProps)void 0===l[i]&&(l[i]=n.defaultProps[i]);return r=l.key,null!=(o=l.ref)&&delete l.ref,null!=r&&delete l.key,h(n,l,r,o)}function h(l,u,t,i){var o={type:l,props:u,key:t,ref:i,__k:null,__:null,__b:0,__e:null,__d:null,__c:null,constructor:void 0};return n.vnode&&n.vnode(o),o}function v(n){return n.children}function d(n,l){this.props=n,this.context=l}function y(n,l){if(null==l)return n.__?y(n.__,n.__.__k.indexOf(n)+1):null;for(var u;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e)return u.__e;return"function"==typeof n.type?y(n):null}function m(n){var l,u;if(null!=(n=n.__)&&null!=n.__c){for(n.__e=n.__c.base=null,l=0;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e){n.__e=n.__c.base=u.__e;break}return m(n)}}function x(l){(!l.__d&&(l.__d=!0)&&1===u.push(l)||i!==n.debounceRendering)&&((i=n.debounceRendering)||t)(w)}function w(){var n,l,t,i,o,r,f;for(u.sort(function(n,l){return l.__v.__b-n.__v.__b});n=u.pop();)n.__d&&(t=void 0,i=void 0,r=(o=(l=n).__v).__e,(f=l.__P)&&(t=[],i=N(f,o,s({},o),l.__n,void 0!==f.ownerSVGElement,null,t,null==r?y(o):r),T(t,o),i!=r&&m(o)))}function g(n,l,u,t,i,o,r,c,s){var p,h,v,d,m,x,w,g=u&&u.__k||e,_=g.length;if(c==f&&(c=null!=o?o[0]:_?y(u,0):null),p=0,l.__k=k(l.__k,function(u){if(null!=u){if(u.__=l,u.__b=l.__b+1,null===(v=g[p])||v&&u.key==v.key&&u.type===v.type)g[p]=void 0;else for(h=0;h<_;h++){if((v=g[h])&&u.key==v.key&&u.type===v.type){g[h]=void 0;break}v=null}if(d=N(n,u,v=v||f,t,i,o,r,c,s),(h=u.ref)&&v.ref!=h&&(w||(w=[]),v.ref&&w.push(v.ref,null,u),w.push(h,u.__c||d,u)),null!=d){if(null==x&&(x=d),null!=u.__d)d=u.__d,u.__d=null;else if(o==v||d!=c||null==d.parentNode){n:if(null==c||c.parentNode!==n)n.appendChild(d);else{for(m=c,h=0;(m=m.nextSibling)&&h<_;h+=2)if(m==d)break n;n.insertBefore(d,c)}"option"==l.type&&(n.value="")}c=d.nextSibling,"function"==typeof l.type&&(l.__d=d)}}return p++,u}),l.__e=x,null!=o&&"function"!=typeof l.type)for(p=o.length;p--;)null!=o[p]&&a(o[p]);for(p=_;p--;)null!=g[p]&&z(g[p],g[p]);if(w)for(p=0;p<w.length;p++)j(w[p],w[++p],w[++p])}function k(n,l,u){if(null==u&&(u=[]),null==n||"boolean"==typeof n)l&&u.push(l(null));else if(Array.isArray(n))for(var t=0;t<n.length;t++)k(n[t],l,u);else u.push(l?l("string"==typeof n||"number"==typeof n?h(null,n,null,null):null!=n.__e||null!=n.__c?h(n.type,n.props,n.key,null):n):n);return u}function _(n,l,u,t,i){var o;for(o in u)o in l||C(n,o,null,u[o],t);for(o in l)i&&"function"!=typeof l[o]||"value"===o||"checked"===o||u[o]===l[o]||C(n,o,l[o],u[o],t)}function b(n,l,u){"-"===l[0]?n.setProperty(l,u):n[l]="number"==typeof u&&!1===c.test(l)?u+"px":null==u?"":u}function C(n,l,u,t,i){var o,r,f,e,c;if(i?"className"===l&&(l="class"):"class"===l&&(l="className"),"key"===l||"children"===l);else if("style"===l)if(o=n.style,"string"==typeof u)o.cssText=u;else{if("string"==typeof t&&(o.cssText="",t=null),t)for(r in t)u&&r in u||b(o,r,"");if(u)for(f in u)t&&u[f]===t[f]||b(o,f,u[f])}else"o"===l[0]&&"n"===l[1]?(e=l!==(l=l.replace(/Capture$/,"")),c=l.toLowerCase(),l=(c in n?c:l).slice(2),u?(t||n.addEventListener(l,P,e),(n.l||(n.l={}))[l]=u):n.removeEventListener(l,P,e)):"list"!==l&&"tagName"!==l&&"form"!==l&&!i&&l in n?n[l]=null==u?"":u:"function"!=typeof u&&"dangerouslySetInnerHTML"!==l&&(l!==(l=l.replace(/^xlink:?/,""))?null==u||!1===u?n.removeAttributeNS("http://www.w3.org/1999/xlink",l.toLowerCase()):n.setAttributeNS("http://www.w3.org/1999/xlink",l.toLowerCase(),u):null==u||!1===u?n.removeAttribute(l):n.setAttribute(l,u))}function P(l){this.l[l.type](n.event?n.event(l):l)}function N(l,u,t,i,o,r,f,e,c){var a,p,h,y,m,x,w,_,b,C,P=u.type;if(void 0!==u.constructor)return null;(a=n.__b)&&a(u);try{n:if("function"==typeof P){if(_=u.props,b=(a=P.contextType)&&i[a.__c],C=a?b?b.props.value:a.__:i,t.__c?w=(p=u.__c=t.__c).__=p.__E:("prototype"in P&&P.prototype.render?u.__c=p=new P(_,C):(u.__c=p=new d(_,C),p.constructor=P,p.render=A),b&&b.sub(p),p.props=_,p.state||(p.state={}),p.context=C,p.__n=i,h=p.__d=!0,p.__h=[]),null==p.__s&&(p.__s=p.state),null!=P.getDerivedStateFromProps&&(p.__s==p.state&&(p.__s=s({},p.__s)),s(p.__s,P.getDerivedStateFromProps(_,p.__s))),y=p.props,m=p.state,h)null==P.getDerivedStateFromProps&&null!=p.componentWillMount&&p.componentWillMount(),null!=p.componentDidMount&&p.__h.push(p.componentDidMount);else{if(null==P.getDerivedStateFromProps&&null==p.__e&&null!=p.componentWillReceiveProps&&p.componentWillReceiveProps(_,C),!p.__e&&null!=p.shouldComponentUpdate&&!1===p.shouldComponentUpdate(_,p.__s,C)){for(p.props=_,p.state=p.__s,p.__d=!1,p.__v=u,u.__e=t.__e,u.__k=t.__k,p.__h.length&&f.push(p),a=0;a<u.__k.length;a++)u.__k[a]&&(u.__k[a].__=u);break n}null!=p.componentWillUpdate&&p.componentWillUpdate(_,p.__s,C),null!=p.componentDidUpdate&&p.__h.push(function(){p.componentDidUpdate(y,m,x)})}p.context=C,p.props=_,p.state=p.__s,(a=n.__r)&&a(u),p.__d=!1,p.__v=u,p.__P=l,a=p.render(p.props,p.state,p.context),u.__k=k(null!=a&&a.type==v&&null==a.key?a.props.children:a),null!=p.getChildContext&&(i=s(s({},i),p.getChildContext())),h||null==p.getSnapshotBeforeUpdate||(x=p.getSnapshotBeforeUpdate(y,m)),g(l,u,t,i,o,r,f,e,c),p.base=u.__e,p.__h.length&&f.push(p),w&&(p.__E=p.__=null),p.__e=null}else u.__e=$(t.__e,u,t,i,o,r,f,c);(a=n.diffed)&&a(u)}catch(l){n.__e(l,u,t)}return u.__e}function T(l,u){n.__c&&n.__c(u,l),l.some(function(u){try{l=u.__h,u.__h=[],l.some(function(n){n.call(u)})}catch(l){n.__e(l,u.__v)}})}function $(n,l,u,t,i,o,r,c){var s,a,p,h,v,d=u.props,y=l.props;if(i="svg"===l.type||i,null==n&&null!=o)for(s=0;s<o.length;s++)if(null!=(a=o[s])&&(null===l.type?3===a.nodeType:a.localName===l.type)){n=a,o[s]=null;break}if(null==n){if(null===l.type)return document.createTextNode(y);n=i?document.createElementNS("http://www.w3.org/2000/svg",l.type):document.createElement(l.type),o=null}if(null===l.type)null!=o&&(o[o.indexOf(n)]=null),d!==y&&(n.data=y);else if(l!==u){if(null!=o&&(o=e.slice.call(n.childNodes)),p=(d=u.props||f).dangerouslySetInnerHTML,h=y.dangerouslySetInnerHTML,!c){if(d===f)for(d={},v=0;v<n.attributes.length;v++)d[n.attributes[v].name]=n.attributes[v].value;(h||p)&&(h&&p&&h.__html==p.__html||(n.innerHTML=h&&h.__html||""))}_(n,y,d,i,c),l.__k=l.props.children,h||g(n,l,u,t,"foreignObject"!==l.type&&i,o,r,f,c),c||("value"in y&&void 0!==y.value&&y.value!==n.value&&(n.value=null==y.value?"":y.value),"checked"in y&&void 0!==y.checked&&y.checked!==n.checked&&(n.checked=y.checked))}return n}function j(l,u,t){try{"function"==typeof l?l(u):l.current=u}catch(l){n.__e(l,t)}}function z(l,u,t){var i,o,r;if(n.unmount&&n.unmount(l),(i=l.ref)&&j(i,null,u),t||"function"==typeof l.type||(t=null!=(o=l.__e)),l.__e=l.__d=null,null!=(i=l.__c)){if(i.componentWillUnmount)try{i.componentWillUnmount()}catch(l){n.__e(l,u)}i.base=i.__P=null}if(i=l.__k)for(r=0;r<i.length;r++)i[r]&&z(i[r],u,t);null!=o&&a(o)}function A(n,l,u){return this.constructor(n,u)}function D(l,u,t){var i,r,c;n.__&&n.__(l,u),r=(i=t===o)?null:t&&t.__k||u.__k,l=p(v,null,[l]),c=[],N(u,(i?u:t||u).__k=l,r||f,f,void 0!==u.ownerSVGElement,t&&!i?[t]:r?null:e.slice.call(u.childNodes),c,t||f,i),T(c,l)}n={__e:function(n,l){for(var u;l=l.__;)if((u=l.__c)&&!u.__)try{if(u.constructor&&null!=u.constructor.getDerivedStateFromError)u.setState(u.constructor.getDerivedStateFromError(n));else{if(null==u.componentDidCatch)continue;u.componentDidCatch(n)}return x(u.__E=u)}catch(l){n=l}throw n}},l=function(n){return null!=n&&void 0===n.constructor},d.prototype.setState=function(n,l){var u;u=this.__s!==this.state?this.__s:this.__s=s({},this.state),"function"==typeof n&&(n=n(u,this.props)),n&&s(u,n),null!=n&&this.__v&&(this.__e=!1,l&&this.__h.push(l),x(this))},d.prototype.forceUpdate=function(n){this.__v&&(this.__e=!0,n&&this.__h.push(n),x(this))},d.prototype.render=v,u=[],t="function"==typeof Promise?Promise.prototype.then.bind(Promise.resolve()):setTimeout,o=f,r=0,exports.render=D,exports.hydrate=function(n,l){D(n,l,o)},exports.createElement=p,exports.h=p,exports.Fragment=v,exports.createRef=function(){return{}},exports.isValidElement=l,exports.Component=d,exports.cloneElement=function(n,l){return l=s(s({},n.props),l),arguments.length>2&&(l.children=e.slice.call(arguments,2)),h(n.type,l,l.key||n.key,l.ref||n.ref)},exports.createContext=function(n){var l={},u={__c:"__cC"+r++,__:n,Consumer:function(n,l){return n.children(l)},Provider:function(n){var t,i=this;return this.getChildContext||(t=[],this.getChildContext=function(){return l[u.__c]=i,l},this.shouldComponentUpdate=function(l){n.value!==l.value&&t.some(function(n){n.context=l.value,x(n)})},this.sub=function(n){t.push(n);var l=n.componentWillUnmount;n.componentWillUnmount=function(){t.splice(t.indexOf(n),1),l&&l.call(n)}}),n.children}};return u.Consumer.contextType=u,u},exports.toChildArray=k,exports._e=z,exports.options=n;
	//# sourceMappingURL=preact.js.map


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var n,t,r,u=__webpack_require__(1),o=[],i=u.options.__r,e=u.options.diffed,f=u.options.__c,c=u.options.unmount;function a(n){u.options.__h&&u.options.__h(t);var r=t.__H||(t.__H={t:[],u:[]});return n>=r.t.length&&r.t.push({}),r.t[n]}function p(r,u,o){var i=a(n++);return i.__c||(i.__c=t,i.o=[o?o(u):y(void 0,u),function(n){var t=r(i.o[0],n);i.o[0]!==t&&(i.o[0]=t,i.__c.setState({}))}]),i.o}function v(r,u){var o=a(n++);d(o.i,u)&&(o.o=r,o.i=u,t.__h.push(o))}function s(t,r){var u=a(n++);return d(u.i,r)?(u.i=r,u.p=t,u.o=t()):u.o}function x(){o.some(function(n){n.__P&&(n.__H.u.forEach(l),n.__H.u.forEach(m),n.__H.u=[])}),o=[]}function l(n){n.v&&n.v()}function m(n){var t=n.o();"function"==typeof t&&(n.v=t)}function d(n,t){return!n||t.some(function(t,r){return t!==n[r]})}function y(n,t){return"function"==typeof t?t(n):t}u.options.__r=function(r){i&&i(r),n=0,(t=r.__c).__H&&(t.__H.u.forEach(l),t.__H.u.forEach(m),t.__H.u=[])},u.options.diffed=function(n){e&&e(n);var t=n.__c;if(t){var i=t.__H;i&&i.u.length&&(1!==o.push(t)&&r===u.options.requestAnimationFrame||((r=u.options.requestAnimationFrame)||function(n){var t,r=function(){clearTimeout(u),cancelAnimationFrame(t),setTimeout(n)},u=setTimeout(r,100);"undefined"!=typeof window&&(t=requestAnimationFrame(r))})(x))}},u.options.__c=function(n,t){t.some(function(n){n.__h.forEach(l),n.__h=n.__h.filter(function(n){return!n.o||m(n)})}),f&&f(n,t)},u.options.unmount=function(n){c&&c(n);var t=n.__c;if(t){var r=t.__H;r&&r.t.forEach(function(n){return n.v&&n.v()})}},exports.useState=function(n){return p(y,n)},exports.useReducer=p,exports.useEffect=function(r,u){var o=a(n++);d(o.i,u)&&(o.o=r,o.i=u,t.__H.u.push(o))},exports.useLayoutEffect=v,exports.useRef=function(n){return s(function(){return{current:n}},[])},exports.useImperativeHandle=function(n,t,r){v(function(){"function"==typeof n?n(t()):n&&(n.current=t())},null==r?r:r.concat(n))},exports.useMemo=s,exports.useCallback=function(n,t){return s(function(){return n},t)},exports.useContext=function(r){var u=t.context[r.__c];if(!u)return r.__;var o=a(n++);return null==o.o&&(o.o=!0,u.sub(t)),u.props.value},exports.useDebugValue=function(n,t){u.options.useDebugValue&&u.options.useDebugValue(t?t(n):n)};
	//# sourceMappingURL=hooks.js.map


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;
	exports.GlobalContext = undefined;

	var _regenerator = __webpack_require__(15);

	var _regenerator2 = _interopRequireDefault(_regenerator);

	var _asyncToGenerator2 = __webpack_require__(14);

	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

	var _extends2 = __webpack_require__(78);

	var _extends3 = _interopRequireDefault(_extends2);

	var _preact = __webpack_require__(1);

	var _hooks = __webpack_require__(2);

	__webpack_require__(125);

	var _CornerWidget = __webpack_require__(74);

	var _CornerWidget2 = _interopRequireDefault(_CornerWidget);

	var _shopify = __webpack_require__(75);

	var _utilities = __webpack_require__(4);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var GlobalContext = exports.GlobalContext = (0, _preact.createContext)("");

	var Root = function Root(props) {
	  var _useState = (0, _hooks.useState)(null),
	      renderConfig = _useState[0],
	      setRenderConfig = _useState[1];

	  var _useState2 = (0, _hooks.useState)("en"),
	      language = _useState2[0],
	      setLanguage = _useState2[1];

	  var _useState3 = (0, _hooks.useState)(false),
	      forceHideSuco = _useState3[0],
	      setForceHideSuco = _useState3[1];

	  var _useState4 = (0, _hooks.useState)([{
	    view: "assistant",
	    params: ""
	  }]),
	      viewStateHistory = _useState4[0],
	      setViewStateHistory = _useState4[1];

	  var _useState5 = (0, _hooks.useState)("general"),
	      pageType = _useState5[0],
	      setPageType = _useState5[1];

	  var _useState6 = (0, _hooks.useState)(false),
	      isStickyBarVisible = _useState6[0],
	      setIsStickyBarVisible = _useState6[1];

	  var _useState7 = (0, _hooks.useState)(false),
	      isCowiOpened = _useState7[0],
	      setIsCowiOpened = _useState7[1];

	  var _useState8 = (0, _hooks.useState)(null),
	      currentProduct = _useState8[0],
	      setCurrentProduct = _useState8[1];
	  // if there is cart information in the local storage its taken


	  var _useState9 = (0, _hooks.useState)(window.localStorage.getItem("mfycartInfo") ? JSON.parse(window.localStorage.getItem("mfycartInfo")) : null),
	      cartInfo = _useState9[0],
	      setcartInfo = _useState9[1];

	  // viewStateHistory Magement Funtions : These funtios add/remove values from viewStateArray. The top most value in viewStateArray decides in which view the user is currently in


	  var removeFromViewStateHistory = function removeFromViewStateHistory() {
	    var tempViewStateHistory = viewStateHistory;
	    tempViewStateHistory.pop();
	    setViewStateHistory([].concat(tempViewStateHistory));
	  };
	  var addToViewStateHistory = function addToViewStateHistory(view, params) {
	    var tempViewStateHistory = viewStateHistory;
	    tempViewStateHistory.push({
	      view: view,
	      params: params
	    });
	    if (tempViewStateHistory.length > 5) tempViewStateHistory.shift();
	    setViewStateHistory([].concat(tempViewStateHistory));
	  };

	  var tempOffers = [{
	    title: "asad",
	    description: "asd",
	    type: "url",
	    url: "123",
	    endsAt: "12",
	    images: ["goo.gl", "cowi.com", "https://jol.co/"]
	  }];

	  // this fuction return "advancedCart" if more than one context are active (This logic works because True = 1 and false = 0)
	  var cartStyleFinder = function cartStyleFinder() {
	    var contextConfigs = renderConfig.config.widgetConfig.commonConfig.contextConfigs;
	    if (contextConfigs.assistant + contextConfigs.cart + contextConfigs.offers >= 2) return "advancedCart";else return "miniCart";
	  };

	  var getCurrentLangugeObject = function getCurrentLangugeObject(selectedLanguage) {
	    var langConfig = renderConfig.config.widgetConfig.langConfig.cornerWidget;
	    var defaultLanguage = renderConfig.config.widgetConfig.langConfig.defaultLanguage;

	    if (renderConfig && langConfig.hasOwnProperty(language)) return langConfig[selectedLanguage];else return langConfig[defaultLanguage];
	  };

	  // This value is pass down to all children as a context


	  var isolateLanguageSpecificArticles = function isolateLanguageSpecificArticles(articleList) {
	    var finalRightLangArticleList = [];
	    var finalDefaultLangArticleList = [];
	    var defaultLanguage = renderConfig.config.widgetConfig.langConfig.defaultLanguage;

	    articleList.map(function (article) {
	      var rightContentIndex = article.content.findIndex(function (contentItem) {
	        return contentItem.lang === language;
	      });
	      var rightMetadataIndex = article.metadata.findIndex(function (metadataItem) {
	        return metadataItem.lang === language;
	      });
	      if (rightContentIndex !== -1 && rightMetadataIndex !== -1) {
	        var finalRightArticle = (0, _extends3.default)({}, article, {
	          title: article.content[rightContentIndex].value.title,
	          body: article.content[rightContentIndex].value.body,
	          seo_options: article.metadata[rightMetadataIndex].value
	        });
	        finalRightLangArticleList.push(finalRightArticle);
	      }
	      var defaultContentIndex = article.content.findIndex(function (contentItem) {
	        return contentItem.lang === defaultLanguage;
	      });
	      var defaultMetadataIndex = article.metadata.findIndex(function (metadataItem) {
	        return metadataItem.lang === defaultLanguage;
	      });
	      if (defaultContentIndex !== -1 && defaultMetadataIndex !== -1) {
	        var finalDefaultArticle = (0, _extends3.default)({}, article, {
	          title: article.content[defaultContentIndex].value.title,
	          body: article.content[defaultContentIndex].value.body,
	          seo_options: article.metadata[defaultMetadataIndex].value
	        });
	        finalDefaultLangArticleList.push(finalDefaultArticle);
	      }
	    });
	    if (finalRightLangArticleList.length > 0) return finalRightLangArticleList;else return finalDefaultLangArticleList;
	  };

	  var isolateLanguageSpecificCategories = function isolateLanguageSpecificCategories(categoryList) {
	    var finalRightCategoryList = [];
	    var finalDefaultCategoryList = [];
	    var defaultLanguage = renderConfig.config.widgetConfig.langConfig.defaultLanguage;

	    categoryList.map(function (category) {
	      var rightContentIndex = category.content.findIndex(function (contentItem) {
	        return contentItem.lang === language;
	      });

	      var finalRightCategory = (0, _extends3.default)({}, category, {
	        name: rightContentIndex !== -1 ? category.content[rightContentIndex].value.name : category.content[0].value.name
	      });
	      finalRightCategoryList.push(finalRightCategory);

	      var defaultContentIndex = category.content.findIndex(function (contentItem) {
	        return contentItem.lang === defaultLanguage;
	      });
	      var finalDefaultCategory = (0, _extends3.default)({}, category, {
	        name: defaultContentIndex !== -1 ? category.content[defaultContentIndex].value.name : category.content[0].value.name
	      });

	      finalDefaultCategoryList.push(finalDefaultCategory);
	    });
	    if (finalRightCategoryList.length > 0) return finalRightCategoryList;else return finalDefaultCategoryList;
	  };

	  var globalContextValues = {
	    pageType: pageType,
	    isCowiOpened: { get: isCowiOpened, set: setIsCowiOpened },
	    viewStateHistory: {
	      currentView: viewStateHistory[viewStateHistory.length - 1],
	      goBack: removeFromViewStateHistory,
	      goTo: addToViewStateHistory
	    },
	    isStickyBarVisible: { get: isStickyBarVisible, set: setIsStickyBarVisible },
	    cartInfo: { get: cartInfo, set: setcartInfo },
	    currentProduct: { get: currentProduct, set: setCurrentProduct },
	    currentLanguage: renderConfig && getCurrentLangugeObject(language),
	    widgetConfig: renderConfig && renderConfig.config.widgetConfig,
	    widgetStyle: renderConfig && cartStyleFinder(),
	    storeName: "tempStoreName",
	    featureFlag: {
	      supportCorner: renderConfig && renderConfig.config.supportCorner.featureFlag
	    },
	    faqList: {
	      articles: renderConfig && renderConfig.config.supportCorner.articles ? isolateLanguageSpecificArticles(renderConfig.config.supportCorner.articles) : [],
	      categories: renderConfig && renderConfig.config.supportCorner.categories ? isolateLanguageSpecificCategories(renderConfig.config.supportCorner.categories) : []
	    },
	    offersList: tempOffers
	  };

	  var getLangCodeFromShopify = function getLangCodeFromShopify() {
	    if (window.Shopify.locale === "zh-CN" || window.Shopify.locale === "zh-TW" || window.Shopify.locale === "pt-BR") return window.Shopify.locale;else {
	      // Taking just first two letter for all languages other than chinese, taivanese & portughese
	      return window.Shopify.locale.substring(0, 2);
	    }
	  };

	  // fetching config of the widgets from backend
	  (0, _hooks.useEffect)((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	    var data, urlParams, translatedLanguages, langCode;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return (0, _utilities.fetchConfig)();

	          case 2:
	            data = _context.sent;

	            setRenderConfig(data);

	            urlParams = new URLSearchParams(window.location.search);
	            translatedLanguages = data && Object.keys(data.config.widgetConfig.langConfig.faqPage);


	            if (urlParams.get("lang")) setLanguage(urlParams.get("lang"));else if (data && translatedLanguages.length > 1 && data.config.supportCorner.featureFlag.multi_language_support && window.Shopify && window.Shopify.locale) {
	              langCode = getLangCodeFromShopify();

	              setLanguage(langCode);
	            } else if (data && data.config.widgetConfig.langConfig.defaultLanguage) setLanguage(data.config.widgetConfig.langConfig.defaultLanguage);else {
	              setLanguage("en");
	            }
	            console.log("%c Help desk powered by Corner (12.89) ", "background: #222; color: #bada55");

	          case 8:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  })), []);

	  // external funtion to control widgets from browser console
	  var externalSucoTrigger = function externalSucoTrigger(value) {
	    switch (value) {
	      case "openSuco":
	        setIsCowiOpened(true);
	        break;
	      case "closeSuco":
	        setIsCowiOpened(false);
	        break;
	      case "hideSuco":
	        setForceHideSuco(true);
	        break;
	      case "unhideSuco":
	        setForceHideSuco(false);
	        break;
	      case "printConfig":
	        renderConfig ? console.log("config", renderConfig, globalContextValues) : console.log("config not loaded");
	        break;
	      default:
	        console.log("CoCa: Invalid Command");
	    }
	  };

	  window.externalSucoTrigger = externalSucoTrigger;

	  // getting current Product from the URL
	  var fetchProductInfo = function () {
	    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	      var productHandle, data;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              productHandle = window.location.href.substring(window.location.href.lastIndexOf("/") + 1).split("?")[0];
	              // This makes sure the api is only called on a product page

	              if (!(productHandle.length > 0)) {
	                _context2.next = 8;
	                break;
	              }

	              _context2.next = 4;
	              return (0, _shopify.getProductDetails)(productHandle);

	            case 4:
	              data = _context2.sent;

	              setCurrentProduct(data);
	              _context2.next = 9;
	              break;

	            case 8:
	              setCurrentProduct(null);

	            case 9:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined);
	    }));

	    return function fetchProductInfo() {
	      return _ref2.apply(this, arguments);
	    };
	  }();

	  var findPageType = function findPageType() {
	    if (window.location.href.includes("/products/")) {
	      setPageType("product");
	      fetchProductInfo();
	    } else if (window.location.href.includes("/collections/")) setPageType("collection");else setPageType("general");
	  };

	  (0, _hooks.useEffect)(function () {
	    findPageType();
	    return function () {};
	  }, []);

	  return (0, _preact.h)(
	    "div",
	    null,
	    props.type === "corner-widget" && (0, _preact.h)(
	      GlobalContext.Provider,
	      { value: globalContextValues },
	      renderConfig && !window.location.pathname.includes("/a/" + renderConfig.config.widgetConfig.faqConfig.appProxyUrl) ? (0, _preact.h)(
	        _preact.Fragment,
	        null,
	        !forceHideSuco && !globalContextValues.widgetConfig.commonConfig.blockedUrls.includes(window.location.pathname) && (0, _preact.h)(_CornerWidget2.default, null)
	      ) : null
	    )
	  );
	};

	exports.default = Root;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var _regenerator = __webpack_require__(15);

	var _regenerator2 = _interopRequireDefault(_regenerator);

	var _asyncToGenerator2 = __webpack_require__(14);

	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var fetchConfig = function () {
	  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	    var data;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return window.fetch(("https://starlink.cornercart.io") + "/api/config/" + window.Shopify.shop + "/conf.json");

	          case 2:
	            data = _context.sent;
	            _context.next = 5;
	            return data.json();

	          case 5:
	            data = _context.sent;
	            return _context.abrupt("return", data);

	          case 7:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));

	  return function fetchConfig() {
	    return _ref.apply(this, arguments);
	  };
	}();

	var calculateForeground = function calculateForeground(rgb) {
	  // The code below takes a rgb string and converts into array of integers consisting the R, G, B values
	  var rgbArray = rgb.substring(rgb.indexOf("(") + 1, rgb.length - 1).split(",").map(Number);
	  // Based on the R, G, B values foreground color is calculated (either black or white)
	  var foreground = rgbArray[0] * 0.299 + rgbArray[1] * 0.587 + rgbArray[2] * 0.114 > 186 ? "dark" : "light";
	  return foreground;
	};

	var rgbToRgba = function rgbToRgba(rgb, alphaValue) {
	  // The code below takes a rgb string and converts into array of integers consisting the R, G, B values
	  var rgbArray = rgb.substring(rgb.indexOf("(") + 1, rgb.length - 1).split(",");
	  var bgColor = "rgba(" + rgbArray[0] + "," + rgbArray[1] + "," + rgbArray[2] + "," + alphaValue + ")";
	  return bgColor;
	};

	module.exports = {
	  rgbToRgba: rgbToRgba,
	  calculateForeground: calculateForeground,
	  fetchConfig: fetchConfig
	};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(44)('wks');
	var uid = __webpack_require__(49);
	var Symbol = __webpack_require__(5).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';

	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};

	$exports.store = store;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.7' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(12);
	module.exports = function (it) {
	  if (!isObject(it)) return;(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(20);
	var createDesc = __webpack_require__(43);
	module.exports = __webpack_require__(10) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(24)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var core = __webpack_require__(7);
	var ctx = __webpack_require__(18);
	var hide = __webpack_require__(9);
	var has = __webpack_require__(19);
	var PROTOTYPE = 'prototype';

	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _promise = __webpack_require__(77);

	var _promise2 = _interopRequireDefault(_promise);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }

	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }

	      return step("next");
	    });
	  };
	};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(122);


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') return;(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	var toString = {}.toString;

	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(16);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(8);
	var IE8_DOM_DEFINE = __webpack_require__(85);
	var toPrimitive = __webpack_require__(105);
	var dP = Object.defineProperty;

	exports.f = __webpack_require__(10) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) return;('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var Open = function Open(props) {
	  if (props.selected) return (0, _preact.h)("img", {
	    className: "coca-cowi-icon",
	    src: props.color === "light" ? "https://assets.cornercart.io/images/corner-widget/offer-selected-light.svg" : "https://assets.cornercart.io/images/corner-widget/offer-selected-dark.svg",
	    alt: "offer"
	  });else return (0, _preact.h)("img", {
	    className: "coca-cowi-icon",
	    src: props.color === "light" ? "https://assets.cornercart.io/images/corner-widget/offer-light.svg" : "https://assets.cornercart.io/images/corner-widget/offer-dark.svg",
	    alt: "offer"
	  });
	};

	exports.default = Open;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) return;("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(12);
	var document = __webpack_require__(5).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(16);

	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) return;('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}

	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(20).f;
	var has = __webpack_require__(19);
	var TAG = __webpack_require__(6)('toStringTag');

	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(44)('keys');
	var uid = __webpack_require__(49);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(38);
	var defined = __webpack_require__(22);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var _Root = __webpack_require__(3);

	var _hooks = __webpack_require__(2);

	var FaqItem = function FaqItem(props) {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);
	  var categoryList = globalContext.faqList.categories;
	  var title = props.faqItem.title;
	  var findCategory = function findCategory() {
	    var currentCategory = categoryList.find(function (item) {
	      return item.categoryid === props.faqItem.categoryid;
	    });
	    return currentCategory;
	  };
	  return (0, _preact.h)(
	    "a",
	    {
	      role: "presentation",
	      onClick: function onClick() {
	        return globalContext.viewStateHistory.goTo("faqView", {
	          faqId: props.faqItem.id
	        });
	      }
	    },
	    (0, _preact.h)(
	      "div",
	      { className: "coca-d-flex coca-align-items-center coca-cowi-card coca-cowi-hover-card coca-cowi-faq-card" },
	      (0, _preact.h)(
	        "div",
	        { className: "coca-cowi-faq-card-image" },
	        props.faqItem.categoryid ? (0, _preact.h)("img", { src: findCategory().icon_url, alt: title }) : (0, _preact.h)("img", {
	          src: "https://assets.cornercart.io/coca-v2/images/category-icons/color/51.svg",
	          alt: title
	        })
	      ),
	      (0, _preact.h)(
	        "div",
	        { className: "coca-cowi-faq-card-details coca-d-col" },
	        (0, _preact.h)(
	          "p",
	          { className: "coca-cowi-faq-card-title" },
	          title
	        ),
	        props.faqItem.categoryid && (0, _preact.h)(
	          "small",
	          null,
	          findCategory().name
	        )
	      )
	    )
	  );
	};

	exports.default = FaqItem;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var _Root = __webpack_require__(3);

	var _hooks = __webpack_require__(2);

	var _fuse = __webpack_require__(118);

	var _fuse2 = _interopRequireDefault(_fuse);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// Performs fuzzy-search against existing FAQ articles using user search input

	var SearchBox = function SearchBox(props) {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);

	  var handleSearch = function handleSearch(text) {
	    if (text.length > 0) {
	      var fuse = new _fuse2.default(globalContext.faqList.articles, {
	        keys: ["title", "body"],
	        threshold: 0.2,
	        ignoreLocation: true,
	        minMatchCharLength: 3
	      });

	      props.onSearch({ isSearchActive: true, searchResult: fuse.search(text) });
	    } else {
	      props.onSearch({ isSearchActive: false, searchResult: [] });
	    }
	  };

	  return (0, _preact.h)(
	    "div",
	    { className: "coca-cowi-search-box coca-d-flex coca-align-items-center" },
	    (0, _preact.h)("input", {
	      id: "search-input",
	      className: "coca-search-input",
	      type: "text",
	      placeholder: globalContext.currentLanguage.assistant.search_box_placeholder ? globalContext.currentLanguage.assistant.search_box_placeholder : "Search for answers...",
	      onChange: function onChange(e) {
	        return handleSearch(e.target.value);
	      }
	    }),
	    (0, _preact.h)(
	      "div",
	      { className: "coca-d-flex coca-cowi-search-btn" },
	      (0, _preact.h)(
	        "svg",
	        {
	          fill: globalContext.widgetConfig.commonConfig.bgEndColor,
	          xmlns: "http://www.w3.org/2000/svg",
	          viewBox: "0 0 30 30",
	          width: "18px",
	          height: "18px"
	        },
	        (0, _preact.h)("path", { d: "M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z" })
	      )
	    )
	  );
	};

	exports.default = SearchBox;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var _Root = __webpack_require__(3);

	var _hooks = __webpack_require__(2);

	var _utilities = __webpack_require__(4);

	var CloseButton = function CloseButton(props) {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);
	  var fillColor = function fillColor() {
	    if (props.customFill) return props.customFill;
	    if ((0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgStartColor) === "light") return "white";else return "rgba(0,0,0,.6)";
	  };
	  return (0, _preact.h)(
	    "div",
	    { className: " coca-cowi-close-button " },
	    (0, _preact.h)(
	      "svg",
	      { x: "0px", y: "0px", width: "14px", viewBox: "0 0 348.333 348.334" },
	      (0, _preact.h)(
	        "g",
	        null,
	        (0, _preact.h)("path", {
	          fill: fillColor(),
	          d: "M336.559,68.611L231.016,174.165l105.543,105.549c15.699,15.705,15.699,41.145,0,56.85 c-7.844,7.844-18.128,11.769-28.407,11.769c-10.296,0-20.581-3.919-28.419-11.769L174.167,231.003L68.609,336.563 c-7.843,7.844-18.128,11.769-28.416,11.769c-10.285,0-20.563-3.919-28.413-11.769c-15.699-15.698-15.699-41.139,0-56.85 l105.54-105.549L11.774,68.611c-15.699-15.699-15.699-41.145,0-56.844c15.696-15.687,41.127-15.687,56.829,0l105.563,105.554 L279.721,11.767c15.705-15.687,41.139-15.687,56.832,0C352.258,27.466,352.258,52.912,336.559,68.611z"
	        })
	      )
	    )
	  );
	};

	exports.default = CloseButton;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var Open = function Open(props) {
	  if (props.selected) return (0, _preact.h)("img", {
	    className: "coca-cowi-icon",
	    src: props.color === "light" ? "https://assets.cornercart.io/images/corner-widget/filled-cart-light.svg" : "https://assets.cornercart.io/images/corner-widget/filled-cart-dark.svg",
	    alt: "Cart"
	  });else return (0, _preact.h)("img", {
	    className: "coca-cowi-icon",
	    src: props.color === "light" ? "https://assets.cornercart.io/images/corner-widget/empty-cart-light.svg" : "https://assets.cornercart.io/images/corner-widget/empty-cart-dark.svg",
	    alt: "Cart"
	  });
	};

	exports.default = Open;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(17);
	var TAG = __webpack_require__(6)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';

	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};

	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(5).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(17);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(25);
	var $export = __webpack_require__(11);
	var redefine = __webpack_require__(101);
	var hide = __webpack_require__(9);
	var Iterators = __webpack_require__(13);
	var $iterCreate = __webpack_require__(89);
	var setToStringTag = __webpack_require__(27);
	var getPrototypeOf = __webpack_require__(97);
	var ITERATOR = __webpack_require__(6)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';

	var returnThis = function () { return this; };

	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(98);
	var enumBugKeys = __webpack_require__(36);

	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(8);
	var isObject = __webpack_require__(12);
	var newPromiseCapability = __webpack_require__(26);

	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(7);
	var global = __webpack_require__(5);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});

	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(25) ? 'pure' : 'global',
	  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(8);
	var aFunction = __webpack_require__(16);
	var SPECIES = __webpack_require__(6)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(18);
	var invoke = __webpack_require__(86);
	var html = __webpack_require__(37);
	var cel = __webpack_require__(23);
	var global = __webpack_require__(5);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(17)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(29);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(22);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];

		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};

		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];

	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}

		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();

		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

		var styles = listToStyles(list);
		addStylesToDom(styles, options);

		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}

	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}

	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}

	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}

	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}

	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}

	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}

	function addStyle(obj, options) {
		var styleElement, update, remove;

		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}

		update(obj);

		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}

	var replaceText = (function () {
		var textStore = [];

		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();

	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;

		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}

	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;

		if(media) {
			styleElement.setAttribute("media", media)
		}

		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}

	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;

		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}

		var blob = new Blob([css], { type: "text/css" });

		var oldSrc = linkElement.href;

		linkElement.href = URL.createObjectURL(blob);

		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var _hooks = __webpack_require__(2);

	var _Root = __webpack_require__(3);

	var CartItem = function CartItem(props) {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);
	  return (0, _preact.h)(
	    "div",
	    { className: "coca-d-flex coca-align-items-center coca-cowi-card coca-cowi-cart-item" },
	    (0, _preact.h)(
	      "div",
	      { className: "coca-cowi-product-image" },
	      (0, _preact.h)("img", { src: props.item.featured_image.url, alt: props.item.title })
	    ),
	    (0, _preact.h)(
	      "div",
	      { className: "coca-cowi-product-details coca-d-col" },
	      (0, _preact.h)(
	        "p",
	        null,
	        props.item.title.replace(/(.{25})..+/, "$1…")
	      ),
	      (0, _preact.h)(
	        "small",
	        null,
	        "Qty:",
	        (0, _preact.h)(
	          "b",
	          null,
	          " ",
	          props.item.quantity,
	          " "
	        )
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        " ",
	        (0, _preact.h)(
	          "span",
	          {
	            ref: function ref(node) {
	              if (node) node.style.setProperty("color", "" + globalContext.widgetConfig.commonConfig.bgEndColor, "important");
	            }
	          },
	          (0, _preact.h)(
	            "b",
	            null,
	            props.item.price / 100
	          )
	        ),
	        (0, _preact.h)(
	          "small",
	          null,
	          props.currency
	        )
	      )
	    )
	  );
	};

	exports.default = CartItem;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var _hooks = __webpack_require__(2);

	var _Root = __webpack_require__(3);

	var FeaturedStory = function FeaturedStory(props) {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);
	  return (0, _preact.h)(
	    "div",
	    {
	      onClick: function onClick() {
	        globalContext.viewStateHistory.goTo("story", props.item);
	      },
	      ref: function ref(node) {
	        if (node) node.style.setProperty("background-image", "url(" + props.item.images[0] + ")", "important");
	      },
	      className: "coca-d-flex coca-cowi-featured-story-card"
	    },
	    (0, _preact.h)("div", { className: "coca-cowi-featured-card-gradient-overlay" }),
	    (0, _preact.h)(
	      "div",
	      { className: "coca-cowi-featured-offer-text" },
	      props.item.title
	    )
	  );
	};

	exports.default = FeaturedStory;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var _hooks = __webpack_require__(2);

	var _Root = __webpack_require__(3);

	var _OfferIcon = __webpack_require__(21);

	var _OfferIcon2 = _interopRequireDefault(_OfferIcon);

	var _utilities = __webpack_require__(4);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var OfferItem = function OfferItem(props) {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);
	  var truncatedDescription = props.item.description.replace(/(.{60})..+/, "$1…");
	  return (0, _preact.h)(
	    "div",
	    { className: "coca-d-flex coca-align-items-center coca-cowi-card coca-cowi-offer-item" },
	    (0, _preact.h)(
	      "div",
	      {
	        onClick: function onClick() {
	          if (props.item.images.length !== 0) {
	            globalContext.viewStateHistory.goTo("story", props.item);
	          } else {
	            if (props.item.type !== "url") {
	              globalContext.viewStateHistory.goTo("offerView", props.item);
	            } else window.location.href = props.item.url;
	          }
	        },
	        ref: function ref(node) {
	          if (node) node.style.setProperty("background", "no-repeat center/100% " + (props.item.images.length !== 0 ? "url(" + props.item.images[0] + ")" : "radial-gradient(99.45% 99.14% at 1.91% 0.86%, rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0) 100%), " + globalContext.widgetConfig.commonConfig.bgEndColor), "important");
	        },
	        className: "coca-d-flex coca-align-items-center coca-justify-content-center coca-cowi-offer-thumbnail"
	      },
	      props.item.images.length === 0 && (0, _preact.h)(_OfferIcon2.default, {
	        selected: true,
	        color: (0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgEndColor)
	      })
	    ),
	    (0, _preact.h)(
	      "div",
	      { className: "coca-cowi-offer-details coca-d-col" },
	      (0, _preact.h)(
	        "p",
	        null,
	        (0, _preact.h)(
	          "b",
	          null,
	          props.item.title
	        )
	      ),
	      (0, _preact.h)(
	        "small",
	        null,
	        " ",
	        truncatedDescription
	      ),
	      (0, _preact.h)(
	        "div",
	        { className: "coca-d-flex coca-cowi-offer-actions" },
	        (0, _preact.h)(
	          "div",
	          { className: "coca-cowi-offer-action-button" },
	          (0, _preact.h)(
	            "small",
	            {
	              onClick: function onClick() {
	                if (props.item.type !== "url") {
	                  globalContext.viewStateHistory.goTo("offerView", props.item);
	                } else window.location.href = props.item.url;
	              },
	              ref: function ref(node) {
	                if (node) node.style.setProperty("color", " " + globalContext.widgetConfig.commonConfig.bgEndColor, "important");
	              }
	            },
	            (0, _preact.h)(
	              "b",
	              null,
	              "Know More"
	            )
	          )
	        )
	      )
	    )
	  );
	};

	exports.default = OfferItem;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var _hooks = __webpack_require__(2);

	var _Root = __webpack_require__(3);

	var _utilities = __webpack_require__(4);

	var CornerButton = function CornerButton(props) {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);

	  return (0, _preact.h)(
	    "div",
	    {
	      ref: function ref(node) {
	        if (node) {
	          node.style.setProperty("bottom", globalContext.widgetConfig.launcherConfig.cornerButton.verticalPositioning + "%", "important");
	        }
	      },
	      className: "coca-cowi-corner-button coca-d-flex coca-cowi-corner-button-align-" + globalContext.widgetConfig.commonConfig.alignment
	    },
	    (0, _preact.h)(
	      "div",
	      {
	        onClick: props.onClick,
	        className: "coca-cowi-corner-button-item coca-d-flex coca-justify-content-center coca-align-items-center coca-cowi-desktop-size-" + globalContext.widgetConfig.launcherConfig.cornerButton.size.desktop + " coca-cowi-mobile-size-" + globalContext.widgetConfig.launcherConfig.cornerButton.size.mobile + "  coca-cowi-corner-button-shape-" + globalContext.widgetConfig.launcherConfig.cornerButton.shape,
	        ref: function ref(node) {
	          if (node) {
	            node.style.setProperty("background", "" + globalContext.widgetConfig.commonConfig.bgEndColor, "important");
	          }
	        }
	      },
	      (0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgEndColor) === "light" ? (0, _preact.h)(
	        _preact.Fragment,
	        null,
	        (0, _preact.h)("img", {
	          className: "coca-cowi-launcher-icon",
	          src: "https://assets.cornercart.io/images/corner-widget/chat-selected-light.svg",
	          alt: "Cart"
	        }),
	        globalContext.widgetConfig.launcherConfig.cornerButton.text && (0, _preact.h)(
	          "p",
	          { className: "coca-text-white" },
	          globalContext.widgetConfig.launcherConfig.cornerButton.text
	        )
	      ) : (0, _preact.h)(
	        _preact.Fragment,
	        null,
	        (0, _preact.h)("img", {
	          className: "coca-cowi-launcher-icon",
	          src: "https://assets.cornercart.io/images/corner-widget/chat-selected-dark.svg",
	          alt: "Cart"
	        }),
	        globalContext.widgetConfig.launcherConfig.cornerButton.text && (0, _preact.h)(
	          "p",
	          { className: "coca-text-black" },
	          globalContext.widgetConfig.launcherConfig.cornerButton.text
	        )
	      )
	    )
	  );
	};

	exports.default = CornerButton;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var _hooks = __webpack_require__(2);

	var _Root = __webpack_require__(3);

	var _utilities = __webpack_require__(4);

	var SideTab = function SideTab(props) {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);

	  return (0, _preact.h)(
	    "div",
	    {
	      onClick: props.onClick,
	      className: "coca-cowi-side-tab coca-d-flex coca-cowi-side-tab-align-" + globalContext.widgetConfig.commonConfig.alignment,
	      ref: function ref(node) {
	        if (node) {
	          node.style.setProperty("bottom", globalContext.widgetConfig.launcherConfig.sideTab.verticalPositioning + "%", "important");
	          node.style.setProperty("background", "" + globalContext.widgetConfig.commonConfig.bgEndColor, "important");
	        }
	      }
	    },
	    (0, _preact.h)(
	      "div",
	      {
	        className: "coca-cowi-side-tab-text",
	        ref: function ref(node) {
	          if (node) {
	            node.style.setProperty("color", "" + ((0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgEndColor) === "light" ? "rgba(255,255,255,1)" : "rgba(0,0,0,.6)"), "important");
	          }
	        }
	      },
	      globalContext.widgetConfig.launcherConfig.sideTab.text
	    ),
	    (0, _preact.h)(
	      "div",
	      { className: "coca-cowi-side-tab-icon" },
	      (0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgEndColor) === "light" ? (0, _preact.h)("img", {
	        src: "https://assets.cornercart.io/images/corner-widget/chat-selected-light.svg",
	        alt: "Cart"
	      }) : (0, _preact.h)("img", {
	        className: "coca-cowi-side-tab-icon",
	        src: "https://assets.cornercart.io/images/corner-widget/chat-selected-dark.svg",
	        alt: "Cart"
	      })
	    )
	  );
	};

	exports.default = SideTab;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var _Root = __webpack_require__(3);

	var _hooks = __webpack_require__(2);

	var _CornerButton = __webpack_require__(55);

	var _CornerButton2 = _interopRequireDefault(_CornerButton);

	var _SideTab = __webpack_require__(56);

	var _SideTab2 = _interopRequireDefault(_SideTab);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var Launchers = function Launchers() {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);
	  var deviceType = window.innerWidth < 992 ? "mobile" : "desktop";

	  var isSideTabHidden = function isSideTabHidden() {
	    if (globalContext.pageType === "collection" && !globalContext.widgetConfig.launcherConfig.sideTab.visibility.showOnCollectionPage) return true;else if (globalContext.pageType === "product" && !globalContext.widgetConfig.launcherConfig.sideTab.visibility.showOnProductPage) return true;else if (deviceType === "mobile" && !globalContext.widgetConfig.launcherConfig.sideTab.visibility.mobile) return true;else if (deviceType === "desktop" && !globalContext.widgetConfig.launcherConfig.sideTab.visibility.desktop) return true;else return false;
	  };
	  var isCornerButtonHidden = function isCornerButtonHidden() {
	    if (globalContext.pageType === "collection" && !globalContext.widgetConfig.launcherConfig.cornerButton.visibility.showOnCollectionPage) return true;else if (globalContext.pageType === "product" && !globalContext.widgetConfig.launcherConfig.cornerButton.visibility.showOnProductPage) return true;else if (deviceType === "mobile" && !globalContext.widgetConfig.launcherConfig.cornerButton.visibility.mobile) return true;else if (deviceType === "desktop" && !globalContext.widgetConfig.launcherConfig.cornerButton.visibility.desktop) return true;else return false;
	  };

	  var renderLauncher = function renderLauncher() {
	    if (globalContext.widgetConfig.launcherConfig.launcherMaping.assistant === "cornerButton" && !isCornerButtonHidden()) return (0, _preact.h)(_CornerButton2.default, {
	      onClick: function onClick() {
	        globalContext.isCowiOpened.set(true);
	        if (window.externalOfcoTrigger) {
	          window.externalOfcoTrigger("closeOfco");
	          window.externalOfcoTrigger("hideOfco");
	        }
	      }
	    });else if (globalContext.widgetConfig.launcherConfig.launcherMaping.assistant === "sideTab" && !isSideTabHidden()) return (0, _preact.h)(_SideTab2.default, {
	      onClick: function onClick() {
	        if (globalContext.widgetConfig.launcherConfig.sideTab.onClick === "assistant") {
	          if (window.externalOfcoTrigger) {
	            window.externalOfcoTrigger("closeOfco");
	            window.externalOfcoTrigger("hideOfco");
	          }
	          globalContext.isCowiOpened.set(true);
	        } else window.location.href = "/a/" + globalContext.widgetConfig.faqConfig.appProxyUrl;
	      }
	    });
	  };

	  return (0, _preact.h)(
	    "div",
	    null,
	    globalContext.widgetConfig.launcherConfig && renderLauncher()
	  );
	};

	exports.default = Launchers;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var IncomeMessage = function IncomeMessage(props) {
	  return (0, _preact.h)(
	    "div",
	    { className: "coca-d-flex coca-cowi-income-chat-message" },
	    (0, _preact.h)(
	      "div",
	      { className: "coca-cowi-chat-message" },
	      (0, _preact.h)("span", { dangerouslySetInnerHTML: { __html: props.message } })
	    )
	  );
	};

	exports.default = IncomeMessage;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var _Root = __webpack_require__(3);

	var _hooks = __webpack_require__(2);

	var _utilities = __webpack_require__(4);

	var OutgoMessage = function OutgoMessage(props) {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);
	  return (0, _preact.h)(
	    "div",
	    { className: "coca-d-flex coca-cowi-outgo-chat-message" },
	    (0, _preact.h)(
	      "div",
	      {
	        ref: function ref(node) {
	          if (node) node.style.setProperty("background", "radial-gradient(99.45% 99.14% at 1.91% 0.86%, rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0) 100%), " + globalContext.widgetConfig.commonConfig.bgEndColor, "important");
	        },
	        className: "coca-cowi-chat-message"
	      },
	      (0, _preact.h)(
	        "p",
	        {
	          ref: function ref(node) {
	            if (node) node.style.setProperty("color", "" + ((0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgEndColor) === "light" ? "rgb(255,255,255)" : "rgba(0,0,0,.6)"), "important");
	          }
	        },
	        (0, _preact.h)("span", { dangerouslySetInnerHTML: { __html: props.message } })
	      )
	    )
	  );
	};
	exports.default = OutgoMessage;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var _hooks = __webpack_require__(2);

	var _IncomeMessage = __webpack_require__(58);

	var _IncomeMessage2 = _interopRequireDefault(_IncomeMessage);

	var _OutgoMessage = __webpack_require__(59);

	var _OutgoMessage2 = _interopRequireDefault(_OutgoMessage);

	var _Root = __webpack_require__(3);

	var _utilities = __webpack_require__(4);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var Chat = function Chat(props) {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);
	  var chatItem = globalContext.viewStateHistory.currentView.params;
	  return (0, _preact.h)(
	    "div",
	    { className: "coca-d-flex  coca-cowi-main-container" },
	    (0, _preact.h)(
	      "div",
	      { className: "coca-d-flex coca-align-items-center coca-cowi-title-header" },
	      (0, _preact.h)(
	        "div",
	        {
	          onClick: function onClick() {
	            globalContext.viewStateHistory.goTo("assistant", "");
	          },
	          className: "coca-cowi-header-icon coca-cowi-chat-back-button"
	        },
	        (0, _preact.h)(
	          "svg",
	          { width: "15", viewBox: "0 0 20 24", fill: "none" },
	          (0, _preact.h)("path", {
	            d: "M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97918 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.93934 10.9393ZM20 10.5L2 10.5L2 13.5L20 13.5L20 10.5Z",
	            fill: globalContext.widgetConfig.commonConfig.bgEndColor
	          })
	        )
	      ),
	      (0, _preact.h)(
	        "div",
	        { className: "coca-cowi-header-title" },
	        (0, _preact.h)(
	          "h2",
	          null,
	          "Quick Reads"
	        )
	      )
	    ),
	    (0, _preact.h)(
	      "div",
	      {
	        ref: function ref(node) {
	          if (node) node.style.setProperty("background", "linear-gradient(0deg, rgba(0, 0, 0, 0.02), rgba(0, 0, 0, 0.02)), " + (0, _utilities.rgbToRgba)(globalContext.widgetConfig.commonConfig.bgEndColor, 0.02), "important");
	        },
	        className: "coca-cowi-bg coca-d-col"
	      },
	      (0, _preact.h)(_OutgoMessage2.default, { message: chatItem.title }),
	      (0, _preact.h)(_IncomeMessage2.default, { message: chatItem.description })
	    )
	  );
	};

	exports.default = Chat;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var _hooks = __webpack_require__(2);

	var _Root = __webpack_require__(3);

	var FaqCategoryButton = function FaqCategoryButton(props) {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);
	  return (0, _preact.h)(
	    "a",
	    {
	      role: "presentation",
	      onClick: function onClick() {
	        return globalContext.viewStateHistory.goTo("faqList", {
	          category: props.categoryItem.categoryid
	        });
	      },
	      className: "coca-cowi-faq-category-btn-card coca-cowi-card coca-cowi-hover-card coca-text-center"
	    },
	    (0, _preact.h)(
	      "div",
	      { className: "coca-cowi-faq-category-btn-img" },
	      (0, _preact.h)("img", { src: props.categoryItem.icon_url, alt: "ss" })
	    ),
	    (0, _preact.h)(
	      "div",
	      { className: "coca-cowi-faq-category-btn-content" },
	      (0, _preact.h)(
	        "small",
	        null,
	        props.categoryItem.name
	      )
	    )
	  );
	};

	exports.default = FaqCategoryButton;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var _FaqCategoryButton = __webpack_require__(61);

	var _FaqCategoryButton2 = _interopRequireDefault(_FaqCategoryButton);

	var _hooks = __webpack_require__(2);

	var _Root = __webpack_require__(3);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var FaqCategories = function FaqCategories() {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);
	  var categoryList = globalContext.faqList.categories.flatMap(function (item) {
	    return item.show_in_widget ? [item] : [];
	  });
	  var renderCagtegories = function renderCagtegories() {
	    var categoryLimit = globalContext.featureFlag.supportCorner.category_count > 6 ? 6 : globalContext.featureFlag.supportCorner.category_count;
	    var sortedCategories = categoryList.sort(function (a, b) {
	      return a.position_rank - b.position_rank;
	    });
	    var visibleCategories = sortedCategories.length > categoryLimit ? sortedCategories.slice(0, categoryLimit) : sortedCategories;
	    return visibleCategories.map(function (item) {
	      return (0, _preact.h)(_FaqCategoryButton2.default, { categoryItem: item });
	    });
	  };

	  var viewAllUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + ("a/" + globalContext.widgetConfig.faqConfig.appProxyUrl) : "/a/" + globalContext.widgetConfig.faqConfig.appProxyUrl;

	  return (0, _preact.h)(
	    "div",
	    { className: "coca-cowi-faq-category-wrapper" },
	    (0, _preact.h)(
	      "h2",
	      { className: "coca-inner-title" },
	      globalContext.currentLanguage.assistant.category_cards_title ? globalContext.currentLanguage.assistant.category_cards_title : "Categories"
	    ),
	    (0, _preact.h)(
	      "div",
	      { className: "coca-d-flex coca-cowi-faq-category-btn-wrapper" },
	      categoryList && renderCagtegories()
	    ),
	    (0, _preact.h)(
	      "div",
	      { className: "coca-d-flex coca-justify-content-end" },
	      (0, _preact.h)(
	        "a",
	        { className: "coca-cowi-tiny-button", href: viewAllUrl },
	        (0, _preact.h)(
	          "small",
	          null,
	          globalContext.currentLanguage.assistant.view_in_faq ? globalContext.currentLanguage.assistant.view_in_faq : "View all"
	        )
	      )
	    )
	  );
	};

	exports.default = FaqCategories;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var _FaqCategories = __webpack_require__(62);

	var _FaqCategories2 = _interopRequireDefault(_FaqCategories);

	var _SearchBox = __webpack_require__(32);

	var _SearchBox2 = _interopRequireDefault(_SearchBox);

	var _Root = __webpack_require__(3);

	var _FaqItem = __webpack_require__(31);

	var _FaqItem2 = _interopRequireDefault(_FaqItem);

	var _hooks = __webpack_require__(2);

	var _utilities = __webpack_require__(4);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var AssistantHome = function AssistantHome() {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);

	  var _useState = (0, _hooks.useState)([]),
	      searchResults = _useState[0],
	      setSearchResults = _useState[1];

	  var _useState2 = (0, _hooks.useState)(false),
	      isSearchActive = _useState2[0],
	      setIsSearchActive = _useState2[1];

	  // list of categories which has show_in_widget value true

	  var categoryList = globalContext.faqList.categories.flatMap(function (item) {
	    return item.show_in_widget ? [item] : [];
	  });
	  // creating a new array with only the faqitems which is inside categories which has show_in_widget value true
	  var allowedFaqList = globalContext.faqList.articles.flatMap(function (item) {
	    return categoryList.map(function (c) {
	      return c.categoryid;
	    }).includes(item.categoryid) ? [item] : [];
	  });

	  var contactOptions = globalContext.widgetConfig.commonConfig.contextConfigs.assistant.contactOptions;

	  var findCategoryPosition = function findCategoryPosition(articleItem) {
	    if (articleItem.categoryid) {
	      var currentCategory = categoryList.find(function (item) {
	        return item.categoryid === articleItem.categoryid;
	      });
	      return currentCategory.position_rank;
	    } else return -1;
	  };

	  var featuredFaqList = allowedFaqList.flatMap(function (item) {
	    return item.is_featured ? [item] : [];
	  });

	  var arrangedFeaturedFaqList = featuredFaqList.sort(function (a, b) {
	    return a.position_rank + findCategoryPosition(a) * 10 - (b.position_rank + findCategoryPosition(b) * 10);
	  });
	  var renderFeaturedFaqs = function renderFeaturedFaqs() {
	    return (0, _preact.h)(
	      "div",
	      null,
	      (0, _preact.h)(
	        "h2",
	        { className: "coca-inner-title" },
	        globalContext.currentLanguage.assistant.featured_faq_title ? globalContext.currentLanguage.assistant.featured_faq_title : "Featured FAQs"
	      ),
	      arrangedFeaturedFaqList.map(function (item) {
	        return (0, _preact.h)(_FaqItem2.default, { faqItem: item });
	      })
	    );
	  };

	  var renderSearchResult = function renderSearchResult() {
	    return (0, _preact.h)(
	      "div",
	      null,
	      (0, _preact.h)(
	        "h2",
	        { className: "coca-inner-title" },
	        globalContext.currentLanguage.assistant.search_results_title ? globalContext.currentLanguage.assistant.search_results_title : "Search Results"
	      ),
	      searchResults.length > 0 ? searchResults.map(function (result) {
	        return (0, _preact.h)(_FaqItem2.default, { faqItem: result.item });
	      }) : (0, _preact.h)(
	        "div",
	        { className: "coca-cowi-empty-state  coca-text-center " },
	        (0, _preact.h)("img", {
	          src: "https://assets.cornercart.io/images/corner-widget/empty-state-faq.svg",
	          alt: ""
	        }),
	        (0, _preact.h)("br", null),
	        (0, _preact.h)(
	          "p",
	          null,
	          globalContext.currentLanguage.assistant.search_empty_result ? globalContext.currentLanguage.assistant.search_empty_result : "No articles found"
	        )
	      )
	    );
	  };
	  return (0, _preact.h)(
	    "div",
	    { className: "coca-d-flex coca-cowi-assitant" },
	    (0, _preact.h)(
	      "div",
	      { className: "coca-cowi-assistant-title-header" },
	      (0, _preact.h)(
	        "div",
	        { className: "coca-cowi-assistant-title-content" },
	        (0, _preact.h)(
	          "div",
	          { className: "coca-cowi-assistant-title-emoji" },
	          globalContext.widgetConfig.commonConfig.contextConfigs.assistant.introEmoji
	        ),
	        (0, _preact.h)(
	          "h1",
	          { className: "" },
	          (0, _preact.h)(
	            "b",
	            null,
	            globalContext.currentLanguage.assistant.welcome_text ? globalContext.currentLanguage.assistant.welcome_text : "Hi there, how  may I help you?"
	          )
	        )
	      ),
	      globalContext.featureFlag.supportCorner.articles_search_enabled && globalContext.widgetConfig.commonConfig.contextConfigs.assistant.search && (0, _preact.h)(_SearchBox2.default, {
	        onSearch: function onSearch(event) {
	          setSearchResults(event.searchResult);
	          setIsSearchActive(event.isSearchActive);
	        }
	      }),
	      contactOptions.email.length + contactOptions.sms.length + contactOptions.whatsapp.length + contactOptions.messenger.length > 0 && (0, _preact.h)(
	        "div",
	        { className: "coca-cowi-contact-options coca-d-flex coca-align-items-center" },
	        (0, _preact.h)(
	          "small",
	          { className: "coca-cowi-contact-label" },
	          globalContext.currentLanguage.assistant.contact_us_label ? globalContext.currentLanguage.assistant.contact_us_label : "Contact Us"
	        ),
	        globalContext.featureFlag.supportCorner.contact_options.email && contactOptions.email.length > 0 && (0, _preact.h)(
	          "a",
	          {
	            className: "coca-cowi-contact-icon coca-cowi-mail-icon",
	            href: "mailto:" + contactOptions.email
	          },
	          (0, _preact.h)("img", {
	            src: "https://assets.cornercart.io/coca-v2/images/contact-icons/mail.svg",
	            alt: ""
	          })
	        ),
	        globalContext.featureFlag.supportCorner.contact_options.whatsapp && contactOptions.whatsapp.length > 0 && (0, _preact.h)(
	          "a",
	          {
	            className: "coca-cowi-contact-icon coca-cowi-wa-icon",
	            target: "_blank",
	            href: "https://wa.me/" + contactOptions.whatsapp
	          },
	          (0, _preact.h)("img", {
	            src: "https://assets.cornercart.io/coca-v2/images/contact-icons/wa.svg",
	            alt: ""
	          })
	        ),
	        globalContext.featureFlag.supportCorner.contact_options.messenger && contactOptions.messenger.length > 0 && (0, _preact.h)(
	          "a",
	          {
	            className: "coca-cowi-contact-icon coca-cowi-me-icon",
	            target: "_blank",
	            href: "" + contactOptions.messenger
	          },
	          (0, _preact.h)("img", {
	            src: "https://assets.cornercart.io/coca-v2/images/contact-icons/me.svg",
	            alt: ""
	          })
	        ),
	        globalContext.featureFlag.supportCorner.contact_options.sms && contactOptions.sms.length > 0 && (0, _preact.h)(
	          "a",
	          {
	            className: "coca-cowi-contact-icon coca-cowi-sms-icon",
	            target: "_blank",
	            href: "sms:" + contactOptions.sms
	          },
	          (0, _preact.h)("img", {
	            src: "https://assets.cornercart.io/coca-v2/images/contact-icons/sms.svg",
	            alt: ""
	          })
	        )
	      )
	    ),
	    (0, _preact.h)(
	      "div",
	      {
	        ref: function ref(node) {
	          if (node) node.style.setProperty("background", "linear-gradient(0deg, rgba(0, 0, 0, 0.02), rgba(0, 0, 0, 0.02)), " + (0, _utilities.rgbToRgba)(globalContext.widgetConfig.commonConfig.bgEndColor, 0.02), "important");
	        },
	        className: "coca-cowi-bg coca-d-col"
	      },
	      isSearchActive ? renderSearchResult() : (0, _preact.h)(
	        "div",
	        null,
	        categoryList && categoryList.length > 0 && (0, _preact.h)(_FaqCategories2.default, null),
	        arrangedFeaturedFaqList && arrangedFeaturedFaqList.length > 0 && renderFeaturedFaqs()
	      )
	    )
	  );
	};

	exports.default = AssistantHome;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _hooks = __webpack_require__(2);

	var _preact = __webpack_require__(1);

	var _Root = __webpack_require__(3);

	var _FaqItem = __webpack_require__(31);

	var _FaqItem2 = _interopRequireDefault(_FaqItem);

	var _SearchBox = __webpack_require__(32);

	var _SearchBox2 = _interopRequireDefault(_SearchBox);

	var _utilities = __webpack_require__(4);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var FaqList = function FaqList() {
	  var _useState = (0, _hooks.useState)([]),
	      searchResults = _useState[0],
	      setSearchResults = _useState[1];

	  var _useState2 = (0, _hooks.useState)(false),
	      isSearchActive = _useState2[0],
	      setIsSearchActive = _useState2[1];

	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);
	  // creating a new array with only the faqitems which is equal to the category id mentioned in currentView.params
	  var currentFaqList = globalContext.faqList.articles.flatMap(function (item) {
	    return globalContext.viewStateHistory.currentView.params.category === item.categoryid ? [item] : [];
	  }).sort(function (a, b) {
	    return a.position_rank - b.position_rank;
	  }).slice(0, globalContext.featureFlag.supportCorner.articles_per_category);

	  var findCategory = function findCategory() {
	    var currentCategory = globalContext.faqList.categories.find(function (item) {
	      return item.categoryid === globalContext.viewStateHistory.currentView.params.category;
	    });
	    return currentCategory;
	  };

	  var renderSearchResult = function renderSearchResult() {
	    return (0, _preact.h)(
	      "div",
	      null,
	      (0, _preact.h)(
	        "h2",
	        { className: "coca-inner-title" },
	        globalContext.currentLanguage.assistant.search_results_title ? globalContext.currentLanguage.assistant.search_results_title : "Search Results"
	      ),
	      searchResults.length > 0 ? searchResults.map(function (result) {
	        return (0, _preact.h)(_FaqItem2.default, { faqItem: result.item });
	      }) : (0, _preact.h)(
	        "div",
	        { className: "coca-cowi-empty-state  coca-text-center " },
	        (0, _preact.h)("img", {
	          src: "https://assets.cornercart.io/images/corner-widget/empty-state-faq.svg",
	          alt: ""
	        }),
	        (0, _preact.h)("br", null),
	        (0, _preact.h)(
	          "p",
	          null,
	          globalContext.currentLanguage.assistant.search_results_title ? globalContext.currentLanguage.assistant.search_results_title : "No articles found"
	        )
	      )
	    );
	  };

	  return (0, _preact.h)(
	    "div",
	    { className: "coca-d-flex coca-cowi-main-container" },
	    (0, _preact.h)(
	      "div",
	      { className: "coca-cowi-assistant-title-header" },
	      (0, _preact.h)(
	        "div",
	        { className: "coca-d-flex" },
	        (0, _preact.h)(
	          "div",
	          {
	            onClick: function onClick() {
	              globalContext.viewStateHistory.goTo("assistant", "");
	            },
	            className: "coca-cowi-header-icon coca-cowi-chat-back-button"
	          },
	          (0, _preact.h)(
	            "svg",
	            { width: "15", viewBox: "0 0 20 24", fill: "none" },
	            (0, _preact.h)("path", {
	              d: "M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97918 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.93934 10.9393ZM20 10.5L2 10.5L2 13.5L20 13.5L20 10.5Z",
	              fill: "black"
	            })
	          )
	        ),
	        (0, _preact.h)(
	          "h2",
	          { className: "coca-text-center coca-d-col" },
	          (0, _preact.h)(
	            "b",
	            null,
	            isSearchActive ? (0, _preact.h)(
	              "span",
	              null,
	              globalContext.currentLanguage.assistant.search_results_title ? globalContext.currentLanguage.assistant.search_results_title : "Search Results"
	            ) : findCategory().name
	          )
	        )
	      ),
	      globalContext.featureFlag.supportCorner.articles_search_enabled && globalContext.widgetConfig.commonConfig.contextConfigs.assistant.search && (0, _preact.h)(_SearchBox2.default, {
	        onSearch: function onSearch(event) {
	          setSearchResults(event.searchResult);
	          setIsSearchActive(event.isSearchActive);
	        }
	      })
	    ),
	    (0, _preact.h)(
	      "div",
	      {
	        ref: function ref(node) {
	          if (node) node.style.setProperty("background", "linear-gradient(0deg, rgba(0, 0, 0, 0.02), rgba(0, 0, 0, 0.02)), " + (0, _utilities.rgbToRgba)(globalContext.widgetConfig.commonConfig.bgEndColor, 0.02), "important");
	        },
	        className: "coca-cowi-bg coca-d-col"
	      },
	      isSearchActive ? renderSearchResult() : (0, _preact.h)(
	        "div",
	        null,
	        currentFaqList !== null && currentFaqList.length > 0 ? (0, _preact.h)(
	          _preact.Fragment,
	          null,
	          currentFaqList.map(function (item) {
	            return (0, _preact.h)(_FaqItem2.default, { faqItem: item });
	          })
	        ) : (0, _preact.h)(
	          "div",
	          { className: "coca-cowi-empty-state coca-d-flex coca-text-center coca-justify-content-center" },
	          (0, _preact.h)(
	            "div",
	            null,
	            (0, _preact.h)("img", {
	              src: "https://assets.cornercart.io/images/corner-widget/empty-state-faq.svg",
	              alt: ""
	            }),
	            (0, _preact.h)("br", null),
	            (0, _preact.h)(
	              "small",
	              null,
	              "No articles found :("
	            )
	          )
	        )
	      )
	    )
	  );
	};

	exports.default = FaqList;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _hooks = __webpack_require__(2);

	var _preact = __webpack_require__(1);

	var _Root = __webpack_require__(3);

	var _utilities = __webpack_require__(4);

	var FaqView = function FaqView() {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);
	  var faqList = globalContext.faqList.articles;
	  var currentFaq = faqList.find(function (item) {
	    return item.id === globalContext.viewStateHistory.currentView.params.faqId;
	  });

	  var findCategory = function findCategory() {
	    if (currentFaq.categoryid) {
	      var categoryList = globalContext.faqList.categories;
	      var currentCategory = categoryList.find(function (item) {
	        return item.categoryid === currentFaq.categoryid;
	      });
	      return currentCategory;
	    } else return "";
	  };

	  return (0, _preact.h)(
	    "div",
	    { className: "coca-d-flex coca-cowi-main-container" },
	    (0, _preact.h)(
	      "div",
	      {
	        ref: function ref(node) {
	          if (node) node.style.setProperty("background", "linear-gradient(0deg, rgba(0, 0, 0, 0.02), rgba(0, 0, 0, 0.02)), " + (0, _utilities.rgbToRgba)(globalContext.widgetConfig.commonConfig.bgEndColor, 0.02), "important");
	        },
	        className: "coca-cowi-title-header"
	      },
	      (0, _preact.h)(
	        "div",
	        {
	          onClick: function onClick() {
	            globalContext.viewStateHistory.goBack();
	          },
	          className: "coca-cowi-header-icon coca-cowi-chat-back-button"
	        },
	        (0, _preact.h)(
	          "svg",
	          { width: "15", viewBox: "0 0 20 24", fill: "none" },
	          (0, _preact.h)("path", {
	            d: "M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97918 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.93934 10.9393ZM20 10.5L2 10.5L2 13.5L20 13.5L20 10.5Z",
	            fill: "black"
	          })
	        )
	      ),
	      (0, _preact.h)(
	        "div",
	        { className: "coca-my-2 " },
	        (0, _preact.h)(
	          "h1",
	          null,
	          currentFaq.title
	        )
	      ),
	      (0, _preact.h)(
	        "div",
	        { className: "coca-d-flex coca-align-items-center coca-justify-content-between" },
	        (0, _preact.h)(
	          "div",
	          { className: "coca-d-flex coca-align-items-center" },
	          (0, _preact.h)(
	            "div",
	            { className: "coca-cowi-faq-view-category-image" },
	            (0, _preact.h)("img", { src: findCategory().icon_url, alt: "" })
	          ),
	          (0, _preact.h)(
	            "small",
	            null,
	            findCategory().name
	          )
	        )
	      )
	    ),
	    (0, _preact.h)(
	      "div",
	      { className: "coca-cowi-bg coca-d-col" },
	      (0, _preact.h)(
	        "div",
	        { className: "coca-mt-2 coca-widget-faq-view" },
	        (0, _preact.h)("span", { dangerouslySetInnerHTML: { __html: currentFaq.body } })
	      )
	    )
	  );
	};

	exports.default = FaqView;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _hooks = __webpack_require__(2);

	var _preact = __webpack_require__(1);

	var _Root = __webpack_require__(3);

	var _CartIcon = __webpack_require__(34);

	var _CartIcon2 = _interopRequireDefault(_CartIcon);

	var _CartItem = __webpack_require__(52);

	var _CartItem2 = _interopRequireDefault(_CartItem);

	var _utilities = __webpack_require__(4);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var CartHome = function CartHome(props) {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);
	  var cartInfo = globalContext.cartInfo.get;

	  return (0, _preact.h)(
	    "div",
	    { className: "coca-d-flex coca-cowi-main-container" },
	    (0, _preact.h)(
	      "div",
	      { className: "coca-d-flex coca-align-items-center coca-cowi-title-header" },
	      (0, _preact.h)(
	        "div",
	        { className: "coca-d-flex" },
	        (0, _preact.h)(
	          "div",
	          { className: "coca-cowi-header-icon" },
	          (0, _preact.h)(_CartIcon2.default, {
	            color: globalContext.widgetConfig.commonConfig.bgEndColor,
	            selected: true
	          })
	        ),
	        (0, _preact.h)(
	          "div",
	          { className: "coca-cowi-header-title" },
	          (0, _preact.h)(
	            "h2",
	            null,
	            " Cart"
	          )
	        )
	      )
	    ),
	    (0, _preact.h)(
	      "div",
	      {
	        ref: function ref(node) {
	          if (node) node.style.setProperty("background", "linear-gradient(0deg, rgba(0, 0, 0, 0.02), rgba(0, 0, 0, 0.02)), " + (0, _utilities.rgbToRgba)(globalContext.widgetConfig.commonConfig.bgEndColor, 0.02), "important");
	        },
	        className: "coca-cowi-bg coca-d-col"
	      },
	      cartInfo !== null && cartInfo.items.length > 0 ? (0, _preact.h)(
	        _preact.Fragment,
	        null,
	        cartInfo.items.map(function (item) {
	          return (0, _preact.h)(_CartItem2.default, { item: item, currency: cartInfo.currency });
	        }),
	        (0, _preact.h)(
	          "div",
	          { className: "coca-d-flex coca-justify-content-center" },
	          (0, _preact.h)(
	            "div",
	            {
	              onClick: function onClick() {
	                return window.location.href = "https://" + globalContext.storeName + "/cart";
	              },
	              className: "coca-cowi-tiny-button coca-cowi-edit-cart-button coca-d-flex coca-align-items-center"
	            },
	            (0, _preact.h)("img", {
	              className: "coca-cowi-tiny-button-icon",
	              src: "https://img.icons8.com/android/14/7d7d7d/edit.png"
	            }),
	            (0, _preact.h)(
	              "small",
	              null,
	              "Edit Cart"
	            )
	          )
	        )
	      ) : (0, _preact.h)(
	        "div",
	        { className: "coca-cowi-empty-state coca-d-flex coca-text-center coca-justify-content-center" },
	        (0, _preact.h)(
	          "div",
	          null,
	          (0, _preact.h)("img", {
	            src: "https://assets.cornercart.io/images/corner-widget/empty-state-cart.svg",
	            alt: ""
	          }),
	          (0, _preact.h)("br", null),
	          (0, _preact.h)(
	            "small",
	            null,
	            "Your cart is empty :("
	          )
	        )
	      )
	    ),
	    (0, _preact.h)(
	      "div",
	      { className: "coca-cowi-checkout-container " },
	      globalContext.offersList.length !== 0 && globalContext.widgetStyle === "advancedCart" && (0, _preact.h)(
	        "div",
	        { className: "coca-d-flex coca-justify-content-center" },
	        (0, _preact.h)(
	          "div",
	          {
	            className: "coca-cowi-tiny-button coca-cowi-cart-offer-button coca-d-flex coca-align-items-center",
	            onClick: function onClick() {
	              globalContext.viewStateHistory.goTo("offers", "");
	            }
	          },
	          (0, _preact.h)("img", {
	            className: "coca-cowi-tiny-button-icon",
	            src: "https://img.icons8.com/material/17/FF960E/redeem--v1.png"
	          }),
	          (0, _preact.h)(
	            "small",
	            null,
	            globalContext.offersList.length,
	            globalContext.offersList.length > 1 ? "offers" : "offer",
	            " ",
	            "available"
	          )
	        )
	      ),
	      (0, _preact.h)(
	        "div",
	        { className: " coca-d-flex coca-align-items-center" },
	        (0, _preact.h)(
	          "div",
	          { className: "coca-cowi-total coca-d-col" },
	          (0, _preact.h)(
	            "small",
	            null,
	            " Total"
	          ),
	          (0, _preact.h)(
	            "h2",
	            null,
	            (0, _preact.h)(
	              "b",
	              null,
	              cartInfo ? cartInfo.total_price / 100 + " " + cartInfo.currency : "0$",
	              " "
	            )
	          )
	        ),
	        (0, _preact.h)(
	          "div",
	          {
	            onClick: function onClick() {
	              return window.location.href = "https://" + globalContext.storeName + "/checkout";
	            },
	            ref: function ref(node) {
	              if (node) node.style.setProperty("background", "radial-gradient(99.45% 99.14% at 1.91% 0.86%, rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0) 100%), " + globalContext.widgetConfig.commonConfig.bgEndColor, "important");
	            },
	            className: "coca-cowi-checkout-button coca-d-flex  "
	          },
	          (0, _preact.h)(
	            "svg",
	            { width: "17", height: "17", viewBox: "0 0 17 17" },
	            (0, _preact.h)("path", {
	              d: "M6.51644 16.2909L16.291 6.51636L13.8017 4.02702L6.59444 11.2343L2.56739 7.20722L5.61893e-05 9.77455L6.51644 16.2909Z",
	              fill: (0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgEndColor) === "light" ? "rgba(255,255,255,1)" : "rgba(0,0,0,.6)"
	            })
	          ),
	          (0, _preact.h)(
	            "p",
	            {
	              ref: function ref(node) {
	                if (node) node.style.setProperty("color", "" + ((0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgEndColor) === "light" ? "rgba(255,255,255,1)" : "rgba(0,0,0,.6)"), "important");
	              }
	            },
	            (0, _preact.h)(
	              "b",
	              null,
	              "Checkout"
	            )
	          )
	        )
	      )
	    )
	  );
	};

	exports.default = CartHome;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var _hooks = __webpack_require__(2);

	var _Root = __webpack_require__(3);

	var _utilities = __webpack_require__(4);

	var OfferView = function OfferView(props) {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);
	  var offerItem = globalContext.viewStateHistory.currentView.params;
	  return (0, _preact.h)(
	    "div",
	    { className: "coca-d-flex coca-cowi-main-container" },
	    (0, _preact.h)(
	      "div",
	      { className: "coca-d-flex coca-align-items-center coca-cowi-title-header" },
	      (0, _preact.h)(
	        "div",
	        {
	          onClick: function onClick() {
	            globalContext.viewStateHistory.goBack();
	          },
	          className: "coca-cowi-header-icon coca-cowi-chat-back-button"
	        },
	        (0, _preact.h)(
	          "svg",
	          { width: "15", height: "18", viewBox: "0 0 20 24", fill: "none" },
	          (0, _preact.h)("path", {
	            d: "M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97918 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.93934 10.9393ZM20 10.5L2 10.5L2 13.5L20 13.5L20 10.5Z",
	            fill: globalContext.widgetConfig.commonConfig.bgEndColor
	          })
	        )
	      ),
	      (0, _preact.h)(
	        "div",
	        { className: "coca-cowi-header-title" },
	        (0, _preact.h)(
	          "h2",
	          null,
	          offerItem.title
	        )
	      )
	    ),
	    (0, _preact.h)(
	      "div",
	      {
	        ref: function ref(node) {
	          if (node) node.style.setProperty("background", "linear-gradient(0deg, rgba(0, 0, 0, 0.02), rgba(0, 0, 0, 0.02)), " + (0, _utilities.rgbToRgba)(globalContext.widgetConfig.commonConfig.bgEndColor, 0.02), "important");
	        },
	        className: "coca-cowi-bg coca-d-col coca-text-center "
	      },
	      (0, _preact.h)(
	        _preact.Fragment,
	        null,
	        (0, _preact.h)(
	          "div",
	          { className: "coca-cowi-offer-container coca-d-flex coca-justify-content-center" },
	          (0, _preact.h)(
	            "div",
	            { className: "coca-cowi-card coca-cowi-offer-card" },
	            (0, _preact.h)(
	              "div",
	              null,
	              (0, _preact.h)("img", {
	                className: "coca-offer-item-img",
	                src: "https://assets.cornercart.io/images/corner-widget/offer-item.svg",
	                alt: "Cart",
	                width: "40px"
	              })
	            ),
	            (0, _preact.h)(
	              "small",
	              null,
	              " Coupon Code"
	            ),
	            (0, _preact.h)(
	              "div",
	              {
	                ref: function ref(node) {
	                  if (node) node.style.setProperty("color", "" + globalContext.widgetConfig.commonConfig.bgEndColor, "important");
	                },
	                className: "coca-cowi-offer-code"
	              },
	              (0, _preact.h)(
	                "b",
	                null,
	                offerItem.code
	              )
	            ),
	            (0, _preact.h)(
	              "div",
	              { className: "coca-cowi-offer-action-button" },
	              (0, _preact.h)(
	                "small",
	                null,
	                " Copy coupon code"
	              )
	            )
	          )
	        ),
	        (0, _preact.h)(
	          "div",
	          { className: "coca-cowi-offer-expanded" },
	          " ",
	          (0, _preact.h)(
	            "h2",
	            null,
	            offerItem.title
	          ),
	          (0, _preact.h)(
	            "small",
	            null,
	            offerItem.description
	          ),
	          (0, _preact.h)(
	            "div",
	            { className: "coca-cowi-offer-specifics" },
	            (0, _preact.h)(
	              "small",
	              null,
	              "Valid Upto :",
	              " ",
	              (0, _preact.h)(
	                "b",
	                null,
	                new Date(offerItem.endsAt).toLocaleDateString()
	              )
	            )
	          )
	        ),
	        (0, _preact.h)(
	          "div",
	          { className: "coca-cowi-offer-buttons coca-d-flex coca-text-center coca-justify-content-center" },
	          (0, _preact.h)(
	            "div",
	            {
	              onClick: function onClick() {
	                globalContext.viewStateHistory.goTo("story", offerItem);
	              },
	              className: "coca-cowi-big-button",
	              ref: function ref(node) {
	                if (node) node.style.setProperty("background", "radial-gradient(99.45% 99.14% at 1.91% 0.86%, rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0) 100%), " + globalContext.widgetConfig.commonConfig.bgEndColor, "important");
	              }
	            },
	            (0, _preact.h)(
	              "span",
	              {
	                ref: function ref(node) {
	                  if (node) node.style.setProperty("color", "" + ((0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgEndColor) === "light" ? "rgba(255,255,255,1)" : "rgba(0,0,0,.6)"), "important");
	                }
	              },
	              " ",
	              "View Offer Story",
	              " "
	            )
	          )
	        )
	      )
	    )
	  );
	};

	exports.default = OfferView;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var _OfferIcon = __webpack_require__(21);

	var _OfferIcon2 = _interopRequireDefault(_OfferIcon);

	var _OfferItem = __webpack_require__(54);

	var _OfferItem2 = _interopRequireDefault(_OfferItem);

	var _FeaturedStory = __webpack_require__(53);

	var _FeaturedStory2 = _interopRequireDefault(_FeaturedStory);

	var _Root = __webpack_require__(3);

	var _hooks = __webpack_require__(2);

	var _utilities = __webpack_require__(4);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var OffersHome = function OffersHome(props) {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);

	  var featuredStories = globalContext.offersList.filter(function (item) {
	    if (item.featured === true) return item;
	  });

	  return (0, _preact.h)(
	    "div",
	    { className: "coca-d-flex coca-cowi-main-container" },
	    globalContext.offersList && featuredStories.length > 0 ? (0, _preact.h)(
	      "div",
	      { className: "coca-cowi-story-container" },
	      (0, _preact.h)(
	        "h2",
	        null,
	        "Featured Offer Stories"
	      ),
	      (0, _preact.h)(
	        "div",
	        { className: "coca-cowi-story-scroll-container" },
	        featuredStories.map(function (item) {
	          return (0, _preact.h)(_FeaturedStory2.default, { item: item });
	        })
	      )
	    ) : (0, _preact.h)(
	      "div",
	      { className: "coca-d-flex coca-align-items-center coca-cowi-title-header" },
	      (0, _preact.h)(
	        "div",
	        { className: "coca-cowi-header-icon" },
	        (0, _preact.h)(_OfferIcon2.default, {
	          color: globalContext.widgetConfig.commonConfig.bgEndColor,
	          selected: true
	        })
	      ),
	      (0, _preact.h)(
	        "div",
	        { className: "coca-cowi-header-title" },
	        (0, _preact.h)(
	          "h2",
	          null,
	          "Offers"
	        )
	      )
	    ),
	    (0, _preact.h)(
	      "div",
	      {
	        ref: function ref(node) {
	          if (node) node.style.setProperty("background", "linear-gradient(0deg, rgba(0, 0, 0, 0.02), rgba(0, 0, 0, 0.02)), " + (0, _utilities.rgbToRgba)(globalContext.widgetConfig.commonConfig.bgEndColor, 0.02), "important");
	        },
	        className: "coca-cowi-bg coca-d-col"
	      },
	      globalContext.offersList.length === 0 && (0, _preact.h)(
	        "div",
	        { className: "coca-cowi-empty-state coca-d-flex coca-text-center coca-justify-content-center" },
	        (0, _preact.h)(
	          "div",
	          null,
	          (0, _preact.h)("img", {
	            src: "https://assets.cornercart.io/images/corner-widget/empty-state-offers.svg",
	            alt: ""
	          }),
	          (0, _preact.h)("br", null),
	          (0, _preact.h)(
	            "small",
	            null,
	            "No Active Offers are available right now :("
	          )
	        )
	      ),
	      globalContext.offersList.map(function (item) {
	        return (0, _preact.h)(_OfferItem2.default, { item: item });
	      })
	    )
	  );
	};

	exports.default = OffersHome;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var _CloseButton = __webpack_require__(33);

	var _CloseButton2 = _interopRequireDefault(_CloseButton);

	var _hooks = __webpack_require__(2);

	var _Root = __webpack_require__(3);

	var _reactInstaStories = __webpack_require__(121);

	var _reactInstaStories2 = _interopRequireDefault(_reactInstaStories);

	var _utilities = __webpack_require__(4);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var StoryView = function StoryView(props) {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);
	  var storyImages = globalContext.viewStateHistory.currentView.params.images;

	  var _useState = (0, _hooks.useState)(false),
	      storyEnd = _useState[0],
	      setStoryEnd = _useState[1];

	  var _useState2 = (0, _hooks.useState)(false),
	      imageLoaded = _useState2[0],
	      setImageLoaded = _useState2[1];

	  var convertToObject = function convertToObject(imageUrl) {
	    return {
	      content: function content(_ref) {
	        var action = _ref.action,
	            isPaused = _ref.isPaused;

	        action(imageLoaded ? "play" : "pause");
	        var handleImageLoad = function handleImageLoad() {
	          return setImageLoaded(true);
	        };
	        var handleClick = function handleClick(e) {
	          e.preventDefault();
	          action(isPaused ? "play" : "pause");
	        };
	        return (0, _preact.h)(
	          "div",
	          {
	            className: "coca-d-flex coca-story-wrapper coca-align-items-center coca-justify-content-center",
	            onClick: handleClick,
	            role: "presentation"
	          },
	          (0, _preact.h)("img", { src: imageUrl, alt: "", onLoad: handleImageLoad }),
	          !imageLoaded && (0, _preact.h)("div", { className: "coca-cowi-story-loader" })
	        );
	      }
	    };
	  };

	  var emptyStory = [{
	    content: function content(_ref2) {
	      var action = _ref2.action,
	          isPaused = _ref2.isPaused;

	      var handleClick = function handleClick(e) {
	        e.preventDefault();
	        action(isPaused ? "play" : "pause");
	      };
	      return (0, _preact.h)(
	        "div",
	        {
	          className: "coca-d-flex coca-story-wrapper coca-align-items-center coca-justify-content-center",
	          onClick: handleClick,
	          ref: function ref(node) {
	            if (node) node.style.setProperty("background", "radial-gradient(99.45% 99.14% at 1.91% 0.86%, rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0) 100%), " + globalContext.widgetConfig.commonConfig.bgEndColor, "important");
	          }
	        },
	        (0, _preact.h)(
	          "h1",
	          {
	            ref: function ref(node) {
	              if (node) node.style.setProperty("color", "" + ((0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgEndColor) === "light" ? "rgba(255,255,255,1)" : "rgba(0,0,0,.6)"), "important");
	            }
	          },
	          (0, _preact.h)(
	            "b",
	            null,
	            globalContext.viewStateHistory.currentView.params.title
	          )
	        )
	      );
	    }
	  }];

	  var storyObject = storyImages.length > 0 ? storyImages.map(function (imageUrl) {
	    return convertToObject(imageUrl);
	  }) : emptyStory;

	  return (0, _preact.h)(
	    "div",
	    { className: "coca-cowi-story-view coca-d-flex" },
	    (0, _preact.h)(_reactInstaStories2.default, {
	      stories: storyObject,
	      defaultInterval: 3500,
	      loader: (0, _preact.h)("div", null),
	      onAllStoriesEnd: function onAllStoriesEnd() {
	        return setStoryEnd(true);
	      },
	      onStoryEnd: function onStoryEnd() {
	        return setImageLoaded(false);
	      }
	    }),
	    (0, _preact.h)(
	      "div",
	      {
	        onClick: function onClick() {
	          globalContext.viewStateHistory.goTo("offers", "");
	        },
	        className: "coca-cowi-story-close-button"
	      },
	      (0, _preact.h)(_CloseButton2.default, { customFill: "rgb(255,255,255)" })
	    ),
	    (0, _preact.h)(
	      "div",
	      {
	        onClick: function onClick() {
	          if (globalContext.viewStateHistory.currentView.params.type !== "url") {
	            globalContext.viewStateHistory.goTo("offerView", globalContext.viewStateHistory.currentView.params);
	          } else window.location.href = globalContext.viewStateHistory.currentView.params.url;
	        },
	        className: "coca-cowi-story-know-more-button coca-d-flex coca-justify-content-center"
	      },
	      (0, _preact.h)(
	        "span",
	        null,
	        "Know More"
	      )
	    ),
	    storyEnd && (0, _preact.h)(
	      "div",
	      { className: "coca-end-story-state coca-d-flex coca-justify-content-center" },
	      (0, _preact.h)(
	        "div",
	        { className: "coca-cowi-story-end-card coca-cowi-card coca-text-center" },
	        (0, _preact.h)(
	          "div",
	          {
	            onClick: function onClick() {
	              return setStoryEnd(false);
	            },
	            className: "coca-cowi-end-state-close coca-d-flex"
	          },
	          (0, _preact.h)(_CloseButton2.default, { customFill: "rgb(0,0,0)" })
	        ),
	        (0, _preact.h)(
	          "h2",
	          null,
	          globalContext.viewStateHistory.currentView.params.title
	        ),
	        (0, _preact.h)(
	          "small",
	          null,
	          globalContext.viewStateHistory.currentView.params.description
	        ),
	        (0, _preact.h)(
	          "div",
	          {
	            onClick: function onClick() {
	              if (globalContext.viewStateHistory.currentView.params.type !== "url") {
	                globalContext.viewStateHistory.goTo("offerView", globalContext.viewStateHistory.currentView.params);
	              } else window.location.href = globalContext.viewStateHistory.currentView.params.url;
	            },
	            ref: function ref(node) {
	              if (node) node.style.setProperty("background", "radial-gradient(99.45% 99.14% at 1.91% 0.86%, rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0) 100%), " + globalContext.widgetConfig.commonConfig.bgEndColor, "important");
	            },
	            className: "coca-cowi-big-button"
	          },
	          (0, _preact.h)(
	            "span",
	            {
	              ref: function ref(node) {
	                if (node) node.style.setProperty("color", "" + ((0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgEndColor) === "light" ? "rgba(255,255,255,1)" : "rgba(0,0,0,.6)"), "important");
	              }
	            },
	            " ",
	            "Know More",
	            " "
	          )
	        ),
	        (0, _preact.h)(
	          "h3",
	          {
	            onClick: function onClick() {
	              globalContext.viewStateHistory.goTo("offers", "");
	            }
	          },
	          " ",
	          "View all offers"
	        )
	      )
	    )
	  );
	};

	exports.default = StoryView;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var _Root = __webpack_require__(3);

	var _hooks = __webpack_require__(2);

	var _CloseButton = __webpack_require__(33);

	var _CloseButton2 = _interopRequireDefault(_CloseButton);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var Header = function Header(props) {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);
	  return (0, _preact.h)(
	    "div",
	    { className: "coca-d-flex coca-align-items-center coca-justify-content-end coca-cowi-logo-header" },
	    (0, _preact.h)(
	      "div",
	      { className: "coca-d-flex coca-align-items-center" },
	      (0, _preact.h)(
	        "div",
	        {
	          onClick: function onClick() {
	            globalContext.isCowiOpened.set(false);
	            if (window.externalOfcoTrigger) {
	              window.externalOfcoTrigger("unhideOfco");
	            }
	          },
	          className: "coca-cowi-opened-close-button coca-flex-grow-0 coca-d-col "
	        },
	        (0, _preact.h)(_CloseButton2.default, null)
	      )
	    )
	  );
	};

	exports.default = Header;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var Open = function Open(props) {
	  if (props.selected) return (0, _preact.h)("img", {
	    className: "coca-cowi-icon",
	    src: props.color === "light" ? "https://assets.cornercart.io/images/corner-widget/chat-selected-light.svg" : "https://assets.cornercart.io/images/corner-widget/chat-selected-dark.svg",
	    alt: "chat"
	  });else return (0, _preact.h)("img", {
	    className: "coca-cowi-icon",
	    src: props.color === "light" ? "https://assets.cornercart.io/images/corner-widget/chat-light.svg" : "https://assets.cornercart.io/images/corner-widget/chat-dark.svg",
	    alt: "chat"
	  });
	};

	exports.default = Open;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var _hooks = __webpack_require__(2);

	var _ChatIcon = __webpack_require__(71);

	var _ChatIcon2 = _interopRequireDefault(_ChatIcon);

	var _CartIcon = __webpack_require__(34);

	var _CartIcon2 = _interopRequireDefault(_CartIcon);

	var _OfferIcon = __webpack_require__(21);

	var _OfferIcon2 = _interopRequireDefault(_OfferIcon);

	var _Root = __webpack_require__(3);

	var _utilities = __webpack_require__(4);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var SideBar = function SideBar(props) {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);
	  return (0, _preact.h)(
	    "div",
	    { className: "coca-d-flex coca-cowi-side-bar " },
	    (0, _preact.h)(
	      "div",
	      { className: "coca-d-flex coca-flex-grow-1 coca-justify-content-center  coca-cowi-navbar" },
	      (0, _preact.h)(
	        "div",
	        {
	          ref: function ref(node) {
	            if (node) node.style.setProperty("border-color", "" + ((0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgEndColor) === "light" ? "rgba(255,255,255,1)" : "rgba(0,0,0,.6)"), "important");
	          },
	          onClick: function onClick() {
	            globalContext.viewStateHistory.goTo("assistant", "");
	          },
	          className: "coca-cowi-nav-item coca-text-center " + (globalContext.viewStateHistory.currentView.view === "chat" || globalContext.viewStateHistory.currentView.view === "assistant" && "coca-cowi-nav-item-selected")
	        },
	        (0, _preact.h)(
	          "div",
	          { className: "coca-nav-item-icon" },
	          (0, _preact.h)(_ChatIcon2.default, {
	            selected: globalContext.viewStateHistory.currentView.view === "chat" || globalContext.viewStateHistory.currentView.view === "assistant",
	            color: (0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgEndColor)
	          })
	        ),
	        (0, _preact.h)(
	          "small",
	          {
	            ref: function ref(node) {
	              if (node) node.style.setProperty("color", "" + ((0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgEndColor) === "light" ? "rgba(255,255,255,1)" : "rgba(0,0,0,.6)"), "important");
	            }
	          },
	          "Assistant"
	        )
	      ),
	      (0, _preact.h)(
	        "div",
	        {
	          ref: function ref(node) {
	            if (node) node.style.setProperty("border-color", "" + ((0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgEndColor) === "light" ? "rgba(255,255,255,1)" : "rgba(0,0,0,.6)"), "important");
	          },
	          onClick: function onClick() {
	            globalContext.viewStateHistory.goTo("cart", "");
	          },
	          className: "coca-cowi-nav-item coca-text-center " + (globalContext.viewStateHistory.currentView.view === "cart" && "coca-cowi-nav-item-selected")
	        },
	        (0, _preact.h)(
	          "div",
	          { className: "coca-nav-item-icon" },
	          (0, _preact.h)(_CartIcon2.default, {
	            selected: globalContext.viewStateHistory.currentView.view === "cart",
	            color: (0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgEndColor)
	          })
	        ),
	        (0, _preact.h)(
	          "small",
	          {
	            ref: function ref(node) {
	              if (node) node.style.setProperty("color", "" + ((0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgEndColor) === "light" ? "rgba(255,255,255,1)" : "rgba(0,0,0,.6)"), "important");
	            }
	          },
	          "Cart"
	        )
	      ),
	      (0, _preact.h)(
	        "div",
	        {
	          ref: function ref(node) {
	            if (node) node.style.setProperty("border-color", "" + ((0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgEndColor) === "light" ? "rgba(255,255,255,1)" : "rgba(0,0,0,.6)"), "important");
	          },
	          onClick: function onClick() {
	            globalContext.viewStateHistory.goTo("offers", "");
	          },
	          className: "coca-cowi-nav-item coca-text-center " + (globalContext.viewStateHistory.currentView.view === "offers" && "coca-cowi-nav-item-selected")
	        },
	        (0, _preact.h)(
	          "div",
	          { className: "coca-nav-item-icon" },
	          (0, _preact.h)(_OfferIcon2.default, {
	            selected: globalContext.viewStateHistory.currentView.view === "offers" || globalContext.viewStateHistory.currentView.view === "offerView",
	            color: (0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgEndColor)
	          })
	        ),
	        (0, _preact.h)(
	          "small",
	          {
	            ref: function ref(node) {
	              if (node) node.style.setProperty("color", "" + ((0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgEndColor) === "light" ? "rgba(255,255,255,1)" : "rgba(0,0,0,.6)"), "important");
	            }
	          },
	          "Offers"
	        )
	      )
	    ),
	    !globalContext.featureFlag.supportCorner.remove_corner_branding && (0, _preact.h)(
	      "div",
	      { className: "coca-cowi-branding coca-d-flex coca-justify-content-center" },
	      (0, _preact.h)(
	        "a",
	        {
	          href: "https://apps.shopify.com/supportcorner?utm_campaign=corner-widget&utm_medium=" + globalContext.storeName + "&utm_source=" + window.location.hostname,
	          className: "coca-branding",
	          target: "_blank"
	        },
	        (0, _preact.h)("img", {
	          className: "coca-cowi-icon",
	          src: (0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgEndColor) === "light" ? "https://assets.cornercart.io/images/corner-widget/branding-light.svg" : "https://assets.cornercart.io/images/corner-widget/branding-dark.svg",
	          alt: "Cart"
	        })
	      )
	    )
	  );
	};

	exports.default = SideBar;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var _hooks = __webpack_require__(2);

	var _Header = __webpack_require__(70);

	var _Header2 = _interopRequireDefault(_Header);

	var _SideBar = __webpack_require__(72);

	var _SideBar2 = _interopRequireDefault(_SideBar);

	var _AssistantHome = __webpack_require__(63);

	var _AssistantHome2 = _interopRequireDefault(_AssistantHome);

	var _FaqList = __webpack_require__(64);

	var _FaqList2 = _interopRequireDefault(_FaqList);

	var _FaqView = __webpack_require__(65);

	var _FaqView2 = _interopRequireDefault(_FaqView);

	var _Chat = __webpack_require__(60);

	var _Chat2 = _interopRequireDefault(_Chat);

	var _CartHome = __webpack_require__(66);

	var _CartHome2 = _interopRequireDefault(_CartHome);

	var _OffersHome = __webpack_require__(68);

	var _OffersHome2 = _interopRequireDefault(_OffersHome);

	var _OfferView = __webpack_require__(67);

	var _OfferView2 = _interopRequireDefault(_OfferView);

	var _StoryView = __webpack_require__(69);

	var _StoryView2 = _interopRequireDefault(_StoryView);

	var _Root = __webpack_require__(3);

	var _utilities = __webpack_require__(4);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var Open = function Open() {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);

	  var viewRenderComponent = function viewRenderComponent() {
	    switch (globalContext.viewStateHistory.currentView.view) {
	      case "assistant":
	        return (0, _preact.h)(_AssistantHome2.default, null);
	      case "chat":
	        return (0, _preact.h)(_Chat2.default, null);
	      case "cart":
	        return (0, _preact.h)(_CartHome2.default, null);
	      case "faqList":
	        return (0, _preact.h)(_FaqList2.default, null);
	      case "faqView":
	        return (0, _preact.h)(_FaqView2.default, null);
	      case "offers":
	        return (0, _preact.h)(_OffersHome2.default, null);
	      case "offerView":
	        return (0, _preact.h)(_OfferView2.default, null);
	    }
	  };

	  return (0, _preact.h)(
	    "div",
	    {
	      className: "coca-d-flex coca-cowi-opened coca-cowi-opened-align-" + globalContext.widgetConfig.commonConfig.alignment,
	      ref: function ref(node) {
	        if (node) node.style.setProperty("background", "linear-gradient(180deg, " + (0, _utilities.rgbToRgba)(globalContext.widgetConfig.commonConfig.bgStartColor, 0.8) + " 0%, " + (0, _utilities.rgbToRgba)(globalContext.widgetConfig.commonConfig.bgEndColor, 0.9) + "  100%)", "important");
	      }
	    },
	    (0, _preact.h)(_Header2.default, null),
	    (0, _preact.h)(
	      "div",
	      { className: "coca-d-flex coca-flex-grow-1 coca-cowi-main-body-wrapper" },
	      globalContext.widgetStyle === "advancedCart" ? (0, _preact.h)(_SideBar2.default, {
	        selectedTab: globalContext.viewStateHistory.currentView.view
	      }) : (0, _preact.h)(
	        "div",
	        null,
	        !globalContext.featureFlag.supportCorner.remove_corner_branding ? (0, _preact.h)(
	          "a",
	          {
	            href: "https://apps.shopify.com/supportcorner?utm_campaign=suco_a&utm_source=corner-widget&utm_medium=" + globalContext.storeName + "&utm_source=" + window.location.hostname,
	            ref: function ref(node) {
	              if (node) node.style.setProperty("color", "" + ((0, _utilities.calculateForeground)(globalContext.widgetConfig.commonConfig.bgEndColor) === "light" ? "rgba(255,255,255,1)" : "rgba(0,0,0,.6)"), "important");
	            },
	            className: "coca-cowi-branding coca-text-center",
	            target: "_blank"
	          },
	          "Powered By ",
	          (0, _preact.h)(
	            "b",
	            null,
	            "Corner"
	          )
	        ) : (0, _preact.h)("div", { className: "coca-cowi-disabled-branding-spacer" })
	      ),
	      (0, _preact.h)(
	        "div",
	        {
	          className: "coca-d-flex coca-flex-grow-1 coca-cowi-main-content-area"
	        },
	        viewRenderComponent()
	      )
	    ),
	    globalContext.viewStateHistory.currentView.view === "story" && (0, _preact.h)(_StoryView2.default, null)
	  );
	};
	exports.default = Open;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _preact = __webpack_require__(1);

	var _Root = __webpack_require__(3);

	var _hooks = __webpack_require__(2);

	__webpack_require__(124);

	var _Open = __webpack_require__(73);

	var _Open2 = _interopRequireDefault(_Open);

	var _Launchers = __webpack_require__(57);

	var _Launchers2 = _interopRequireDefault(_Launchers);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var CornerWidget = function CornerWidget() {
	  var globalContext = (0, _hooks.useContext)(_Root.GlobalContext);
	  var widgetState = function widgetState() {
	    if (globalContext.isCowiOpened.get) return (0, _preact.h)(_Open2.default, null);else return (0, _preact.h)(_Launchers2.default, null);
	  };
	  return (0, _preact.h)(
	    "div",
	    {
	      className: "coca-clean coca-cowi",
	      ref: function ref(node) {
	        if (node) node.style.setProperty("z-index", globalContext.widgetConfig.commonConfig.zIndex, "important");
	      }
	    },
	    widgetState()
	  );
	};

	exports.default = CornerWidget;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var _regenerator = __webpack_require__(15);

	var _regenerator2 = _interopRequireDefault(_regenerator);

	var _asyncToGenerator2 = __webpack_require__(14);

	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var getProductDetails = function () {
	  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(handle) {
	    var product;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return window.fetch("/products/" + handle + ".js");

	          case 2:
	            _context.next = 4;
	            return _context.sent.json();

	          case 4:
	            product = _context.sent;
	            return _context.abrupt("return", product);

	          case 6:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));

	  return function getProductDetails(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();

	module.exports = { getProductDetails: getProductDetails };

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(79), __esModule: true };

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(80), __esModule: true };

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _assign = __webpack_require__(76);

	var _assign2 = _interopRequireDefault(_assign);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];

	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }

	  return target;
	};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(109);
	module.exports = __webpack_require__(7).Object.assign;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(110);
	__webpack_require__(112);
	__webpack_require__(115);
	__webpack_require__(111);
	__webpack_require__(113);
	__webpack_require__(114);
	module.exports = __webpack_require__(7).Promise;


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 82 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    return;(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(30);
	var toLength = __webpack_require__(47);
	var toAbsoluteIndex = __webpack_require__(104);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(18);
	var call = __webpack_require__(88);
	var isArrayIter = __webpack_require__(87);
	var anObject = __webpack_require__(8);
	var toLength = __webpack_require__(47);
	var getIterFn = __webpack_require__(107);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') return;(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(10) && !__webpack_require__(24)(function () {
	  return Object.defineProperty(__webpack_require__(23)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 86 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(13);
	var ITERATOR = __webpack_require__(6)('iterator');
	var ArrayProto = Array.prototype;

	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(8);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(94);
	var descriptor = __webpack_require__(43);
	var setToStringTag = __webpack_require__(27);
	var IteratorPrototype = {};

	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(9)(IteratorPrototype, __webpack_require__(6)('iterator'), function () { return this; });

	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(6)('iterator');
	var SAFE_CLOSING = false;

	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }

	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 91 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var macrotask = __webpack_require__(46).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(17)(process) == 'process';

	module.exports = function () {
	  var head, last, notify;

	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };

	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }

	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(40);
	var gOPS = __webpack_require__(96);
	var pIE = __webpack_require__(99);
	var toObject = __webpack_require__(48);
	var IObject = __webpack_require__(38);
	var $assign = Object.assign;

	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(24)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(8);
	var dPs = __webpack_require__(95);
	var enumBugKeys = __webpack_require__(36);
	var IE_PROTO = __webpack_require__(28)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(23)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(37).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};

	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(20);
	var anObject = __webpack_require__(8);
	var getKeys = __webpack_require__(40);

	module.exports = __webpack_require__(10) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 96 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(19);
	var toObject = __webpack_require__(48);
	var IE_PROTO = __webpack_require__(28)('IE_PROTO');
	var ObjectProto = Object.prototype;

	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(19);
	var toIObject = __webpack_require__(30);
	var arrayIndexOf = __webpack_require__(83)(false);
	var IE_PROTO = __webpack_require__(28)('IE_PROTO');

	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 99 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(9);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(9);


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var core = __webpack_require__(7);
	var dP = __webpack_require__(20);
	var DESCRIPTORS = __webpack_require__(10);
	var SPECIES = __webpack_require__(6)('species');

	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(29);
	var defined = __webpack_require__(22);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(29);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(12);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  return;("Can't convert object to primitive value");
	};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var navigator = global.navigator;

	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(35);
	var ITERATOR = __webpack_require__(6)('iterator');
	var Iterators = __webpack_require__(13);
	module.exports = __webpack_require__(7).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(81);
	var step = __webpack_require__(91);
	var Iterators = __webpack_require__(13);
	var toIObject = __webpack_require__(30);

	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(39)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');

	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;

	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(11);

	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(93) });


/***/ }),
/* 110 */
/***/ (function(module, exports) {

	

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(25);
	var global = __webpack_require__(5);
	var ctx = __webpack_require__(18);
	var classof = __webpack_require__(35);
	var $export = __webpack_require__(11);
	var isObject = __webpack_require__(12);
	var aFunction = __webpack_require__(16);
	var anInstance = __webpack_require__(82);
	var forOf = __webpack_require__(84);
	var speciesConstructor = __webpack_require__(45);
	var task = __webpack_require__(46).set;
	var microtask = __webpack_require__(92)();
	var newPromiseCapabilityModule = __webpack_require__(26);
	var perform = __webpack_require__(41);
	var userAgent = __webpack_require__(106);
	var promiseResolve = __webpack_require__(42);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(6)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();

	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) return;("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};

	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(100)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}

	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(27)($Promise, PROMISE);
	__webpack_require__(102)(PROMISE);
	Wrapper = __webpack_require__(7)[PROMISE];

	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(90)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(103)(true);

	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(39)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(11);
	var core = __webpack_require__(7);
	var global = __webpack_require__(5);
	var speciesConstructor = __webpack_require__(45);
	var promiseResolve = __webpack_require__(42);

	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(11);
	var newPromiseCapability = __webpack_require__(26);
	var perform = __webpack_require__(41);

	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(108);
	var global = __webpack_require__(5);
	var hide = __webpack_require__(9);
	var Iterators = __webpack_require__(13);
	var TO_STRING_TAG = __webpack_require__(6)('toStringTag');

	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');

	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(50)();
	// imports


	// module
	exports.push([module.id, ".coca-d-none{display:none!important}.coca-cowi img{width:100%!important}.coca-cowi .coca-d-flex{display:-ms-flexbox!important;display:flex!important}.coca-cowi .coca-d-col{-ms-flex:1!important;flex:1!important}.coca-cowi .coca-flex-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.coca-cowi .coca-flex-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.coca-cowi .coca-flex-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.coca-cowi .coca-flex-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.coca-cowi .coca-d-block{display:block!important}.coca-cowi .coca-align-items-center{-ms-flex-align:center!important;align-items:center!important}.coca-cowi .coca-justify-content-center{-ms-flex-pack:center!important;justify-content:center!important}.coca-cowi .coca-justify-content-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.coca-cowi .coca-justify-content-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.coca-cowi .coca-text-center{text-align:center!important}.coca-cowi .coca-p-1{padding:8px!important}.coca-cowi .coca-p-2{padding:12px!important}.coca-cowi .coca-pt-1{padding-top:8px!important}.coca-cowi .coca-pt-2{padding-top:12px!important}.coca-cowi .coca-pb-1{padding-bottom:8px!important}.coca-cowi .coca-pb-2{padding-bottom:12px!important}.coca-cowi .coca-pr-1{padding-right:8px!important}.coca-cowi .coca-pr-2{padding-right:12px!important}.coca-cowi .coca-pl-1{padding-left:8px!important}.coca-cowi .coca-pl-2{padding-left:12px!important}.coca-cowi .coca-py-1{padding:8px 0!important}.coca-cowi .coca-py-2{padding:12px 0!important}.coca-cowi .coca-px-1{padding:0 8px!important}.coca-cowi .coca-px-2{margin:0 12px!important}.coca-cowi .coca-m-1{margin:8px!important}.coca-cowi .coca-m-2{margin:12px!important}.coca-cowi .coca-mt-1{margin-top:8px!important}.coca-cowi .coca-mt-2{margin-top:12px!important}.coca-cowi .coca-mb-1{margin-bottom:8px!important}.coca-cowi .coca-mb-2{margin-bottom:12px!important}.coca-cowi .coca-mr-1{margin-right:8px!important}.coca-cowi .coca-mr-2{margin-right:12px!important}.coca-cowi .coca-ml-1{margin-left:8px!important}.coca-cowi .coca-ml-2{margin-left:12px!important}.coca-cowi .coca-my-1{margin:8px 0!important}.coca-cowi .coca-my-2{margin:12px 0!important}.coca-cowi .coca-mx-1{margin:0 8px!important}.coca-cowi .coca-mx-2{margin:0 12px!important}.coca-cowi .coca-cowi-card{background:#fff!important;border:1px solid #e8e8e8!important;box-sizing:border-box!important;box-shadow:0 3px 11px rgba(0,0,0,.06)!important;border-radius:6px!important}.coca-cowi .coca-cowi-hover-card{cursor:pointer!important;transition:all .2s ease!important}.coca-cowi .coca-cowi-hover-card:hover{box-shadow:0 11px 16px rgba(0,0,0,.08)!important;transition:all .2s ease!important;transform:scale(1.03)!important}@media screen and (min-width:992px){.coca-cowi.coca-cowi-hide-on-desktop,.coca-cowi .coca-cowi-hide-on-desktop{display:none!important}}@media screen and (max-width:992px){.coca-cowi.coca-cowi-hide-on-mobile,.coca-cowi .coca-cowi-hide-on-mobile{display:none!important}}.coca-cowi,.coca-cowi p{font-family:Open Sans,sans-serif!important;font-style:normal!important;font-weight:400!important;font-size:14px!important;line-height:18px!important;color:#424242!important}.coca-cowi p{margin:0!important;word-break:break-word!important}.coca-cowi h1{font-weight:400!important;font-size:24px!important;line-height:33px!important}.coca-cowi h1,.coca-cowi h2{font-family:Open Sans,sans-serif!important;font-style:normal!important;margin:0!important;color:#232222!important}.coca-cowi h2{font-weight:bolder!important;font-size:15px!important;line-height:22px!important}.coca-cowi h3{font-weight:400!important;font-size:15px!important;line-height:22px!important;color:#232222!important}.coca-cowi h3,.coca-cowi small{font-family:Open Sans,sans-serif!important;font-style:normal!important;margin:0!important}.coca-cowi small{font-weight:500!important;font-size:12px!important;line-height:12px!important;color:#4a4a4a!important}.coca-cowi a{text-decoration:none!important}.coca-cowi .coca-text-white{color:#fff!important}.coca-cowi .coca-text-green{color:#2e924a!important}.coca-cowi{position:relative!important}.coca-cowi .coca-cowi-big-button{padding:12px!important;margin:4px 0!important;border-radius:4px!important;cursor:pointer!important}.coca-cowi .coca-cowi-tiny-button{padding:4px 8px!important;border-radius:18px!important;cursor:pointer!important;border:1px solid rgba(0,0,0,.1)!important;transition:all .2s ease!important}.coca-cowi .coca-cowi-tiny-button-icon{margin-right:8px!important}.coca-cowi .coca-cowi-tiny-button:hover{transition:all .2s ease!important;border:1px solid rgba(0,0,0,.4)}.coca-cowi .coca-cowi-icon{border:0!important;max-height:22px!important}.coca-cowi .coca-inner-title{margin-top:12px!important}.coca-cowi .coca-cowi-corner-button{position:fixed!important;-ms-flex-direction:column!important;flex-direction:column!important;pointer-events:none;transition:all 1s ease!important;margin:30px!important}.coca-cowi-corner-button-align-right{right:0!important;-ms-flex-align:end!important;align-items:flex-end!important}.coca-cowi-corner-button-align-left{left:0!important;-ms-flex-align:start!important;align-items:flex-start!important;text-align:left!important}@media only screen and (max-width:780px){.coca-cowi-corner-button-align-left{left:0!important;margin:20px!important}.coca-cowi-corner-button-align-right{right:0!important;margin:20px!important}}.coca-cowi .coca-cowi-corner-button-item{position:relative;pointer-events:all;box-shadow:0 20px 60px rgba(0,0,0,.479),0 10px 12px 0 rgba(0,0,0,.14);cursor:pointer!important;z-index:2!important;transition:all 1s ease!important}.coca-cowi .coca-cowi-corner-button-item p{font-weight:700!important;margin-left:6px!important}.coca-cowi .coca-cowi-desktop-size-small{padding:8px!important}.coca-cowi .coca-cowi-desktop-size-small .coca-cowi-launcher-icon{width:18px!important}.coca-cowi .coca-cowi-desktop-size-medium{padding:12px!important}.coca-cowi .coca-cowi-desktop-size-medium .coca-cowi-launcher-icon{width:20px!important}.coca-cowi .coca-cowi-desktop-size-large{padding:16px!important}.coca-cowi .coca-cowi-desktop-size-large .coca-cowi-launcher-icon{width:25px!important}@media only screen and (max-width:780px){.coca-cowi .coca-cowi-mobile-size-small{padding:4px!important}.coca-cowi .coca-cowi-mobile-size-small .coca-cowi-launcher-icon{width:16px!important}.coca-cowi .coca-cowi-mobile-size-medium{padding:8px!important}.coca-cowi .coca-cowi-mobile-size-medium .coca-cowi-launcher-icon{width:18px!important}.coca-cowi .coca-cowi-mobile-size-large{padding:12px!important}.coca-cowi .coca-cowi-mobile-size-small .coca-cowi-launcher-icon{width:20px!important}}.coca-cowi .coca-cowi-launcher-icon{border:0!important;width:50%!important;margin-left:-1px!important;transition:all 1s ease!important}.coca-cowi .coca-cowi-corner-button-shape-circle{border-radius:200px!important}.coca-cowi .coca-cowi-corner-button-shape-square{border-radius:2px!important}.coca-cowi .coca-cowi-corner-button-shape-rounded-square{border-radius:8px!important}.coca-cowi .coca-cowi-corner-button-shape-app-icon{border-radius:16px!important}.coca-cowi .coca-cowi-side-tab{position:fixed!important;-ms-flex-direction:column!important;flex-direction:column!important;transition:all .3s ease!important;padding:12px 14px 12px 12px!important;cursor:pointer!important}.coca-cowi .coca-cowi-side-tab:hover{transition:all 1s ease!important;padding:12px 14px 12px 16px!important;box-shadow:0 0 35px 2px rgba(0,0,0,.24)}.coca-cowi .coca-cowi-side-tab-text{-webkit-writing-mode:vertical-lr!important;-ms-writing-mode:tb-lr!important;writing-mode:vertical-lr!important;transform:rotate(180deg)!important;font-size:13px!important;font-weight:bolder!important}.coca-cowi .coca-cowi-side-tab-icon{margin-top:8px!important;width:20px!important}.coca-cowi-side-tab-align-right{right:0!important;border-radius:3px 0 0 3px!important}.coca-cowi-side-tab-align-left{left:0!important;border-radius:0 3px 3px 0!important}@media only screen and (max-width:780px){.coca-cowi .coca-cowi-side-tab{padding:8px 6px 8px 8px!important}.coca-cowi .coca-cowi-side-tab:hover{padding:8px 6px 8px 12px!important}.coca-cowi .coca-cowi-side-tab-text{font-size:12px!important}.coca-cowi .coca-cowi-side-tab-icon{margin-top:6px!important;width:16px!important}}.coca-cowi .coca-cowi-opened{-ms-flex-direction:column!important;flex-direction:column!important;position:fixed!important;bottom:22px!important;height:740px!important;width:400px!important;border-radius:20px;box-shadow:0 4px 75px rgba(0,0,0,.25);background:#fff!important;animation:appear .5s!important;-webkit-backdrop-filter:blur(6px)!important;backdrop-filter:blur(6px)!important}@keyframes appear{0%{transform:scale(.2);opacity:0;transform:translate(10px,10px)}to{transform:scale(1);opacity:1;transform:translate(0)}}.coca-cowi-opened-align-bottom-right,.coca-cowi-opened-align-right{right:22px!important}.coca-cowi-opened-align-bottom-left,.coca-cowi-opened-align-left{left:22px!important}@media only screen and (max-height:780px){.coca-cowi .coca-cowi-opened{bottom:0!important;height:calc(100vh - 20px)!important;width:380px!important}.coca-cowi-opened-align-bottom-right,.coca-cowi-opened-align-right{right:0!important}.coca-cowi-opened-align-bottom-left,.coca-cowi-opened-align-left{left:0!important}}@media only screen and (max-width:500px){.coca-cowi .coca-cowi-opened{bottom:0!important;width:100vw!important;height:80vh!important}.coca-cowi-opened-align-bottom-right,.coca-cowi-opened-align-right{right:0!important}.coca-cowi-opened-align-bottom-left,.coca-cowi-opened-align-left{left:0!important}}.coca-cowi .coca-cowi-bg{overflow-x:hidden!important;position:relative!important;border-radius:20px 20px 0 0!important;padding:0 12px!important;border:1px solid rgba(0,0,0,.04)!important}@media only screen and (max-width:374px),screen and (max-height:500px){.coca-cowi .coca-cowi-bg{padding:8px!important}}.coca-cowi .coca-cowi-main-container{position:relative!important;-ms-flex-direction:column!important;flex-direction:column!important;width:100%!important}.coca-cowi .coca-cowi-title-header{padding:12px 18px!important;cursor:pointer!important}.coca-cowi .coca-cowi-chat-back-button:hover{transition:all .2s ease!important;transform:translateX(-4px)!important}.coca-cowi .coca-cowi-header-icon,.coca-cowi .coca-cowi-header-title{transition:all .2s ease!important;padding:0 4px!important}.coca-cowi .coca-cowi-header-icon{width:22px!important}.coca-cowi .coca-cowi-main-body-wrapper{-ms-flex-align:end!important;align-items:flex-end!important;height:calc(100% - 55px)!important}@media only screen and (max-height:780px){.coca-cowi .coca-cowi-main-body-wrapper{height:calc(100% - 48px)!important}}.coca-cowi .coca-cowi-empty-state{margin-top:65px!important}.coca-cowi .coca-cowi-empty-state img{max-width:235px!important}.coca-cowi .coca-cowi-logo-header{width:100%!important;-ms-flex:0 0 40px!important;flex:0 0 40px!important}@media only screen and (max-width:500px),screen and (max-height:780px){.coca-cowi .coca-cowi-logo-header{-ms-flex:0 0 48px!important;flex:0 0 48px!important}}.coca-cowi .coca-cowi-opened-close-button{margin:0 12px!important}.coca-cowi .coca-cowi-close-button{margin:0 8px!important;transition:all .2s ease!important;cursor:pointer!important}.coca-cowi .coca-cowi-close-button:hover{transform:rotate(90deg)!important;transition:all .2s ease!important}.coca-cowi .coca-cowi-store-logo{height:40px!important;margin:0 28px!important}.coca-cowi .coca-cowi-store-logo img{height:100%!important;max-width:180px!important}.coca-cowi .coca-cowi-side-bar{-ms-flex-direction:column!important;flex-direction:column!important;-ms-flex:0 0 68px!important;flex:0 0 68px!important;height:100%!important}@media only screen and (max-width:400px),screen and (max-height:500px){.coca-cowi .coca-cowi-side-bar{-ms-flex:0 0 65px!important;flex:0 0 65px!important}}.coca-cowi .coca-cowi-navbar{-ms-flex-direction:column!important;flex-direction:column!important}.coca-cowi .coca-cowi-main-content-area{position:relative!important;background:#fff!important;box-shadow:-3px 0 20px rgba(0,0,0,.15)!important;border-radius:20px!important;overflow-x:hidden!important;overflow-y:auto!important;height:100%!important;animation:lol .6s ease-out!important}@keyframes lol{0%{opacity:0;transform:translatex(50px)}to{opacity:1;transform:translatex(0)}}.coca-cowi .coca-cowi-nav-item{padding:32px 0!important;cursor:pointer!important;border-left:0 solid;transition:all .5s ease!important}.coca-cowi :not(.coca-cowi-nav-item-selected).coca-cowi-nav-item:hover{background:linear-gradient(91.7deg,rgba(0,0,0,.06) 1.93%,transparent 97.99%)!important;transition:all .5s ease!important}.coca-cowi .coca-cowi-nav-item-selected{border-left:4px solid;background:linear-gradient(91.7deg,rgba(0,0,0,.16) 1.93%,transparent 97.99%)!important;transition:all .5s ease!important;font-weight:bolder!important}.coca-cowi .coca-cowi-branding{-webkit-writing-mode:vertical-lr!important;-ms-writing-mode:tb-lr!important;writing-mode:vertical-lr!important;transform:rotate(180deg)!important;font-size:13px!important;padding:15px 3px 0!important;font-size:10px!important}.coca-cowi .coca-cowi-disabled-branding-spacer{width:18px!important;height:18px!important}@media only screen and (max-width:500px){.coca-cowi .coca-cowi-branding{padding:15px 1px 0!important;font-size:8px!important}.coca-cowi .coca-cowi-disabled-branding-spacer{width:12px!important;height:12px!important}}.coca-cowi .coca-cowi-branding:hover{opacity:1!important;transition:all .5s ease!important;cursor:pointer!important}.coca-cowi .coca-cowi-assitant{-ms-flex-direction:column!important;flex-direction:column!important;width:100%!important;overflow-y:auto!important}.coca-cowi .coca-cowi-assistant-contact-btn{padding:4px!important;border-radius:4px!important;cursor:pointer!important}.coca-cowi .coca-cowi-assistant-contact{margin-top:16px!important;text-align:right!important}.coca-cowi .coca-cowi-search-box{padding:14px!important;box-shadow:0 6px 17px rgba(0,0,0,.09)!important;border-radius:5px!important;border:1px solid #e8e8e8!important}.coca-cowi .coca-search-input{border:none!important;font-family:Open Sans,sans-serif!important;-ms-flex:1 0 90%!important;flex:1 0 90%!important;line-height:0!important}.coca-cowi .coca-cowi-search-btn{height:22px!important}.coca-cowi .coca-cowi-assistant-title-header{margin:18px!important}.coca-cowi .coca-cowi-assistant-title-content{margin:14px 0!important}.coca-cowi .coca-cowi-assistant-title-emoji{font-size:38px!important;line-height:18px!important;margin-bottom:18px!important}.coca-cowi .coca-cowi-contact-options{margin-top:18px!important}.coca-cowi .coca-cowi-contact-icon{display:-ms-flexbox!important;display:flex!important;-ms-flex-align:center!important;align-items:center!important;width:25px!important;height:25px!important;padding:6px!important;margin-right:12px!important;border-radius:14px!important;transition:all .5s ease!important;transform:translateY(0)!important}.coca-cowi .coca-cowi-contact-icon:hover{transition:all .5s ease!important;transform:translateY(-3px)!important;filter:hue-rotate(-25deg)}.coca-cowi .coca-cowi-contact-label{margin-right:8px!important}.coca-cowi .coca-cowi-wa-icon{background:#45b364!important;box-shadow:0 10px 8px rgba(84,255,81,.45)!important}.coca-cowi .coca-cowi-me-icon{background:#138eff!important;box-shadow:0 10px 8px rgba(66,221,255,.25)!important}.coca-cowi .coca-cowi-mail-icon{background:#ec4c4c!important;box-shadow:0 10px 8px rgba(255,66,66,.25)!important}.coca-cowi .coca-cowi-sms-icon{background:#a128ff!important;box-shadow:0 10px 8px rgba(100,27,255,.25)!important}@media only screen and (max-width:500px),screen and (max-height:780px){.coca-cowi .coca-cowi-assistant-title-header h1{font-size:22px!important;line-height:32px!important}.coca-cowi .coca-cowi-assistant-title-content{margin:8px 0!important}.coca-cowi .coca-cowi-contact-options{margin-top:12px!important}.coca-cowi .coca-cowi-assistant-title-emoji{font-size:28px!important;line-height:28px!important;margin-bottom:0!important}.coca-cowi .coca-cowi-search-box{padding:8px!important;margin-top:12px!important}}@media only screen and (max-width:500px){.coca-cowi .coca-cowi-assistant-title-emoji{display:none!important}}@media only screen and (max-height:520px){.coca-cowi .coca-cowi-assistant-title-content{display:none!important}}.coca-cowi .coca-cowi-faq-category-wrapper{margin-top:14px!important}.coca-cowi .coca-cowi-faq-category-btn-wrapper{margin-top:8px!important;-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.coca-cowi .coca-cowi-faq-category-btn{-ms-flex:0 0 49%!important;flex:0 0 49%!important}.coca-cowi .coca-cowi-faq-category-btn-img{width:30px!important}.coca-cowi .coca-cowi-faq-category-btn-img img{width:100%!important}.coca-cowi .coca-cowi-faq-category-btn-card{-ms-flex:0 0 47%;flex:0 0 47%;padding:8px!important;margin:4px!important;cursor:pointer!important;transition:all .2s ease!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-direction:column!important;flex-direction:column!important;-ms-flex-pack:center!important;justify-content:center!important;-ms-flex-align:center!important;align-items:center!important}.coca-cowi .coca-cowi-faq-card{margin-top:8px!important;padding:16px 12px!important}.coca-cowi .coca-cowi-faq-card-image{width:34px!important;border-radius:8px!important;overflow:hidden!important;cursor:pointer!important}.coca-cowi .coca-cowi-faq-card-details{padding:0 12px!important;cursor:pointer!important;transition:all .5s ease!important}.coca-cowi .coca-cowi-faq-card-title{font-weight:700!important;margin-bottom:4px!important}@media only screen and (max-width:780px){.coca-cowi .coca-cowi-faq-card{margin-top:8px!important;padding:12px 8px!important}.coca-cowi .coca-cowi-faq-card-image{width:28px!important}}.coca-cowi .coca-cowi-threads-container{position:relative!important;border-radius:20px!important}.coca-cowi .coca-cowi-threads h2{padding:16px 0!important;border-bottom:1px solid rgba(0,0,0,.2)!important}.coca-cowi .coca-cowi-quickread{margin:12px 0}.coca-cowi .coca-cowi-quickread h3{padding:12px 16px!important}.coca-cowi .coca-cowi-quickread-content{-ms-flex:0 0 85%!important;flex:0 0 85%!important}.coca-cowi .coca-cowi-quickread-item{padding:16px!important;border-top:1px solid rgba(0,0,0,.2)!important;cursor:pointer!important}.coca-cowi .coca-cowi-quickread-item:hover{background:rgba(0,158,255,.06)!important}.coca-cowi .coca-cowi-quickread-img{-ms-flex:0 0 15%!important;flex:0 0 15%!important;padding-right:12px!important}.coca-cowi .coca-cowi-quickread-img img{width:100%!important}.coca-cowi .coca-cowi-quickread-description{max-height:34px!important;margin-top:4px!important;text-overflow:ellipsis!important;word-wrap:break-word!important;overflow:hidden!important}.coca-cowi .coca-cowi-chat-message{background:#fff!important;margin-top:18px!important;box-sizing:border-box!important;padding:12px!important;max-width:95%!important;box-shadow:0 4px 16px rgba(0,0,0,.02),0 4px 5px rgba(0,0,0,.07)!important;border-radius:8px!important}.coca-cowi .coca-cowi-income-chat-message .coca-cowi-chat-message,.coca-cowi .coca-cowi-outgo-chat-message{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.coca-cowi .coca-cowi-income-chat-message .coca-cowi-chat-message{border:1px solid #d7d7d7!important}.coca-cowi .coca-cowi-checkout-container{padding:12px 18px!important}.coca-cowi .coca-cowi-checkout-button{box-shadow:0 4px 4px rgba(0,0,0,.09)!important;border-radius:8px!important;padding:12px 18px!important;color:#fff!important;cursor:pointer!important}.coca-cowi .coca-cowi-checkout-button svg{margin-right:8px!important}.coca-cowi-edit-cart-button{margin:8px!important}.coca-cowi-cart-offer-button{margin-bottom:12px!important}.coca-cowi .coca-cowi-cart-item{margin-top:12px!important;padding:12px 8px!important}.coca-cowi .coca-cowi-message-card .coca-cowi-cart-item{margin-top:0!important}.coca-cowi .coca-cowi-message-card .coca-cowi-product-details p{display:none!important}.coca-cowi .coca-cowi-product-image{max-width:40px!important;border-radius:8px!important;overflow:hidden!important}.coca-cowi .coca-cowi-message-card .coca-cowi-product-image{max-width:32px!important;border-radius:8px!important;overflow:hidden!important}.coca-cowi .coca-cowi-product-image img{width:100%!important}.coca-cowi .coca-cowi-product-actions,.coca-cowi .coca-cowi-product-details{padding:0 12px!important;cursor:pointer!important;transition:all .5s ease!important}.coca-cowi .coca-cowi-product-actions:hover{transform:scale(1.3)!important;transition:all .5s ease!important}.coca-cowi .coca-cowi-story-container h2{padding:28px 12px 0!important}@media only screen and (max-width:374px),screen and (max-height:500px){.coca-cowi .coca-cowi-story-container h2{padding:12px 8px 0!important}}.coca-cowi .coca-cowi-story-scroll-container{overflow-y:auto!important;display:-ms-flexbox!important;display:flex!important;padding:22px 4px!important}@media only screen and (max-width:374px),screen and (max-height:500px){.coca-cowi .coca-cowi-story-scroll-container{padding:12px 4px!important}}.coca-cowi .coca-cowi-featured-story-card{position:relative!important;width:90px!important;height:135px!important;-ms-flex-negative:0!important;flex-shrink:0!important;margin-right:12px!important;background-position:50%!important;background-repeat:no-repeat!important;background-size:cover!important;box-shadow:0 4px 20px rgba(0,0,0,.25)!important;border-radius:8px!important;cursor:pointer!important;transition:all .2s ease!important}@media only screen and (max-width:374px),screen and (max-height:500px){.coca-cowi .coca-cowi-featured-story-card{width:67px!important;height:100px!important}}.coca-cowi .coca-cowi-featured-story-card:hover{transition:all .2s ease!important;transform:translateY(-2px);box-shadow:0 6px 22px rgba(0,0,0,.35)!important}.coca-cowi .coca-cowi-featured-offer-text{color:#fff!important;margin-top:auto!important;padding:12px 4px;font-size:10px!important;text-shadow:0 1px 5px rgba(0,0,0,.5);white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;z-index:1!important}.coca-cowi .coca-cowi-featured-card-gradient-overlay{position:absolute!important;border-radius:8px!important;width:100%!important;height:100%!important;background:linear-gradient(179.46deg,transparent 59.44%,rgba(0,0,0,.59) 99.69%)!important}.coca-cowi .coca-cowi-offer-thumbnail{width:50px!important;height:77px!important;background-position:50%!important;background-repeat:no-repeat!important;background-size:cover!important;box-shadow:0 8px 9px rgba(0,0,0,.25)!important;border-radius:8px!important;cursor:pointer!important;transition:all .2s ease!important;border:1px solid #e2e2e2!important}.coca-cowi .coca-cowi-offer-thumbnail:hover{transition:all .2s ease!important;transform:translateY(-2px);box-shadow:0 6px 22px rgba(0,0,0,.35)!important}.coca-cowi .coca-cowi-offer-item{margin-top:12px!important;padding:12px!important}.coca-cowi .coca-cowi-offer-details{padding-left:12px!important;margin-left:14px!important;border-left:1px dashed #d4d2d2!important}.coca-cowi-coupon-container{background:#eefff2!important;border:1px solid #dbffe5!important;box-sizing:border-box!important;border-radius:8px!important;margin:4px 0!important;padding:4px 8px!important}.coca-cowi .coca-cowi-coupon-copy{padding:8px!important;transition:all .2s ease!important}.coca-cowi .coca-cowi-coupon-copy:hover{transition:all .2s ease!important;transform:translateY(-2px)}.coca-cowi .coca-cowi-offer-actions{-ms-flex-pack:end!important;justify-content:flex-end!important;margin-top:4px!important}.coca-cowi .coca-cowi-offer-action-button{padding:4px 8px!important;cursor:pointer!important;border-radius:4px!important}.coca-cowi .coca-cowi-offer-card{margin:18px!important;padding:18px!important;min-width:200px!important}.coca-cowi .coca-cowi-offer-code{margin:4px 0 12px!important;font-size:24px!important}.coca-cowi .coca-offer-item-img{max-width:50px!important;margin-bottom:18px!important}.coca-cowi .coca-cowi-offer-specifics{margin-top:12px!important}.coca-cowi .coca-cowi-offer-expanded{max-width:260px!important;margin:auto!important}.coca-cowi .coca-cowi-offer-buttons{margin-top:32px!important}.coca-cowi .coca-cowi-offer-email-collector{height:100%!important;padding:12px}.coca-cowi .coca-cowi-offer-email-collector p{margin-bottom:24px!important}.coca-cowi .coca-locked-item-img{margin-top:-100px!important;margin-bottom:12px!important;max-width:100%!important;filter:drop-shadow(0 8px 8px rgba(84,152,129,.5))!important}.coca-cowi .coca-locked-item-content{margin-bottom:24px!important}.coca-cowi .coca-cowi-lock-popup-wrapper{pointer-events:none!important;position:absolute!important;width:100%!important;height:100%!important;background:linear-gradient(180deg,transparent,rgba(65,94,99,.5))!important;-ms-flex-align:end!important;align-items:flex-end!important}.coca-cowi .coca-cowi-blur{filter:blur(5px)!important}.coca-cowi .coca-cowi-lock-popup{pointer-events:all!important;padding:12px!important;margin:16px!important;animation:slide-in 1s!important}.coca-cowi .coca-cowi-story-view{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important;width:100%;height:100%;position:absolute;background-position:50%!important;background-repeat:no-repeat!important;background-size:cover!important;border-radius:20px;-ms-flex-direction:column;flex-direction:column;overflow:hidden}.coca-cowi .coca-cowi-story-close-button{position:absolute!important;top:21px!important;right:8px!important;z-index:3!important;padding:7px!important;border-radius:21px!important;background:rgba(0,0,0,.44)!important}.coca-cowi .coca-story-wrapper{position:relative!important;width:100%!important;height:100%!important}.coca-cowi .coca-story-wrapper img{object-fit:cover!important}.coca-cowi .coca-cowi-story-view>div:first-child,.coca-cowi .coca-cowi-story-view>div:first-child>div:nth-child(2),.coca-cowi .coca-cowi-story-view>div:first-child>div:nth-child(2)>div,.coca-cowi .coca-story-wrapper img{width:100%!important;height:100%!important}.coca-cowi .coca-cowi-story-view>div:first-child{z-index:2!important}.coca-cowi .coca-cowi-story-know-more-button{position:absolute!important;z-index:3!important;bottom:18px!important;width:100%}.coca-cowi .coca-cowi-story-know-more-button span{padding:10px 18px!important;border-radius:30px!important;color:#fff!important;font-size:14px!important;background:rgba(0,0,0,.6)!important;transition:all .5s ease!important}.coca-cowi .coca-cowi-story-know-more-button span:hover{background:#000!important;transition:all .5s ease!important;cursor:pointer!important}.coca-cowi .coca-end-story-state{position:absolute!important;z-index:3!important;bottom:240px!important;width:100%}.coca-cowi .coca-cowi-end-state-close{-ms-flex-pack:end!important;justify-content:flex-end!important}.coca-cowi .coca-cowi-story-end-card{padding:20px!important;animation:slide-in 1s!important;max-width:70%!important}.coca-cowi .coca-cowi-story-end-card h3{cursor:pointer!important}.coca-cowi .coca-cowi-story-end-card .coca-cowi-big-button{margin-top:20px!important;margin-bottom:16px!important}.coca-cowi .coca-cowi-story-loader{position:absolute;width:50px!important;height:50px!important;background:#fff!important;border-radius:50%!important;animation:load 1.25s ease-in-out infinite!important}@keyframes load{0%,to{transform:scale(0);opacity:0}50%{transform:scale(1);opacity:.5}}@keyframes slide-in{0%{opacity:0;transform:translateY(-15px)}to{opacity:1;transform:translateY(0)}}.coca-cowi .coca-cowi-email-form button,.coca-cowi .coca-cowi-email-form input{width:100%!important;padding:12px 16px!important;margin-bottom:8px!important;box-sizing:border-box!important;border:0!important;font-size:14px!important;font-family:Arial,Helvetica,sans-serif!important}.coca-cowi .coca-cowi-email-form input{border:1px solid #d4d4d4!important;border-radius:4px!important}.coca-cowi .coca-cowi-email-form button:focus,.coca-cowi .coca-cowi-email-form input:focus{outline-style:inherit!important}.coca-cowi .coca-cowi-email-form button{color:#fff!important;border-radius:4px!important;font-size:15px!important;cursor:pointer!important}.coca-cowi .coca-widget-faq-view{font-family:Arial,Helvetica,sans-serif!important}.coca-cowi .coca-widget-faq-view p{font-size:14px!important;line-height:1.8rem!important;margin-bottom:24px!important}.coca-cowi-faq-view-category-image{width:18px!important;margin-right:8px!important}.coca-cowi .coca-widget-faq-view li{font-size:14px!important;line-height:1.8rem!important}.coca-cowi .coca-widget-faq-view h1{margin:16px 0!important}.coca-cowi .coca-widget-faq-view h1,.coca-cowi .coca-widget-faq-view h2{font-weight:bolder!important;font-size:22px!important;line-height:1.5rem!important}.coca-cowi .coca-widget-faq-view h2{margin:12px 0!important}.coca-cowi .coca-widget-faq-view h3{font-weight:bolder!important;font-size:28px!important;line-height:1.5rem!important;margin:8px 0!important}.coca-cowi .coca-widget-faq-view pre{font-size:14px!important;white-space:pre-wrap!important;word-wrap:break-word!important;border:1px solid #e5e5ec!important;padding:4px!important;border-radius:8px!important;background:#eeeef1!important;display:inline!important}.coca-cowi .coca-widget-faq-view iframe{width:100%!important}.coca-cowi .coca-widget-faq-view td{border:1px solid #121212!important}", ""]);

	// exports


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(50)();
	// imports


	// module
	exports.push([module.id, "/*!\n* CleanSlate\n*   github.com/premasagar/cleanslate\n*\n*/.coca-clean a:empty,.coca-clean article:empty,.coca-clean div:empty,.coca-clean dl:empty,.coca-clean h1:empty,.coca-clean h2:empty,.coca-clean h3:empty,.coca-clean h4:empty,.coca-clean h5:empty,.coca-clean h6:empty,.coca-clean p:empty,.coca-clean section:empty,.coca-clean ul:empty{display:block!important}.coca-clean,.coca-clean a,.coca-clean abbr,.coca-clean acronym,.coca-clean address,.coca-clean applet,.coca-clean area,.coca-clean article,.coca-clean aside,.coca-clean audio,.coca-clean b,.coca-clean big,.coca-clean blockquote,.coca-clean button,.coca-clean canvas,.coca-clean caption,.coca-clean cite,.coca-clean code,.coca-clean col,.coca-clean colgroup,.coca-clean datalist,.coca-clean dd,.coca-clean del,.coca-clean dfn,.coca-clean dl,.coca-clean dt,.coca-clean em,.coca-clean fieldset,.coca-clean figcaption,.coca-clean figure,.coca-clean footer,.coca-clean form,.coca-clean h1,.coca-clean h2,.coca-clean h3,.coca-clean h4,.coca-clean h5,.coca-clean h6,.coca-clean header,.coca-clean hr,.coca-clean i,.coca-clean img,.coca-clean input,.coca-clean ins,.coca-clean kbd,.coca-clean label,.coca-clean legend,.coca-clean li,.coca-clean main,.coca-clean map,.coca-clean mark,.coca-clean menu,.coca-clean meta,.coca-clean nav,.coca-clean object,.coca-clean ol,.coca-clean optgroup,.coca-clean option,.coca-clean output,.coca-clean p,.coca-clean pre,.coca-clean progress,.coca-clean q,.coca-clean samp,.coca-clean section,.coca-clean select,.coca-clean small,.coca-clean span,.coca-clean strike,.coca-clean strong,.coca-clean sub,.coca-clean summary,.coca-clean sup,.coca-clean svg,.coca-clean table,.coca-clean tbody,.coca-clean td,.coca-clean textarea,.coca-clean tfoot,.coca-clean th,.coca-clean thead,.coca-clean time,.coca-clean tr,.coca-clean tt,.coca-clean ul,.coca-clean var,.coca-clean video{background-attachment:scroll!important;background-color:transparent!important;background-image:none!important;background-position:0 0!important;background-repeat:repeat!important;border-color:#000!important;border:medium none currentColor!important;bottom:auto!important;clear:none!important;clip:auto!important;color:inherit!important;counter-increment:none!important;counter-reset:none!important;direction:inherit!important;display:inline!important;float:none!important;font-variant:normal!important;height:auto!important;left:auto!important;letter-spacing:normal!important;list-style-type:inherit!important;list-style-position:outside!important;list-style-image:none!important;margin:0!important;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:1;outline:medium none invert!important;overflow:visible!important;padding:0!important;position:static!important;quotes:\"\" \"\"!important;right:auto!important;table-layout:auto!important;text-align:inherit!important;text-decoration:inherit!important;text-indent:0!important;text-transform:none!important;top:auto!important;unicode-bidi:normal!important;vertical-align:baseline!important;visibility:inherit!important;white-space:normal!important;width:auto!important;word-spacing:normal!important;z-index:auto!important;background-origin:padding-box!important;background-clip:border-box!important;background-size:auto!important;border-image:none!important;border-radius:0!important;box-shadow:none!important;box-sizing:content-box!important;column-count:auto!important;column-gap:normal!important;column-rule:medium none #000!important;column-span:1!important;column-width:auto!important;font-feature-settings:normal!important;overflow-x:visible!important;overflow-y:visible!important;-webkit-hyphens:manual!important;-ms-hyphens:manual!important;hyphens:manual!important;-ms-perspective:none!important;-o-perspective:none!important;perspective:none!important;-ms-perspective-origin:50% 50%!important;-o-perspective-origin:50% 50%!important;perspective-origin:50% 50%!important;-webkit-backface-visibility:visible!important;backface-visibility:visible!important;text-shadow:none!important;transition:all 0s ease 0s!important;transform:none!important;transform-origin:50% 50%!important;transform-style:flat!important;word-break:normal!important}.coca-clean,.coca-clean address,.coca-clean article,.coca-clean audio,.coca-clean blockquote,.coca-clean caption,.coca-clean colgroup,.coca-clean dd,.coca-clean dialog,.coca-clean dl,.coca-clean dt,.coca-clean fieldset,.coca-clean figure,.coca-clean footer,.coca-clean form,.coca-clean h1,.coca-clean h2,.coca-clean h3,.coca-clean h4,.coca-clean h5,.coca-clean h6,.coca-clean header,.coca-clean hgroup,.coca-clean hr,.coca-clean main,.coca-clean menu,.coca-clean nav,.coca-clean ol,.coca-clean option,.coca-clean p,.coca-clean pre,.coca-clean progress,.coca-clean section,.coca-clean summary,.coca-clean ul,.coca-clean video{display:block!important}.coca-clean h1{font-size:2em!important}.coca-clean h2{font-size:1.5em!important}.coca-clean h3{font-size:1.17em!important}.coca-clean h4{font-size:1em!important}.coca-clean h5{font-size:.83em!important}.coca-clean p{margin:1em 0!important}.coca-clean table{display:table!important}.coca-clean thead{display:table-header-group!important}.coca-clean tbody{display:table-row-group!important}.coca-clean tfoot{display:table-footer-group!important}.coca-clean tr{display:table-row!important}.coca-clean td,.coca-clean th{display:table-cell!important;padding:2px!important}.coca-clean ol,.coca-clean ul{margin:1em 0!important}.coca-clean ol li,.coca-clean ol ol li,.coca-clean ol ol ol li,.coca-clean ol ol ul li,.coca-clean ol ul ul li,.coca-clean ul li,.coca-clean ul ol ol li,.coca-clean ul ul li,.coca-clean ul ul ol li,.coca-clean ul ul ul li{list-style-position:inside!important;margin-top:.08em!important}.coca-clean ol ol,.coca-clean ol ol ol,.coca-clean ol ol ul,.coca-clean ol ul,.coca-clean ol ul ul,.coca-clean ul ol,.coca-clean ul ol ol,.coca-clean ul ul,.coca-clean ul ul ol,.coca-clean ul ul ul{padding-left:40px!important;margin:0!important}.coca-clean nav ol,.coca-clean nav ul{list-style-type:none!important}.coca-clean menu,.coca-clean ul{list-style-type:disc!important}.coca-clean ol{list-style-type:decimal!important}.coca-clean menu menu,.coca-clean menu ul,.coca-clean ol menu,.coca-clean ol ul,.coca-clean ul menu,.coca-clean ul ul{list-style-type:circle!important}.coca-clean menu menu menu,.coca-clean menu menu ul,.coca-clean menu ol menu,.coca-clean menu ol ul,.coca-clean menu ul menu,.coca-clean menu ul ul,.coca-clean ol menu menu,.coca-clean ol menu ul,.coca-clean ol ol menu,.coca-clean ol ol ul,.coca-clean ol ul menu,.coca-clean ol ul ul,.coca-clean ul menu menu,.coca-clean ul menu ul,.coca-clean ul ol menu,.coca-clean ul ol ul,.coca-clean ul ul menu,.coca-clean ul ul ul{list-style-type:square!important}.coca-clean li{display:list-item!important;min-height:auto!important;min-width:auto!important;padding-left:20px!important}.coca-clean strong{font-weight:700!important}.coca-clean em{font-style:italic!important}.coca-clean code,.coca-clean kbd,.coca-clean pre,.coca-clean samp{font-family:monospace!important}.coca-clean a{color:blue!important;text-decoration:underline!important}.coca-clean a:visited{color:#529!important}.coca-clean a,.coca-clean a *,.coca-clean button,.coca-clean input[type=button],.coca-clean input[type=checkbox],.coca-clean input[type=radio],.coca-clean input[type=submit],.coca-clean select{cursor:pointer!important}.coca-clean button,.coca-clean input[type=submit]{text-align:center!important;padding:2px 6px 3px!important;border-radius:4px!important;text-decoration:none!important;font-family:arial,helvetica,sans-serif!important;font-size:small!important;background:#fff!important;-webkit-appearance:push-button!important;color:buttontext!important;border:1px solid #a6a6a6!important;background:#d3d3d3!important;background:#fff;background:linear-gradient(180deg,#fff 0,#ddd 100%,#d1d1d1 0,#ddd 0)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ffffff\",endColorstr=\"#dddddd\",GradientType=0)!important;-o-box-shadow:1px 1px 0 #eee!important;box-shadow:1px 1px 0 #eee!important;outline:initial!important}.coca-clean button:active,.coca-clean input[type=button]:active,.coca-clean input[type=submit]:active{background:#3b679e!important;background:linear-gradient(180deg,#3b679e 0,#2b88d9 50%,#207cca 51%,#7db9e8)!important;border-color:#5259b0!important}.coca-clean button{padding:1px 6px 2px!important;margin-right:5px!important}.coca-clean input[type=hidden]{display:none!important}.coca-clean textarea{-webkit-appearance:textarea!important;background:#fff!important;padding:2px!important;margin-left:4px!important;word-wrap:break-word!important;white-space:pre-wrap!important;font-size:11px!important;font-family:arial,helvetica,sans-serif!important;line-height:13px!important;resize:both!important}.coca-clean input,.coca-clean select,.coca-clean textarea{border:1px solid #ccc!important}.coca-clean select{font-size:11px!important;font-family:helvetica,arial,sans-serif!important;display:inline-block}.coca-clean input:focus,.coca-clean textarea:focus{outline:5px auto -webkit-focus-ring-color!important;outline:initial!important}.coca-clean input[type=email],.coca-clean input[type=text]{background:#fff!important;padding:1px!important;font-size:small!important}.coca-clean input[type=checkbox],.coca-clean input[type=radio]{border:1px solid #2b2b2b!important;border-radius:4px!important;outline:initial!important}.coca-clean input[type=radio]{margin:2px 2px 3px!important}.coca-clean abbr[title],.coca-clean acronym[title],.coca-clean dfn[title]{cursor:help!important;border-bottom-width:1px!important;border-bottom-style:dotted!important}.coca-clean ins{background-color:#ff9!important;color:#000!important}.coca-clean del{text-decoration:line-through!important}.coca-clean blockquote,.coca-clean q{quotes:none!important}.coca-clean blockquote:after,.coca-clean blockquote:before,.coca-clean li:after,.coca-clean li:before,.coca-clean q:after,.coca-clean q:before{content:\"\"!important}.coca-clean input,.coca-clean select{vertical-align:middle!important}.coca-clean table{border-collapse:collapse!important;border-spacing:0!important}.coca-clean hr{display:block!important;height:1px!important;border:0!important;border-top:1px solid #ccc!important;margin:1em 0!important}.coca-clean [dir=rtl]{direction:rtl!important}.coca-clean mark{background-color:#ff9!important;color:#000!important;font-style:italic!important;font-weight:700!important}.coca-clean menu{padding-left:40px!important;padding-top:8px!important}.coca-clean [hidden],.coca-clean template{display:none!important}.coca-clean abbr[title]{border-bottom:1px dotted!important}.coca-clean sub,.coca-clean sup{font-size:75%!important;line-height:0!important;position:relative!important;vertical-align:baseline!important}.coca-clean sup{top:-.5em!important}.coca-clean sub{bottom:-.25em!important}.coca-clean img{border:0!important}.coca-clean figure{margin:0!important}.coca-clean textarea{overflow:auto!important;vertical-align:top!important}.coca-clean{font-size:medium!important;line-height:1!important;direction:ltr!important;text-align:left!important;text-align:start!important;color:#000!important;font-style:normal!important;font-weight:400!important;text-decoration:none!important;list-style-type:disc!important}.coca-clean pre{white-space:pre!important}", ""]);

	// exports


/***/ }),
/* 118 */
/***/ (function(module, exports) {

	/**
	 * Fuse.js v6.4.6 - Lightweight fuzzy-search (http://fusejs.io)
	 *
	 * Copyright (c) 2021 Kiro Risk (http://kiro.me)
	 * All Rights Reserved. Apache Software License 2.0
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 */

	'use strict';

	function _typeof(obj) {
	  "@babel/helpers - typeof";

	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function (obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function (obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }

	  return _typeof(obj);
	}

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    return;("Cannot call a class as a function");
	  }
	}

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	}

	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);

	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    });
	    keys.push.apply(keys, symbols);
	  }

	  return keys;
	}

	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};

	    if (i % 2) {
	      ownKeys(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }

	  return target;
	}

	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    return;("Super expression must either be null or a function");
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf(subClass, superClass);
	}

	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}

	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };

	  return _setPrototypeOf(o, p);
	}

	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	  if (Reflect.construct.sham) return false;
	  if (typeof Proxy === "function") return true;

	  try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
	    return true;
	  } catch (e) {
	    return false;
	  }
	}

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    return;("this hasn't been initialised - super() hasn't been called");
	  }

	  return self;
	}

	function _possibleConstructorReturn(self, call) {
	  if (call && (typeof call === "object" || typeof call === "function")) {
	    return call;
	  }

	  return _assertThisInitialized(self);
	}

	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();

	  return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;

	    if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;

	      result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }

	    return _possibleConstructorReturn(this, result);
	  };
	}

	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}

	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}

	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}

	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}

	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;

	  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

	  return arr2;
	}

	function _nonIterableSpread() {
	  return;("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}

	function isArray(value) {
	  return !Array.isArray ? getTag(value) === '[object Array]' : Array.isArray(value);
	} // Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js

	var INFINITY = 1 / 0;
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }

	  var result = value + '';
	  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
	}
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	function isString(value) {
	  return typeof value === 'string';
	}
	function isNumber(value) {
	  return typeof value === 'number';
	} // Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js

	function isBoolean(value) {
	  return value === true || value === false || isObjectLike(value) && getTag(value) == '[object Boolean]';
	}
	function isObject(value) {
	  return _typeof(value) === 'object';
	} // Checks if `value` is object-like.

	function isObjectLike(value) {
	  return isObject(value) && value !== null;
	}
	function isDefined(value) {
	  return value !== undefined && value !== null;
	}
	function isBlank(value) {
	  return !value.trim().length;
	} // Gets the `toStringTag` of `value`.
	// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js

	function getTag(value) {
	  return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
	}

	var EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
	var INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
	var LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = function LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key) {
	  return "Invalid value for key ".concat(key);
	};
	var PATTERN_LENGTH_TOO_LARGE = function PATTERN_LENGTH_TOO_LARGE(max) {
	  return "Pattern length exceeds max of ".concat(max, ".");
	};
	var MISSING_KEY_PROPERTY = function MISSING_KEY_PROPERTY(name) {
	  return "Missing ".concat(name, " property in key");
	};
	var INVALID_KEY_WEIGHT_VALUE = function INVALID_KEY_WEIGHT_VALUE(key) {
	  return "Property 'weight' in key '".concat(key, "' must be a positive integer");
	};

	var hasOwn = Object.prototype.hasOwnProperty;

	var KeyStore = /*#__PURE__*/function () {
	  function KeyStore(keys) {
	    var _this = this;

	    _classCallCheck(this, KeyStore);

	    this._keys = [];
	    this._keyMap = {};
	    var totalWeight = 0;
	    keys.forEach(function (key) {
	      var obj = createKey(key);
	      totalWeight += obj.weight;

	      _this._keys.push(obj);

	      _this._keyMap[obj.id] = obj;
	      totalWeight += obj.weight;
	    }); // Normalize weights so that their sum is equal to 1

	    this._keys.forEach(function (key) {
	      key.weight /= totalWeight;
	    });
	  }

	  _createClass(KeyStore, [{
	    key: "get",
	    value: function get(keyId) {
	      return this._keyMap[keyId];
	    }
	  }, {
	    key: "keys",
	    value: function keys() {
	      return this._keys;
	    }
	  }, {
	    key: "toJSON",
	    value: function toJSON() {
	      return JSON.stringify(this._keys);
	    }
	  }]);

	  return KeyStore;
	}();
	function createKey(key) {
	  var path = null;
	  var id = null;
	  var src = null;
	  var weight = 1;

	  if (isString(key) || isArray(key)) {
	    src = key;
	    path = createKeyPath(key);
	    id = createKeyId(key);
	  } else {
	    if (!hasOwn.call(key, 'name')) {
	      throw new Error(MISSING_KEY_PROPERTY('name'));
	    }

	    var name = key.name;
	    src = name;

	    if (hasOwn.call(key, 'weight')) {
	      weight = key.weight;

	      if (weight <= 0) {
	        throw new Error(INVALID_KEY_WEIGHT_VALUE(name));
	      }
	    }

	    path = createKeyPath(name);
	    id = createKeyId(name);
	  }

	  return {
	    path: path,
	    id: id,
	    weight: weight,
	    src: src
	  };
	}
	function createKeyPath(key) {
	  return isArray(key) ? key : key.split('.');
	}
	function createKeyId(key) {
	  return isArray(key) ? key.join('.') : key;
	}

	function get(obj, path) {
	  var list = [];
	  var arr = false;

	  var deepGet = function deepGet(obj, path, index) {
	    if (!isDefined(obj)) {
	      return;
	    }

	    if (!path[index]) {
	      // If there's no path left, we've arrived at the object we care about.
	      list.push(obj);
	    } else {
	      var key = path[index];
	      var value = obj[key];

	      if (!isDefined(value)) {
	        return;
	      } // If we're at the last value in the path, and if it's a string/number/bool,
	      // add it to the list


	      if (index === path.length - 1 && (isString(value) || isNumber(value) || isBoolean(value))) {
	        list.push(toString(value));
	      } else if (isArray(value)) {
	        arr = true; // Search each item in the array.

	        for (var i = 0, len = value.length; i < len; i += 1) {
	          deepGet(value[i], path, index + 1);
	        }
	      } else if (path.length) {
	        // An object. Recurse further.
	        deepGet(value, path, index + 1);
	      }
	    }
	  }; // Backwards compatibility (since path used to be a string)


	  deepGet(obj, isString(path) ? path.split('.') : path, 0);
	  return arr ? list : list[0];
	}

	var MatchOptions = {
	  // Whether the matches should be included in the result set. When `true`, each record in the result
	  // set will include the indices of the matched characters.
	  // These can consequently be used for highlighting purposes.
	  includeMatches: false,
	  // When `true`, the matching function will continue to the end of a search pattern even if
	  // a perfect match has already been located in the string.
	  findAllMatches: false,
	  // Minimum number of characters that must be matched before a result is considered a match
	  minMatchCharLength: 1
	};
	var BasicOptions = {
	  // When `true`, the algorithm continues searching to the end of the input even if a perfect
	  // match is found before the end of the same input.
	  isCaseSensitive: false,
	  // When true, the matching function will continue to the end of a search pattern even if
	  includeScore: false,
	  // List of properties that will be searched. This also supports nested properties.
	  keys: [],
	  // Whether to sort the result list, by score
	  shouldSort: true,
	  // Default sort function: sort by ascending score, ascending index
	  sortFn: function sortFn(a, b) {
	    return a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1;
	  }
	};
	var FuzzyOptions = {
	  // Approximately where in the text is the pattern expected to be found?
	  location: 0,
	  // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
	  // (of both letters and location), a threshold of '1.0' would match anything.
	  threshold: 0.6,
	  // Determines how close the match must be to the fuzzy location (specified above).
	  // An exact letter match which is 'distance' characters away from the fuzzy location
	  // would score as a complete mismatch. A distance of '0' requires the match be at
	  // the exact location specified, a threshold of '1000' would require a perfect match
	  // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
	  distance: 100
	};
	var AdvancedOptions = {
	  // When `true`, it enables the use of unix-like search commands
	  useExtendedSearch: false,
	  // The get function to use when fetching an object's properties.
	  // The default will search nested paths *ie foo.bar.baz*
	  getFn: get,
	  // When `true`, search will ignore `location` and `distance`, so it won't matter
	  // where in the string the pattern appears.
	  // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
	  ignoreLocation: false,
	  // When `true`, the calculation for the relevance score (used for sorting) will
	  // ignore the field-length norm.
	  // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
	  ignoreFieldNorm: false
	};
	var Config = _objectSpread2({}, BasicOptions, {}, MatchOptions, {}, FuzzyOptions, {}, AdvancedOptions);

	var SPACE = /[^ ]+/g; // Field-length norm: the shorter the field, the higher the weight.
	// Set to 3 decimals to reduce index size.

	function norm() {
	  var mantissa = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
	  var cache = new Map();
	  var m = Math.pow(10, mantissa);
	  return {
	    get: function get(value) {
	      var numTokens = value.match(SPACE).length;

	      if (cache.has(numTokens)) {
	        return cache.get(numTokens);
	      }

	      var norm = 1 / Math.sqrt(numTokens); // In place of `toFixed(mantissa)`, for faster computation

	      var n = parseFloat(Math.round(norm * m) / m);
	      cache.set(numTokens, n);
	      return n;
	    },
	    clear: function clear() {
	      cache.clear();
	    }
	  };
	}

	var FuseIndex = /*#__PURE__*/function () {
	  function FuseIndex() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$getFn = _ref.getFn,
	        getFn = _ref$getFn === void 0 ? Config.getFn : _ref$getFn;

	    _classCallCheck(this, FuseIndex);

	    this.norm = norm(3);
	    this.getFn = getFn;
	    this.isCreated = false;
	    this.setIndexRecords();
	  }

	  _createClass(FuseIndex, [{
	    key: "setSources",
	    value: function setSources() {
	      var docs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      this.docs = docs;
	    }
	  }, {
	    key: "setIndexRecords",
	    value: function setIndexRecords() {
	      var records = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      this.records = records;
	    }
	  }, {
	    key: "setKeys",
	    value: function setKeys() {
	      var _this = this;

	      var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      this.keys = keys;
	      this._keysMap = {};
	      keys.forEach(function (key, idx) {
	        _this._keysMap[key.id] = idx;
	      });
	    }
	  }, {
	    key: "create",
	    value: function create() {
	      var _this2 = this;

	      if (this.isCreated || !this.docs.length) {
	        return;
	      }

	      this.isCreated = true; // List is Array<String>

	      if (isString(this.docs[0])) {
	        this.docs.forEach(function (doc, docIndex) {
	          _this2._addString(doc, docIndex);
	        });
	      } else {
	        // List is Array<Object>
	        this.docs.forEach(function (doc, docIndex) {
	          _this2._addObject(doc, docIndex);
	        });
	      }

	      this.norm.clear();
	    } // Adds a doc to the end of the index

	  }, {
	    key: "add",
	    value: function add(doc) {
	      var idx = this.size();

	      if (isString(doc)) {
	        this._addString(doc, idx);
	      } else {
	        this._addObject(doc, idx);
	      }
	    } // Removes the doc at the specified index of the index

	  }, {
	    key: "removeAt",
	    value: function removeAt(idx) {
	      this.records.splice(idx, 1); // Change ref index of every subsquent doc

	      for (var i = idx, len = this.size(); i < len; i += 1) {
	        this.records[i].i -= 1;
	      }
	    }
	  }, {
	    key: "getValueForItemAtKeyId",
	    value: function getValueForItemAtKeyId(item, keyId) {
	      return item[this._keysMap[keyId]];
	    }
	  }, {
	    key: "size",
	    value: function size() {
	      return this.records.length;
	    }
	  }, {
	    key: "_addString",
	    value: function _addString(doc, docIndex) {
	      if (!isDefined(doc) || isBlank(doc)) {
	        return;
	      }

	      var record = {
	        v: doc,
	        i: docIndex,
	        n: this.norm.get(doc)
	      };
	      this.records.push(record);
	    }
	  }, {
	    key: "_addObject",
	    value: function _addObject(doc, docIndex) {
	      var _this3 = this;

	      var record = {
	        i: docIndex,
	        $: {}
	      }; // Iterate over every key (i.e, path), and fetch the value at that key

	      this.keys.forEach(function (key, keyIndex) {
	        // console.log(key)
	        var value = _this3.getFn(doc, key.path);

	        if (!isDefined(value)) {
	          return;
	        }

	        if (isArray(value)) {
	          (function () {
	            var subRecords = [];
	            var stack = [{
	              nestedArrIndex: -1,
	              value: value
	            }];

	            while (stack.length) {
	              var _stack$pop = stack.pop(),
	                  nestedArrIndex = _stack$pop.nestedArrIndex,
	                  _value = _stack$pop.value;

	              if (!isDefined(_value)) {
	                continue;
	              }

	              if (isString(_value) && !isBlank(_value)) {
	                var subRecord = {
	                  v: _value,
	                  i: nestedArrIndex,
	                  n: _this3.norm.get(_value)
	                };
	                subRecords.push(subRecord);
	              } else if (isArray(_value)) {
	                _value.forEach(function (item, k) {
	                  stack.push({
	                    nestedArrIndex: k,
	                    value: item
	                  });
	                });
	              }
	            }

	            record.$[keyIndex] = subRecords;
	          })();
	        } else if (!isBlank(value)) {
	          var subRecord = {
	            v: value,
	            n: _this3.norm.get(value)
	          };
	          record.$[keyIndex] = subRecord;
	        }
	      });
	      this.records.push(record);
	    }
	  }, {
	    key: "toJSON",
	    value: function toJSON() {
	      return {
	        keys: this.keys,
	        records: this.records
	      };
	    }
	  }]);

	  return FuseIndex;
	}();
	function createIndex(keys, docs) {
	  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref2$getFn = _ref2.getFn,
	      getFn = _ref2$getFn === void 0 ? Config.getFn : _ref2$getFn;

	  var myIndex = new FuseIndex({
	    getFn: getFn
	  });
	  myIndex.setKeys(keys.map(createKey));
	  myIndex.setSources(docs);
	  myIndex.create();
	  return myIndex;
	}
	function parseIndex(data) {
	  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref3$getFn = _ref3.getFn,
	      getFn = _ref3$getFn === void 0 ? Config.getFn : _ref3$getFn;

	  var keys = data.keys,
	      records = data.records;
	  var myIndex = new FuseIndex({
	    getFn: getFn
	  });
	  myIndex.setKeys(keys);
	  myIndex.setIndexRecords(records);
	  return myIndex;
	}

	function computeScore(pattern) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$errors = _ref.errors,
	      errors = _ref$errors === void 0 ? 0 : _ref$errors,
	      _ref$currentLocation = _ref.currentLocation,
	      currentLocation = _ref$currentLocation === void 0 ? 0 : _ref$currentLocation,
	      _ref$expectedLocation = _ref.expectedLocation,
	      expectedLocation = _ref$expectedLocation === void 0 ? 0 : _ref$expectedLocation,
	      _ref$distance = _ref.distance,
	      distance = _ref$distance === void 0 ? Config.distance : _ref$distance,
	      _ref$ignoreLocation = _ref.ignoreLocation,
	      ignoreLocation = _ref$ignoreLocation === void 0 ? Config.ignoreLocation : _ref$ignoreLocation;

	  var accuracy = errors / pattern.length;

	  if (ignoreLocation) {
	    return accuracy;
	  }

	  var proximity = Math.abs(expectedLocation - currentLocation);

	  if (!distance) {
	    // Dodge divide by zero error.
	    return proximity ? 1.0 : accuracy;
	  }

	  return accuracy + proximity / distance;
	}

	function convertMaskToIndices() {
	  var matchmask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var minMatchCharLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Config.minMatchCharLength;
	  var indices = [];
	  var start = -1;
	  var end = -1;
	  var i = 0;

	  for (var len = matchmask.length; i < len; i += 1) {
	    var match = matchmask[i];

	    if (match && start === -1) {
	      start = i;
	    } else if (!match && start !== -1) {
	      end = i - 1;

	      if (end - start + 1 >= minMatchCharLength) {
	        indices.push([start, end]);
	      }

	      start = -1;
	    }
	  } // (i-1 - start) + 1 => i - start


	  if (matchmask[i - 1] && i - start >= minMatchCharLength) {
	    indices.push([start, i - 1]);
	  }

	  return indices;
	}

	// Machine word size
	var MAX_BITS = 32;

	function search(text, pattern, patternAlphabet) {
	  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	      _ref$location = _ref.location,
	      location = _ref$location === void 0 ? Config.location : _ref$location,
	      _ref$distance = _ref.distance,
	      distance = _ref$distance === void 0 ? Config.distance : _ref$distance,
	      _ref$threshold = _ref.threshold,
	      threshold = _ref$threshold === void 0 ? Config.threshold : _ref$threshold,
	      _ref$findAllMatches = _ref.findAllMatches,
	      findAllMatches = _ref$findAllMatches === void 0 ? Config.findAllMatches : _ref$findAllMatches,
	      _ref$minMatchCharLeng = _ref.minMatchCharLength,
	      minMatchCharLength = _ref$minMatchCharLeng === void 0 ? Config.minMatchCharLength : _ref$minMatchCharLeng,
	      _ref$includeMatches = _ref.includeMatches,
	      includeMatches = _ref$includeMatches === void 0 ? Config.includeMatches : _ref$includeMatches,
	      _ref$ignoreLocation = _ref.ignoreLocation,
	      ignoreLocation = _ref$ignoreLocation === void 0 ? Config.ignoreLocation : _ref$ignoreLocation;

	  if (pattern.length > MAX_BITS) {
	    throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS));
	  }

	  var patternLen = pattern.length; // Set starting location at beginning text and initialize the alphabet.

	  var textLen = text.length; // Handle the case when location > text.length

	  var expectedLocation = Math.max(0, Math.min(location, textLen)); // Highest score beyond which we give up.

	  var currentThreshold = threshold; // Is there a nearby exact match? (speedup)

	  var bestLocation = expectedLocation; // Performance: only computer matches when the minMatchCharLength > 1
	  // OR if `includeMatches` is true.

	  var computeMatches = minMatchCharLength > 1 || includeMatches; // A mask of the matches, used for building the indices

	  var matchMask = computeMatches ? Array(textLen) : [];
	  var index; // Get all exact matches, here for speed up

	  while ((index = text.indexOf(pattern, bestLocation)) > -1) {
	    var score = computeScore(pattern, {
	      currentLocation: index,
	      expectedLocation: expectedLocation,
	      distance: distance,
	      ignoreLocation: ignoreLocation
	    });
	    currentThreshold = Math.min(score, currentThreshold);
	    bestLocation = index + patternLen;

	    if (computeMatches) {
	      var i = 0;

	      while (i < patternLen) {
	        matchMask[index + i] = 1;
	        i += 1;
	      }
	    }
	  } // Reset the best location


	  bestLocation = -1;
	  var lastBitArr = [];
	  var finalScore = 1;
	  var binMax = patternLen + textLen;
	  var mask = 1 << patternLen - 1;

	  for (var _i = 0; _i < patternLen; _i += 1) {
	    // Scan for the best match; each iteration allows for one more error.
	    // Run a binary search to determine how far from the match location we can stray
	    // at this error level.
	    var binMin = 0;
	    var binMid = binMax;

	    while (binMin < binMid) {
	      var _score2 = computeScore(pattern, {
	        errors: _i,
	        currentLocation: expectedLocation + binMid,
	        expectedLocation: expectedLocation,
	        distance: distance,
	        ignoreLocation: ignoreLocation
	      });

	      if (_score2 <= currentThreshold) {
	        binMin = binMid;
	      } else {
	        binMax = binMid;
	      }

	      binMid = Math.floor((binMax - binMin) / 2 + binMin);
	    } // Use the result from this iteration as the maximum for the next.


	    binMax = binMid;
	    var start = Math.max(1, expectedLocation - binMid + 1);
	    var finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen; // Initialize the bit array

	    var bitArr = Array(finish + 2);
	    bitArr[finish + 1] = (1 << _i) - 1;

	    for (var j = finish; j >= start; j -= 1) {
	      var currentLocation = j - 1;
	      var charMatch = patternAlphabet[text.charAt(currentLocation)];

	      if (computeMatches) {
	        // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
	        matchMask[currentLocation] = +!!charMatch;
	      } // First pass: exact match


	      bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch; // Subsequent passes: fuzzy match

	      if (_i) {
	        bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
	      }

	      if (bitArr[j] & mask) {
	        finalScore = computeScore(pattern, {
	          errors: _i,
	          currentLocation: currentLocation,
	          expectedLocation: expectedLocation,
	          distance: distance,
	          ignoreLocation: ignoreLocation
	        }); // This match will almost certainly be better than any existing match.
	        // But check anyway.

	        if (finalScore <= currentThreshold) {
	          // Indeed it is
	          currentThreshold = finalScore;
	          bestLocation = currentLocation; // Already passed `loc`, downhill from here on in.

	          if (bestLocation <= expectedLocation) {
	            break;
	          } // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.


	          start = Math.max(1, 2 * expectedLocation - bestLocation);
	        }
	      }
	    } // No hope for a (better) match at greater error levels.


	    var _score = computeScore(pattern, {
	      errors: _i + 1,
	      currentLocation: expectedLocation,
	      expectedLocation: expectedLocation,
	      distance: distance,
	      ignoreLocation: ignoreLocation
	    });

	    if (_score > currentThreshold) {
	      break;
	    }

	    lastBitArr = bitArr;
	  }

	  var result = {
	    isMatch: bestLocation >= 0,
	    // Count exact matches (those with a score of 0) to be "almost" exact
	    score: Math.max(0.001, finalScore)
	  };

	  if (computeMatches) {
	    var indices = convertMaskToIndices(matchMask, minMatchCharLength);

	    if (!indices.length) {
	      result.isMatch = false;
	    } else if (includeMatches) {
	      result.indices = indices;
	    }
	  }

	  return result;
	}

	function createPatternAlphabet(pattern) {
	  var mask = {};

	  for (var i = 0, len = pattern.length; i < len; i += 1) {
	    var char = pattern.charAt(i);
	    mask[char] = (mask[char] || 0) | 1 << len - i - 1;
	  }

	  return mask;
	}

	var BitapSearch = /*#__PURE__*/function () {
	  function BitapSearch(pattern) {
	    var _this = this;

	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        _ref$location = _ref.location,
	        location = _ref$location === void 0 ? Config.location : _ref$location,
	        _ref$threshold = _ref.threshold,
	        threshold = _ref$threshold === void 0 ? Config.threshold : _ref$threshold,
	        _ref$distance = _ref.distance,
	        distance = _ref$distance === void 0 ? Config.distance : _ref$distance,
	        _ref$includeMatches = _ref.includeMatches,
	        includeMatches = _ref$includeMatches === void 0 ? Config.includeMatches : _ref$includeMatches,
	        _ref$findAllMatches = _ref.findAllMatches,
	        findAllMatches = _ref$findAllMatches === void 0 ? Config.findAllMatches : _ref$findAllMatches,
	        _ref$minMatchCharLeng = _ref.minMatchCharLength,
	        minMatchCharLength = _ref$minMatchCharLeng === void 0 ? Config.minMatchCharLength : _ref$minMatchCharLeng,
	        _ref$isCaseSensitive = _ref.isCaseSensitive,
	        isCaseSensitive = _ref$isCaseSensitive === void 0 ? Config.isCaseSensitive : _ref$isCaseSensitive,
	        _ref$ignoreLocation = _ref.ignoreLocation,
	        ignoreLocation = _ref$ignoreLocation === void 0 ? Config.ignoreLocation : _ref$ignoreLocation;

	    _classCallCheck(this, BitapSearch);

	    this.options = {
	      location: location,
	      threshold: threshold,
	      distance: distance,
	      includeMatches: includeMatches,
	      findAllMatches: findAllMatches,
	      minMatchCharLength: minMatchCharLength,
	      isCaseSensitive: isCaseSensitive,
	      ignoreLocation: ignoreLocation
	    };
	    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
	    this.chunks = [];

	    if (!this.pattern.length) {
	      return;
	    }

	    var addChunk = function addChunk(pattern, startIndex) {
	      _this.chunks.push({
	        pattern: pattern,
	        alphabet: createPatternAlphabet(pattern),
	        startIndex: startIndex
	      });
	    };

	    var len = this.pattern.length;

	    if (len > MAX_BITS) {
	      var i = 0;
	      var remainder = len % MAX_BITS;
	      var end = len - remainder;

	      while (i < end) {
	        addChunk(this.pattern.substr(i, MAX_BITS), i);
	        i += MAX_BITS;
	      }

	      if (remainder) {
	        var startIndex = len - MAX_BITS;
	        addChunk(this.pattern.substr(startIndex), startIndex);
	      }
	    } else {
	      addChunk(this.pattern, 0);
	    }
	  }

	  _createClass(BitapSearch, [{
	    key: "searchIn",
	    value: function searchIn(text) {
	      var _this$options = this.options,
	          isCaseSensitive = _this$options.isCaseSensitive,
	          includeMatches = _this$options.includeMatches;

	      if (!isCaseSensitive) {
	        text = text.toLowerCase();
	      } // Exact match


	      if (this.pattern === text) {
	        var _result = {
	          isMatch: true,
	          score: 0
	        };

	        if (includeMatches) {
	          _result.indices = [[0, text.length - 1]];
	        }

	        return _result;
	      } // Otherwise, use Bitap algorithm


	      var _this$options2 = this.options,
	          location = _this$options2.location,
	          distance = _this$options2.distance,
	          threshold = _this$options2.threshold,
	          findAllMatches = _this$options2.findAllMatches,
	          minMatchCharLength = _this$options2.minMatchCharLength,
	          ignoreLocation = _this$options2.ignoreLocation;
	      var allIndices = [];
	      var totalScore = 0;
	      var hasMatches = false;
	      this.chunks.forEach(function (_ref2) {
	        var pattern = _ref2.pattern,
	            alphabet = _ref2.alphabet,
	            startIndex = _ref2.startIndex;

	        var _search = search(text, pattern, alphabet, {
	          location: location + startIndex,
	          distance: distance,
	          threshold: threshold,
	          findAllMatches: findAllMatches,
	          minMatchCharLength: minMatchCharLength,
	          includeMatches: includeMatches,
	          ignoreLocation: ignoreLocation
	        }),
	            isMatch = _search.isMatch,
	            score = _search.score,
	            indices = _search.indices;

	        if (isMatch) {
	          hasMatches = true;
	        }

	        totalScore += score;

	        if (isMatch && indices) {
	          allIndices = [].concat(_toConsumableArray(allIndices), _toConsumableArray(indices));
	        }
	      });
	      var result = {
	        isMatch: hasMatches,
	        score: hasMatches ? totalScore / this.chunks.length : 1
	      };

	      if (hasMatches && includeMatches) {
	        result.indices = allIndices;
	      }

	      return result;
	    }
	  }]);

	  return BitapSearch;
	}();

	var BaseMatch = /*#__PURE__*/function () {
	  function BaseMatch(pattern) {
	    _classCallCheck(this, BaseMatch);

	    this.pattern = pattern;
	  }

	  _createClass(BaseMatch, [{
	    key: "search",
	    value: function search()
	    /*text*/
	    {}
	  }], [{
	    key: "isMultiMatch",
	    value: function isMultiMatch(pattern) {
	      return getMatch(pattern, this.multiRegex);
	    }
	  }, {
	    key: "isSingleMatch",
	    value: function isSingleMatch(pattern) {
	      return getMatch(pattern, this.singleRegex);
	    }
	  }]);

	  return BaseMatch;
	}();

	function getMatch(pattern, exp) {
	  var matches = pattern.match(exp);
	  return matches ? matches[1] : null;
	}

	var ExactMatch = /*#__PURE__*/function (_BaseMatch) {
	  _inherits(ExactMatch, _BaseMatch);

	  var _super = _createSuper(ExactMatch);

	  function ExactMatch(pattern) {
	    _classCallCheck(this, ExactMatch);

	    return _super.call(this, pattern);
	  }

	  _createClass(ExactMatch, [{
	    key: "search",
	    value: function search(text) {
	      var isMatch = text === this.pattern;
	      return {
	        isMatch: isMatch,
	        score: isMatch ? 0 : 1,
	        indices: [0, this.pattern.length - 1]
	      };
	    }
	  }], [{
	    key: "type",
	    get: function get() {
	      return 'exact';
	    }
	  }, {
	    key: "multiRegex",
	    get: function get() {
	      return /^="(.*)"$/;
	    }
	  }, {
	    key: "singleRegex",
	    get: function get() {
	      return /^=(.*)$/;
	    }
	  }]);

	  return ExactMatch;
	}(BaseMatch);

	var InverseExactMatch = /*#__PURE__*/function (_BaseMatch) {
	  _inherits(InverseExactMatch, _BaseMatch);

	  var _super = _createSuper(InverseExactMatch);

	  function InverseExactMatch(pattern) {
	    _classCallCheck(this, InverseExactMatch);

	    return _super.call(this, pattern);
	  }

	  _createClass(InverseExactMatch, [{
	    key: "search",
	    value: function search(text) {
	      var index = text.indexOf(this.pattern);
	      var isMatch = index === -1;
	      return {
	        isMatch: isMatch,
	        score: isMatch ? 0 : 1,
	        indices: [0, text.length - 1]
	      };
	    }
	  }], [{
	    key: "type",
	    get: function get() {
	      return 'inverse-exact';
	    }
	  }, {
	    key: "multiRegex",
	    get: function get() {
	      return /^!"(.*)"$/;
	    }
	  }, {
	    key: "singleRegex",
	    get: function get() {
	      return /^!(.*)$/;
	    }
	  }]);

	  return InverseExactMatch;
	}(BaseMatch);

	var PrefixExactMatch = /*#__PURE__*/function (_BaseMatch) {
	  _inherits(PrefixExactMatch, _BaseMatch);

	  var _super = _createSuper(PrefixExactMatch);

	  function PrefixExactMatch(pattern) {
	    _classCallCheck(this, PrefixExactMatch);

	    return _super.call(this, pattern);
	  }

	  _createClass(PrefixExactMatch, [{
	    key: "search",
	    value: function search(text) {
	      var isMatch = text.startsWith(this.pattern);
	      return {
	        isMatch: isMatch,
	        score: isMatch ? 0 : 1,
	        indices: [0, this.pattern.length - 1]
	      };
	    }
	  }], [{
	    key: "type",
	    get: function get() {
	      return 'prefix-exact';
	    }
	  }, {
	    key: "multiRegex",
	    get: function get() {
	      return /^\^"(.*)"$/;
	    }
	  }, {
	    key: "singleRegex",
	    get: function get() {
	      return /^\^(.*)$/;
	    }
	  }]);

	  return PrefixExactMatch;
	}(BaseMatch);

	var InversePrefixExactMatch = /*#__PURE__*/function (_BaseMatch) {
	  _inherits(InversePrefixExactMatch, _BaseMatch);

	  var _super = _createSuper(InversePrefixExactMatch);

	  function InversePrefixExactMatch(pattern) {
	    _classCallCheck(this, InversePrefixExactMatch);

	    return _super.call(this, pattern);
	  }

	  _createClass(InversePrefixExactMatch, [{
	    key: "search",
	    value: function search(text) {
	      var isMatch = !text.startsWith(this.pattern);
	      return {
	        isMatch: isMatch,
	        score: isMatch ? 0 : 1,
	        indices: [0, text.length - 1]
	      };
	    }
	  }], [{
	    key: "type",
	    get: function get() {
	      return 'inverse-prefix-exact';
	    }
	  }, {
	    key: "multiRegex",
	    get: function get() {
	      return /^!\^"(.*)"$/;
	    }
	  }, {
	    key: "singleRegex",
	    get: function get() {
	      return /^!\^(.*)$/;
	    }
	  }]);

	  return InversePrefixExactMatch;
	}(BaseMatch);

	var SuffixExactMatch = /*#__PURE__*/function (_BaseMatch) {
	  _inherits(SuffixExactMatch, _BaseMatch);

	  var _super = _createSuper(SuffixExactMatch);

	  function SuffixExactMatch(pattern) {
	    _classCallCheck(this, SuffixExactMatch);

	    return _super.call(this, pattern);
	  }

	  _createClass(SuffixExactMatch, [{
	    key: "search",
	    value: function search(text) {
	      var isMatch = text.endsWith(this.pattern);
	      return {
	        isMatch: isMatch,
	        score: isMatch ? 0 : 1,
	        indices: [text.length - this.pattern.length, text.length - 1]
	      };
	    }
	  }], [{
	    key: "type",
	    get: function get() {
	      return 'suffix-exact';
	    }
	  }, {
	    key: "multiRegex",
	    get: function get() {
	      return /^"(.*)"\$$/;
	    }
	  }, {
	    key: "singleRegex",
	    get: function get() {
	      return /^(.*)\$$/;
	    }
	  }]);

	  return SuffixExactMatch;
	}(BaseMatch);

	var InverseSuffixExactMatch = /*#__PURE__*/function (_BaseMatch) {
	  _inherits(InverseSuffixExactMatch, _BaseMatch);

	  var _super = _createSuper(InverseSuffixExactMatch);

	  function InverseSuffixExactMatch(pattern) {
	    _classCallCheck(this, InverseSuffixExactMatch);

	    return _super.call(this, pattern);
	  }

	  _createClass(InverseSuffixExactMatch, [{
	    key: "search",
	    value: function search(text) {
	      var isMatch = !text.endsWith(this.pattern);
	      return {
	        isMatch: isMatch,
	        score: isMatch ? 0 : 1,
	        indices: [0, text.length - 1]
	      };
	    }
	  }], [{
	    key: "type",
	    get: function get() {
	      return 'inverse-suffix-exact';
	    }
	  }, {
	    key: "multiRegex",
	    get: function get() {
	      return /^!"(.*)"\$$/;
	    }
	  }, {
	    key: "singleRegex",
	    get: function get() {
	      return /^!(.*)\$$/;
	    }
	  }]);

	  return InverseSuffixExactMatch;
	}(BaseMatch);

	var FuzzyMatch = /*#__PURE__*/function (_BaseMatch) {
	  _inherits(FuzzyMatch, _BaseMatch);

	  var _super = _createSuper(FuzzyMatch);

	  function FuzzyMatch(pattern) {
	    var _this;

	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        _ref$location = _ref.location,
	        location = _ref$location === void 0 ? Config.location : _ref$location,
	        _ref$threshold = _ref.threshold,
	        threshold = _ref$threshold === void 0 ? Config.threshold : _ref$threshold,
	        _ref$distance = _ref.distance,
	        distance = _ref$distance === void 0 ? Config.distance : _ref$distance,
	        _ref$includeMatches = _ref.includeMatches,
	        includeMatches = _ref$includeMatches === void 0 ? Config.includeMatches : _ref$includeMatches,
	        _ref$findAllMatches = _ref.findAllMatches,
	        findAllMatches = _ref$findAllMatches === void 0 ? Config.findAllMatches : _ref$findAllMatches,
	        _ref$minMatchCharLeng = _ref.minMatchCharLength,
	        minMatchCharLength = _ref$minMatchCharLeng === void 0 ? Config.minMatchCharLength : _ref$minMatchCharLeng,
	        _ref$isCaseSensitive = _ref.isCaseSensitive,
	        isCaseSensitive = _ref$isCaseSensitive === void 0 ? Config.isCaseSensitive : _ref$isCaseSensitive,
	        _ref$ignoreLocation = _ref.ignoreLocation,
	        ignoreLocation = _ref$ignoreLocation === void 0 ? Config.ignoreLocation : _ref$ignoreLocation;

	    _classCallCheck(this, FuzzyMatch);

	    _this = _super.call(this, pattern);
	    _this._bitapSearch = new BitapSearch(pattern, {
	      location: location,
	      threshold: threshold,
	      distance: distance,
	      includeMatches: includeMatches,
	      findAllMatches: findAllMatches,
	      minMatchCharLength: minMatchCharLength,
	      isCaseSensitive: isCaseSensitive,
	      ignoreLocation: ignoreLocation
	    });
	    return _this;
	  }

	  _createClass(FuzzyMatch, [{
	    key: "search",
	    value: function search(text) {
	      return this._bitapSearch.searchIn(text);
	    }
	  }], [{
	    key: "type",
	    get: function get() {
	      return 'fuzzy';
	    }
	  }, {
	    key: "multiRegex",
	    get: function get() {
	      return /^"(.*)"$/;
	    }
	  }, {
	    key: "singleRegex",
	    get: function get() {
	      return /^(.*)$/;
	    }
	  }]);

	  return FuzzyMatch;
	}(BaseMatch);

	var IncludeMatch = /*#__PURE__*/function (_BaseMatch) {
	  _inherits(IncludeMatch, _BaseMatch);

	  var _super = _createSuper(IncludeMatch);

	  function IncludeMatch(pattern) {
	    _classCallCheck(this, IncludeMatch);

	    return _super.call(this, pattern);
	  }

	  _createClass(IncludeMatch, [{
	    key: "search",
	    value: function search(text) {
	      var location = 0;
	      var index;
	      var indices = [];
	      var patternLen = this.pattern.length; // Get all exact matches

	      while ((index = text.indexOf(this.pattern, location)) > -1) {
	        location = index + patternLen;
	        indices.push([index, location - 1]);
	      }

	      var isMatch = !!indices.length;
	      return {
	        isMatch: isMatch,
	        score: isMatch ? 0 : 1,
	        indices: indices
	      };
	    }
	  }], [{
	    key: "type",
	    get: function get() {
	      return 'include';
	    }
	  }, {
	    key: "multiRegex",
	    get: function get() {
	      return /^'"(.*)"$/;
	    }
	  }, {
	    key: "singleRegex",
	    get: function get() {
	      return /^'(.*)$/;
	    }
	  }]);

	  return IncludeMatch;
	}(BaseMatch);

	var searchers = [ExactMatch, IncludeMatch, PrefixExactMatch, InversePrefixExactMatch, InverseSuffixExactMatch, SuffixExactMatch, InverseExactMatch, FuzzyMatch];
	var searchersLen = searchers.length; // Regex to split by spaces, but keep anything in quotes together

	var SPACE_RE = / +(?=([^\"]*\"[^\"]*\")*[^\"]*$)/;
	var OR_TOKEN = '|'; // Return a 2D array representation of the query, for simpler parsing.
	// Example:
	// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]

	function parseQuery(pattern) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return pattern.split(OR_TOKEN).map(function (item) {
	    var query = item.trim().split(SPACE_RE).filter(function (item) {
	      return item && !!item.trim();
	    });
	    var results = [];

	    for (var i = 0, len = query.length; i < len; i += 1) {
	      var queryItem = query[i]; // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)

	      var found = false;
	      var idx = -1;

	      while (!found && ++idx < searchersLen) {
	        var searcher = searchers[idx];
	        var token = searcher.isMultiMatch(queryItem);

	        if (token) {
	          results.push(new searcher(token, options));
	          found = true;
	        }
	      }

	      if (found) {
	        continue;
	      } // 2. Handle single query matches (i.e, once that are *not* quoted)


	      idx = -1;

	      while (++idx < searchersLen) {
	        var _searcher = searchers[idx];

	        var _token = _searcher.isSingleMatch(queryItem);

	        if (_token) {
	          results.push(new _searcher(_token, options));
	          break;
	        }
	      }
	    }

	    return results;
	  });
	}

	// to a singl match

	var MultiMatchSet = new Set([FuzzyMatch.type, IncludeMatch.type]);
	/**
	 * Command-like searching
	 * ======================
	 *
	 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
	 * search in a given text.
	 *
	 * Search syntax:
	 *
	 * | Token       | Match type                 | Description                            |
	 * | ----------- | -------------------------- | -------------------------------------- |
	 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
	 * | `=scheme`   | exact-match                | Items that are `scheme`                |
	 * | `'python`   | include-match              | Items that include `python`            |
	 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
	 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
	 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
	 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
	 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
	 *
	 * A single pipe character acts as an OR operator. For example, the following
	 * query matches entries that start with `core` and end with either`go`, `rb`,
	 * or`py`.
	 *
	 * ```
	 * ^core go$ | rb$ | py$
	 * ```
	 */

	var ExtendedSearch = /*#__PURE__*/function () {
	  function ExtendedSearch(pattern) {
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        _ref$isCaseSensitive = _ref.isCaseSensitive,
	        isCaseSensitive = _ref$isCaseSensitive === void 0 ? Config.isCaseSensitive : _ref$isCaseSensitive,
	        _ref$includeMatches = _ref.includeMatches,
	        includeMatches = _ref$includeMatches === void 0 ? Config.includeMatches : _ref$includeMatches,
	        _ref$minMatchCharLeng = _ref.minMatchCharLength,
	        minMatchCharLength = _ref$minMatchCharLeng === void 0 ? Config.minMatchCharLength : _ref$minMatchCharLeng,
	        _ref$ignoreLocation = _ref.ignoreLocation,
	        ignoreLocation = _ref$ignoreLocation === void 0 ? Config.ignoreLocation : _ref$ignoreLocation,
	        _ref$findAllMatches = _ref.findAllMatches,
	        findAllMatches = _ref$findAllMatches === void 0 ? Config.findAllMatches : _ref$findAllMatches,
	        _ref$location = _ref.location,
	        location = _ref$location === void 0 ? Config.location : _ref$location,
	        _ref$threshold = _ref.threshold,
	        threshold = _ref$threshold === void 0 ? Config.threshold : _ref$threshold,
	        _ref$distance = _ref.distance,
	        distance = _ref$distance === void 0 ? Config.distance : _ref$distance;

	    _classCallCheck(this, ExtendedSearch);

	    this.query = null;
	    this.options = {
	      isCaseSensitive: isCaseSensitive,
	      includeMatches: includeMatches,
	      minMatchCharLength: minMatchCharLength,
	      findAllMatches: findAllMatches,
	      ignoreLocation: ignoreLocation,
	      location: location,
	      threshold: threshold,
	      distance: distance
	    };
	    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
	    this.query = parseQuery(this.pattern, this.options);
	  }

	  _createClass(ExtendedSearch, [{
	    key: "searchIn",
	    value: function searchIn(text) {
	      var query = this.query;

	      if (!query) {
	        return {
	          isMatch: false,
	          score: 1
	        };
	      }

	      var _this$options = this.options,
	          includeMatches = _this$options.includeMatches,
	          isCaseSensitive = _this$options.isCaseSensitive;
	      text = isCaseSensitive ? text : text.toLowerCase();
	      var numMatches = 0;
	      var allIndices = [];
	      var totalScore = 0; // ORs

	      for (var i = 0, qLen = query.length; i < qLen; i += 1) {
	        var searchers = query[i]; // Reset indices

	        allIndices.length = 0;
	        numMatches = 0; // ANDs

	        for (var j = 0, pLen = searchers.length; j < pLen; j += 1) {
	          var searcher = searchers[j];

	          var _searcher$search = searcher.search(text),
	              isMatch = _searcher$search.isMatch,
	              indices = _searcher$search.indices,
	              score = _searcher$search.score;

	          if (isMatch) {
	            numMatches += 1;
	            totalScore += score;

	            if (includeMatches) {
	              var type = searcher.constructor.type;

	              if (MultiMatchSet.has(type)) {
	                allIndices = [].concat(_toConsumableArray(allIndices), _toConsumableArray(indices));
	              } else {
	                allIndices.push(indices);
	              }
	            }
	          } else {
	            totalScore = 0;
	            numMatches = 0;
	            allIndices.length = 0;
	            break;
	          }
	        } // OR condition, so if TRUE, return


	        if (numMatches) {
	          var result = {
	            isMatch: true,
	            score: totalScore / numMatches
	          };

	          if (includeMatches) {
	            result.indices = allIndices;
	          }

	          return result;
	        }
	      } // Nothing was matched


	      return {
	        isMatch: false,
	        score: 1
	      };
	    }
	  }], [{
	    key: "condition",
	    value: function condition(_, options) {
	      return options.useExtendedSearch;
	    }
	  }]);

	  return ExtendedSearch;
	}();

	var registeredSearchers = [];
	function register() {
	  registeredSearchers.push.apply(registeredSearchers, arguments);
	}
	function createSearcher(pattern, options) {
	  for (var i = 0, len = registeredSearchers.length; i < len; i += 1) {
	    var searcherClass = registeredSearchers[i];

	    if (searcherClass.condition(pattern, options)) {
	      return new searcherClass(pattern, options);
	    }
	  }

	  return new BitapSearch(pattern, options);
	}

	var LogicalOperator = {
	  AND: '$and',
	  OR: '$or'
	};
	var KeyType = {
	  PATH: '$path',
	  PATTERN: '$val'
	};

	var isExpression = function isExpression(query) {
	  return !!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);
	};

	var isPath = function isPath(query) {
	  return !!query[KeyType.PATH];
	};

	var isLeaf = function isLeaf(query) {
	  return !isArray(query) && isObject(query) && !isExpression(query);
	};

	var convertToExplicit = function convertToExplicit(query) {
	  return _defineProperty({}, LogicalOperator.AND, Object.keys(query).map(function (key) {
	    return _defineProperty({}, key, query[key]);
	  }));
	}; // When `auto` is `true`, the parse function will infer and initialize and add
	// the appropriate `Searcher` instance


	function parse(query, options) {
	  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref3$auto = _ref3.auto,
	      auto = _ref3$auto === void 0 ? true : _ref3$auto;

	  var next = function next(query) {
	    var keys = Object.keys(query);
	    var isQueryPath = isPath(query);

	    if (!isQueryPath && keys.length > 1 && !isExpression(query)) {
	      return next(convertToExplicit(query));
	    }

	    if (isLeaf(query)) {
	      var key = isQueryPath ? query[KeyType.PATH] : keys[0];
	      var pattern = isQueryPath ? query[KeyType.PATTERN] : query[key];

	      if (!isString(pattern)) {
	        throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
	      }

	      var obj = {
	        keyId: createKeyId(key),
	        pattern: pattern
	      };

	      if (auto) {
	        obj.searcher = createSearcher(pattern, options);
	      }

	      return obj;
	    }

	    var node = {
	      children: [],
	      operator: keys[0]
	    };
	    keys.forEach(function (key) {
	      var value = query[key];

	      if (isArray(value)) {
	        value.forEach(function (item) {
	          node.children.push(next(item));
	        });
	      }
	    });
	    return node;
	  };

	  if (!isExpression(query)) {
	    query = convertToExplicit(query);
	  }

	  return next(query);
	}

	function computeScore$1(results, _ref) {
	  var _ref$ignoreFieldNorm = _ref.ignoreFieldNorm,
	      ignoreFieldNorm = _ref$ignoreFieldNorm === void 0 ? Config.ignoreFieldNorm : _ref$ignoreFieldNorm;
	  results.forEach(function (result) {
	    var totalScore = 1;
	    result.matches.forEach(function (_ref2) {
	      var key = _ref2.key,
	          norm = _ref2.norm,
	          score = _ref2.score;
	      var weight = key ? key.weight : null;
	      totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
	    });
	    result.score = totalScore;
	  });
	}

	function transformMatches(result, data) {
	  var matches = result.matches;
	  data.matches = [];

	  if (!isDefined(matches)) {
	    return;
	  }

	  matches.forEach(function (match) {
	    if (!isDefined(match.indices) || !match.indices.length) {
	      return;
	    }

	    var indices = match.indices,
	        value = match.value;
	    var obj = {
	      indices: indices,
	      value: value
	    };

	    if (match.key) {
	      obj.key = match.key.src;
	    }

	    if (match.idx > -1) {
	      obj.refIndex = match.idx;
	    }

	    data.matches.push(obj);
	  });
	}

	function transformScore(result, data) {
	  data.score = result.score;
	}

	function format(results, docs) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$includeMatches = _ref.includeMatches,
	      includeMatches = _ref$includeMatches === void 0 ? Config.includeMatches : _ref$includeMatches,
	      _ref$includeScore = _ref.includeScore,
	      includeScore = _ref$includeScore === void 0 ? Config.includeScore : _ref$includeScore;

	  var transformers = [];
	  if (includeMatches) transformers.push(transformMatches);
	  if (includeScore) transformers.push(transformScore);
	  return results.map(function (result) {
	    var idx = result.idx;
	    var data = {
	      item: docs[idx],
	      refIndex: idx
	    };

	    if (transformers.length) {
	      transformers.forEach(function (transformer) {
	        transformer(result, data);
	      });
	    }

	    return data;
	  });
	}

	var Fuse = /*#__PURE__*/function () {
	  function Fuse(docs) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var index = arguments.length > 2 ? arguments[2] : undefined;

	    _classCallCheck(this, Fuse);

	    this.options = _objectSpread2({}, Config, {}, options);

	    if (this.options.useExtendedSearch && !true) {
	      throw new Error(EXTENDED_SEARCH_UNAVAILABLE);
	    }

	    this._keyStore = new KeyStore(this.options.keys);
	    this.setCollection(docs, index);
	  }

	  _createClass(Fuse, [{
	    key: "setCollection",
	    value: function setCollection(docs, index) {
	      this._docs = docs;

	      if (index && !(index instanceof FuseIndex)) {
	        throw new Error(INCORRECT_INDEX_TYPE);
	      }

	      this._myIndex = index || createIndex(this.options.keys, this._docs, {
	        getFn: this.options.getFn
	      });
	    }
	  }, {
	    key: "add",
	    value: function add(doc) {
	      if (!isDefined(doc)) {
	        return;
	      }

	      this._docs.push(doc);

	      this._myIndex.add(doc);
	    }
	  }, {
	    key: "remove",
	    value: function remove() {
	      var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
	        return (
	          /* doc, idx */
	          false
	        );
	      };
	      var results = [];

	      for (var i = 0, len = this._docs.length; i < len; i += 1) {
	        var doc = this._docs[i];

	        if (predicate(doc, i)) {
	          this.removeAt(i);
	          i -= 1;
	          len -= 1;
	          results.push(doc);
	        }
	      }

	      return results;
	    }
	  }, {
	    key: "removeAt",
	    value: function removeAt(idx) {
	      this._docs.splice(idx, 1);

	      this._myIndex.removeAt(idx);
	    }
	  }, {
	    key: "getIndex",
	    value: function getIndex() {
	      return this._myIndex;
	    }
	  }, {
	    key: "search",
	    value: function search(query) {
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          _ref$limit = _ref.limit,
	          limit = _ref$limit === void 0 ? -1 : _ref$limit;

	      var _this$options = this.options,
	          includeMatches = _this$options.includeMatches,
	          includeScore = _this$options.includeScore,
	          shouldSort = _this$options.shouldSort,
	          sortFn = _this$options.sortFn,
	          ignoreFieldNorm = _this$options.ignoreFieldNorm;
	      var results = isString(query) ? isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
	      computeScore$1(results, {
	        ignoreFieldNorm: ignoreFieldNorm
	      });

	      if (shouldSort) {
	        results.sort(sortFn);
	      }

	      if (isNumber(limit) && limit > -1) {
	        results = results.slice(0, limit);
	      }

	      return format(results, this._docs, {
	        includeMatches: includeMatches,
	        includeScore: includeScore
	      });
	    }
	  }, {
	    key: "_searchStringList",
	    value: function _searchStringList(query) {
	      var searcher = createSearcher(query, this.options);
	      var records = this._myIndex.records;
	      var results = []; // Iterate over every string in the index

	      records.forEach(function (_ref2) {
	        var text = _ref2.v,
	            idx = _ref2.i,
	            norm = _ref2.n;

	        if (!isDefined(text)) {
	          return;
	        }

	        var _searcher$searchIn = searcher.searchIn(text),
	            isMatch = _searcher$searchIn.isMatch,
	            score = _searcher$searchIn.score,
	            indices = _searcher$searchIn.indices;

	        if (isMatch) {
	          results.push({
	            item: text,
	            idx: idx,
	            matches: [{
	              score: score,
	              value: text,
	              norm: norm,
	              indices: indices
	            }]
	          });
	        }
	      });
	      return results;
	    }
	  }, {
	    key: "_searchLogical",
	    value: function _searchLogical(query) {
	      var _this = this;

	      var expression = parse(query, this.options);

	      var evaluate = function evaluate(node, item, idx) {
	        if (!node.children) {
	          var keyId = node.keyId,
	              searcher = node.searcher;

	          var matches = _this._findMatches({
	            key: _this._keyStore.get(keyId),
	            value: _this._myIndex.getValueForItemAtKeyId(item, keyId),
	            searcher: searcher
	          });

	          if (matches && matches.length) {
	            return [{
	              idx: idx,
	              item: item,
	              matches: matches
	            }];
	          }

	          return [];
	        }
	        /*eslint indent: [2, 2, {"SwitchCase": 1}]*/


	        switch (node.operator) {
	          case LogicalOperator.AND:
	            {
	              var res = [];

	              for (var i = 0, len = node.children.length; i < len; i += 1) {
	                var child = node.children[i];
	                var result = evaluate(child, item, idx);

	                if (result.length) {
	                  res.push.apply(res, _toConsumableArray(result));
	                } else {
	                  return [];
	                }
	              }

	              return res;
	            }

	          case LogicalOperator.OR:
	            {
	              var _res = [];

	              for (var _i = 0, _len = node.children.length; _i < _len; _i += 1) {
	                var _child = node.children[_i];

	                var _result = evaluate(_child, item, idx);

	                if (_result.length) {
	                  _res.push.apply(_res, _toConsumableArray(_result));

	                  break;
	                }
	              }

	              return _res;
	            }
	        }
	      };

	      var records = this._myIndex.records;
	      var resultMap = {};
	      var results = [];
	      records.forEach(function (_ref3) {
	        var item = _ref3.$,
	            idx = _ref3.i;

	        if (isDefined(item)) {
	          var expResults = evaluate(expression, item, idx);

	          if (expResults.length) {
	            // Dedupe when adding
	            if (!resultMap[idx]) {
	              resultMap[idx] = {
	                idx: idx,
	                item: item,
	                matches: []
	              };
	              results.push(resultMap[idx]);
	            }

	            expResults.forEach(function (_ref4) {
	              var _resultMap$idx$matche;

	              var matches = _ref4.matches;

	              (_resultMap$idx$matche = resultMap[idx].matches).push.apply(_resultMap$idx$matche, _toConsumableArray(matches));
	            });
	          }
	        }
	      });
	      return results;
	    }
	  }, {
	    key: "_searchObjectList",
	    value: function _searchObjectList(query) {
	      var _this2 = this;

	      var searcher = createSearcher(query, this.options);
	      var _this$_myIndex = this._myIndex,
	          keys = _this$_myIndex.keys,
	          records = _this$_myIndex.records;
	      var results = []; // List is Array<Object>

	      records.forEach(function (_ref5) {
	        var item = _ref5.$,
	            idx = _ref5.i;

	        if (!isDefined(item)) {
	          return;
	        }

	        var matches = []; // Iterate over every key (i.e, path), and fetch the value at that key

	        keys.forEach(function (key, keyIndex) {
	          matches.push.apply(matches, _toConsumableArray(_this2._findMatches({
	            key: key,
	            value: item[keyIndex],
	            searcher: searcher
	          })));
	        });

	        if (matches.length) {
	          results.push({
	            idx: idx,
	            item: item,
	            matches: matches
	          });
	        }
	      });
	      return results;
	    }
	  }, {
	    key: "_findMatches",
	    value: function _findMatches(_ref6) {
	      var key = _ref6.key,
	          value = _ref6.value,
	          searcher = _ref6.searcher;

	      if (!isDefined(value)) {
	        return [];
	      }

	      var matches = [];

	      if (isArray(value)) {
	        value.forEach(function (_ref7) {
	          var text = _ref7.v,
	              idx = _ref7.i,
	              norm = _ref7.n;

	          if (!isDefined(text)) {
	            return;
	          }

	          var _searcher$searchIn2 = searcher.searchIn(text),
	              isMatch = _searcher$searchIn2.isMatch,
	              score = _searcher$searchIn2.score,
	              indices = _searcher$searchIn2.indices;

	          if (isMatch) {
	            matches.push({
	              score: score,
	              key: key,
	              value: text,
	              idx: idx,
	              norm: norm,
	              indices: indices
	            });
	          }
	        });
	      } else {
	        var text = value.v,
	            norm = value.n;

	        var _searcher$searchIn3 = searcher.searchIn(text),
	            isMatch = _searcher$searchIn3.isMatch,
	            score = _searcher$searchIn3.score,
	            indices = _searcher$searchIn3.indices;

	        if (isMatch) {
	          matches.push({
	            score: score,
	            key: key,
	            value: text,
	            norm: norm,
	            indices: indices
	          });
	        }
	      }

	      return matches;
	    }
	  }]);

	  return Fuse;
	}();

	Fuse.version = '6.4.6';
	Fuse.createIndex = createIndex;
	Fuse.parseIndex = parseIndex;
	Fuse.config = Config;

	{
	  Fuse.parseQuery = parse;
	}

	{
	  register(ExtendedSearch);
	}

	module.exports = Fuse;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var e=__webpack_require__(1),t=function(e){return e.replace(/-([a-z])/gi,function(e,t){return t.toUpperCase()})},n=function(){return document.currentScript||function(){var e=document.getElementsByTagName("script");return e[e.length-1]}()},r=function(e,n){void 0===n&&(n={});var r=e.attributes,i=Object.assign({},n);return Object.keys(r).forEach(function(e){if(r.hasOwnProperty(e)){var n=r[e].name;if(!n||"string"!=typeof n)return!1;var a=n.split(/(data-props?-)/).pop()||"";if(a=t(a),n!==a){var o=r[e].nodeValue;i[a]=o}}}),[].forEach.call(e.getElementsByTagName("script"),function(e){var t={};if(e.hasAttribute("type")){if("text/props"!==e.getAttribute("type")&&"application/json"!==e.getAttribute("type"))return;try{t=JSON.parse(e.innerHTML)}catch(e){throw new Error(e)}Object.assign(i,t)}}),i},i=function(e){var t=e.attributes,n=null;return Object.keys(t).forEach(function(e){if(t.hasOwnProperty(e)){"data-mount-in"===t[e].name&&(n=t[e].nodeValue)}}),n},a=function(e){var t=e.selector,r=e.inline,a=e.clientSpecified,o=[],c=n();if(!0===r){var u=c.parentNode;o.push(u)}return!0!==a||t||(t=i(c)),t&&[].forEach.call(document.querySelectorAll(t),function(e){o.push(e)}),o},o=function(t,n,i,a,o){n.forEach(function(n){var c=n;if(!c._habitat){c._habitat=!0;var u=r(n,o)||o;return a&&(c.innerHTML=""),e.render(e.h(t,u),c,i)}})},c=function(e){var t=e;return{render:function(e){void 0===e&&(e={});var n=e.selector;void 0===n&&(n=null);var r=e.inline;void 0===r&&(r=!1);var i=e.clean;void 0===i&&(i=!1);var c=e.clientSpecified;void 0===c&&(c=!1);var u=e.defaultProps;void 0===u&&(u={});var l=a({selector:n,inline:r,clientSpecified:c}),f=function(){if(l.length>0){var e=a({selector:n,inline:r,clientSpecified:c});return o(t,e,null,i,u)}};f(),document.addEventListener("DOMContentLoaded",f),document.addEventListener("load",f)}}};module.exports=c;
	//# sourceMappingURL=preact-habitat.js.map

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	var n=__webpack_require__(2),t=__webpack_require__(1);function e(n,t){for(var e in t)n[e]=t[e];return n}function r(n){var t=n.parentNode;t&&t.removeChild(n)}var o=t.options.__e;function u(n){this.__u=[],this.__f=n.fallback}function i(n){var e,r,o;function u(u){if(e||(e=n()).then(function(n){r=n.default},function(n){o=n}),o)throw o;if(!r)throw e;return t.createElement(r,u)}return u.displayName="Lazy",u.t=!0,u}t.options.__e=function(n,t,e){if(n.then&&e)for(var r,u=t;u=u.__;)if((r=u.__c)&&r.o)return e&&(t.__e=e.__e,t.__k=e.__k),void r.o(n);o(n,t,e)},(u.prototype=new t.Component).o=function(n){var e=this;e.__u.push(n);var o=function(){e.__u[e.__u.indexOf(n)]=e.__u[e.__u.length-1],e.__u.pop(),0==e.__u.length&&(e.__f&&t._e(e.__f),e.__v.__e=null,e.__v.__k=e.state.u,e.setState({u:null}))};null==e.state.u&&(e.__f=e.__f&&t.cloneElement(e.__f),e.setState({u:e.__v.__k}),function n(t){for(var e=0;e<t.length;e++){var o=t[e];null!=o&&("function"!=typeof o.type&&o.__e?r(o.__e):o.__k&&n(o.__k))}}(e.__v.__k),e.__v.__k=[]),n.then(o,o)},u.prototype.render=function(n,t){return t.u?this.__f:n.children};var c="undefined"!=typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103,f=/^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/,a=t.options.event;function l(n){return m.bind(null,n)}function s(n,e,o){if(null==e.__k)for(;e.firstChild;)r(e.firstChild);return t.render(n,e),"function"==typeof o&&o(),n?n.__c:null}t.options.event=function(n){return a&&(n=a(n)),n.persist=function(){},n.nativeEvent=n};var p=function(){function n(){}var t=n.prototype;return t.getChildContext=function(){return this.props.context},t.render=function(n){return n.children},n}();function v(n){var e=this,r=n.container,o=t.h(p,{context:e.context},n.vnode);return e.i&&e.i!==r&&(e.l.parentNode&&e.i.removeChild(e.l),t._e(e.s),e.p=!1),n.vnode?e.p?(r.__k=e.__k,t.render(o,r),e.__k=r.__k):(e.l=document.createTextNode(""),t.hydrate("",r),r.appendChild(e.l),e.p=!0,e.i=r,t.render(o,r,e.l),e.__k=this.l.__k):e.p&&(e.l.parentNode&&e.i.removeChild(e.l),t._e(e.s)),e.s=o,e.componentWillUnmount=function(){e.l.parentNode&&e.i.removeChild(e.l),t._e(e.s)},null}function d(n,e){return t.h(v,{vnode:n,container:e})}var h=function(n,e){return n?t.toChildArray(n).map(e):null},x={map:h,forEach:h,count:function(n){return n?t.toChildArray(n).length:0},only:function(n){if(1!==(n=t.toChildArray(n)).length)throw new Error("Children.only() expects only one child.");return n[0]},toArray:t.toChildArray};function m(){var n=t.h.apply(void 0,arguments),e=n.type,r=n.props;return"function"!=typeof e&&(r.defaultValue&&(r.value||0===r.value||(r.value=r.defaultValue),delete r.defaultValue),Array.isArray(r.value)&&r.multiple&&"select"===e&&(t.toChildArray(r.children).forEach(function(n){-1!=r.value.indexOf(n.props.value)&&(n.props.selected=!0)}),delete r.value),function(n,t){var e,r,o;for(o in t)if(e=f.test(o))break;if(e)for(o in r=n.props={},t)r[f.test(o)?o.replace(/([A-Z0-9])/,"-$1").toLowerCase():o]=t[o]}(n,r)),n.preactCompatNormalized=!1,y(n)}function y(n){return n.preactCompatNormalized=!0,function(n){var t=n.props;(t.class||t.className)&&(E.enumerable="className"in t,t.className&&(t.class=t.className),Object.defineProperty(t,"className",E))}(n),n}function b(n){return g(n)?y(t.cloneElement.apply(null,arguments)):n}function g(n){return!!n&&n.$$typeof===c}function C(n){return!!n.__k&&(t.render(null,n),!0)}var E={configurable:!0,get:function(){return this.class}};function _(n,t){for(var e in n)if("__source"!==e&&!(e in t))return!0;for(var r in t)if("__source"!==r&&n[r]!==t[r])return!0;return!1}function w(n){return n&&(n.base||1===n.nodeType&&n)||null}var A=function(n){var t,e;function r(t){var e;return(e=n.call(this,t)||this).isPureReactComponent=!0,e}return e=n,(t=r).prototype=Object.create(e.prototype),t.prototype.constructor=t,t.__proto__=e,r.prototype.shouldComponentUpdate=function(n,t){return _(this.props,n)||_(this.state,t)},r}(t.Component);function k(n,r){function o(n){var t=this.props.ref,e=t==n.ref;return!e&&t&&(t.call?t(null):t.current=null),r?!r(this.props,n)||!e:_(this.props,n)}function u(r){return this.shouldComponentUpdate=o,t.h(n,e({},r))}return u.prototype.isReactComponent=!0,u.displayName="Memo("+(n.displayName||n.name)+")",u.t=!0,u}function S(n){function t(t){var r=e({},t);return delete r.ref,n(r,t.ref)}return t.prototype.isReactComponent=!0,t.t=!0,t.displayName="ForwardRef("+(n.displayName||n.name)+")",t}function N(n,t){n["UNSAFE_"+t]&&!n[t]&&Object.defineProperty(n,t,{configurable:!1,get:function(){return this["UNSAFE_"+t]},set:function(n){this["UNSAFE_"+t]=n}})}t.Component.prototype.isReactComponent={};var F=t.options.vnode;t.options.vnode=function(n){n.$$typeof=c,function(t){var e=n.type,r=n.props;if(r&&"string"==typeof e){var o={};for(var u in r)/^on(Ani|Tra)/.test(u)&&(r[u.toLowerCase()]=r[u],delete r[u]),o[u.toLowerCase()]=u;if(o.ondoubleclick&&(r.ondblclick=r[o.ondoubleclick],delete r[o.ondoubleclick]),o.onbeforeinput&&(r.onbeforeinput=r[o.onbeforeinput],delete r[o.onbeforeinput]),o.onchange&&("textarea"===e||"input"===e.toLowerCase()&&!/^fil|che|ra/i.test(r.type))){var i=o.oninput||"oninput";r[i]||(r[i]=r[o.onchange],delete r[o.onchange])}}}();var t=n.type;t&&t.t&&n.ref&&(n.props.ref=n.ref,n.ref=null),"function"==typeof t&&!t.v&&t.prototype&&(N(t.prototype,"componentWillMount"),N(t.prototype,"componentWillReceiveProps"),N(t.prototype,"componentWillUpdate"),t.v=!0),F&&F(n)};var R=function(n,t){return n(t)},O={useState:n.useState,useReducer:n.useReducer,useEffect:n.useEffect,useLayoutEffect:n.useLayoutEffect,useRef:n.useRef,useImperativeHandle:n.useImperativeHandle,useMemo:n.useMemo,useCallback:n.useCallback,useContext:n.useContext,useDebugValue:n.useDebugValue,version:"16.8.0",Children:x,render:s,hydrate:s,unmountComponentAtNode:C,createPortal:d,createElement:m,createContext:t.createContext,createFactory:l,cloneElement:b,createRef:t.createRef,Fragment:t.Fragment,isValidElement:g,findDOMNode:w,Component:t.Component,PureComponent:A,memo:k,forwardRef:S,unstable_batchedUpdates:R,Suspense:u,lazy:i};Object.keys(n).forEach(function(t){exports[t]=n[t]}),exports.createContext=t.createContext,exports.createRef=t.createRef,exports.Fragment=t.Fragment,exports.Component=t.Component,exports.version="16.8.0",exports.Children=x,exports.render=s,exports.hydrate=s,exports.unmountComponentAtNode=C,exports.createPortal=d,exports.createElement=m,exports.createFactory=l,exports.cloneElement=b,exports.isValidElement=g,exports.findDOMNode=w,exports.PureComponent=A,exports.memo=k,exports.forwardRef=S,exports.unstable_batchedUpdates=R,exports.Suspense=u,exports.lazy=i,exports.default=O;
	//# sourceMappingURL=compat.js.map


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(120)):"function"==typeof define&&define.amd?define("Stories",["React"],t):"object"==typeof exports?exports.Stories=t(require("react")):e.Stories=t(e.React)}(this,(function(e){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="/dist/index.js",n(n.s=3)}([function(t,n){t.exports=e},function(e,t,n){"use strict";var r=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});var o=r(n(0)).default.createContext({stories:[],defaultInterval:4e3,width:360,height:640});t.default=o},function(e,t,n){"use strict";var r=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});var o=r(n(0));t.default=o.default.createContext({numArray:[],currentId:0,count:0,currentStory:{url:""},videoDuration:0,bufferAction:!1,pause:!1})},function(e,t,n){"use strict";function r(e){return(r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var o=this&&this.__importStar||function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t},i=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});var a=o(n(0)),u=i(n(4)),l=i(n(1)),s=function(e){a.useEffect((function(){e.stories.forEach((function(e,t){var n=[],o="object"!==r(e)||!e.url||"image"!==e.type&&e.type?"string"==typeof e?e:null:e.url;o&&(n[t]=new Image,n[t].src=o)}))}),[e.stories]);var t={stories:e.stories.map((function(e){return"string"==typeof e?{url:e}:e})),width:e.width,height:e.height,loader:e.loader,header:e.header,storyStyles:e.storyStyles,loop:e.loop,defaultInterval:e.defaultInterval,isPaused:e.isPaused,currentIndex:e.currentIndex,onStoryStart:e.onStoryStart,onStoryEnd:e.onStoryEnd,onAllStoriesEnd:e.onAllStoriesEnd};return a.default.createElement(l.default.Provider,{value:t},a.default.createElement(u.default,null))};s.defaultProps={width:360,height:640,defaultInterval:4e3},t.default=s},function(e,t,n){"use strict";function r(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){var n=[],r=!0,o=!1,i=void 0;try{for(var a,u=e[Symbol.iterator]();!(r=(a=u.next()).done)&&(n.push(a.value),!t||n.length!==t);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==u.return||u.return()}finally{if(o)throw i}}return n}(e,t)||function(){return;("Invalid attempt to destructure non-iterable instance")}()}var o=this&&this.__importStar||function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t},i=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});var a=o(n(0)),u=i(n(1)),l=i(n(2)),s=i(n(5)),c=i(n(12));t.default=function(){var e=r(a.useState(0),2),t=e[0],n=e[1],o=r(a.useState(!0),2),i=o[0],d=o[1],p=r(a.useState(0),2),h=p[0],y=p[1],m=r(a.useState(!0),2),v=m[0],b=m[1],g=r(a.useState(0),2),_=g[0],x=g[1],w=a.useRef(),S=a.useRef(),E=a.useContext(u.default),M=E.width,j=E.height,I=E.defaultInterval,C=E.stories,O=E.loop,P=E.currentIndex,k=E.isPaused,T=E.onStoryStart,A=E.onStoryEnd,D=E.onAllStoriesEnd;a.useEffect((function(){return i||(S.current=requestAnimationFrame(z)),function(){cancelAnimationFrame(S.current)}}),[t,i]),a.useEffect((function(){y(0)}),[t,C]),a.useEffect((function(){"number"==typeof P&&(P>=0&&P<C.length?n(P):console.error("Index out of bounds. Current index was set to value more than the length of stories array.",P))}),[P]),a.useEffect((function(){"boolean"==typeof k&&d(k)}),[k]);var z=function e(){y((function(n){0===n&&R();var r=Z();return n<100?S.current=requestAnimationFrame(e):(L(),t===C.length-1&&V(),J()),n+100/(r/1e3*60)}))},R=function(){T&&T(t,C[t])},L=function(){A&&A(t,C[t])},V=function(){D&&D()},Z=function(){return"video"===C[t].type?_:"number"==typeof C[t].duration?C[t].duration:I},B=function(e,t){d("pause"===e),b(!!t)},J=function(){O?N():q()},N=function(){n((t+1)%C.length),y(0)},q=function(){t<C.length-1&&(n(t+1),y(0))},F=function(e){e.preventDefault(),w.current=setTimeout((function(){B("pause")}),200)},U=function(e,r){e.preventDefault(),w.current&&clearTimeout(w.current),i?B("play"):"next"===r?J():t>0&&(n(t-1),y(0))};return a.default.createElement("div",{style:Object.assign({},f.container,{width:M,height:j})},a.default.createElement(l.default.Provider,{value:{bufferAction:v,videoDuration:_,numArray:C.map((function(e,t){return t})),currentStory:C[t],currentId:t,count:h,pause:i}},a.default.createElement(c.default,null)),a.default.createElement(s.default,{action:B,bufferAction:v,playState:i,story:C[t],getVideoDuration:function(e){x(1e3*e)}}),a.default.createElement("div",{style:f.overlay},a.default.createElement("div",{style:{width:"50%",zIndex:999},onTouchStart:F,onTouchEnd:function(e){return U(e,"previous")},onMouseDown:F,onMouseUp:function(e){return U(e,"previous")}}),a.default.createElement("div",{style:{width:"50%",zIndex:999},onTouchStart:F,onTouchEnd:function(e){return U(e,"next")},onMouseDown:F,onMouseUp:function(e){return U(e,"next")}})))};var f={container:{display:"flex",flexDirection:"column",background:"#111",position:"relative"},overlay:{position:"absolute",height:"inherit",width:"inherit",display:"flex"}}},function(e,t,n){"use strict";function r(e){return(r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function o(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){var n=[],r=!0,o=!1,i=void 0;try{for(var a,u=e[Symbol.iterator]();!(r=(a=u.next()).done)&&(n.push(a.value),!t||n.length!==t);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==u.return||u.return()}finally{if(o)throw i}}return n}(e,t)||function(){return;("Invalid attempt to destructure non-iterable instance")}()}var i=this&&this.__importStar||function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t},a=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});var u=i(n(0)),l=a(n(6)),s=a(n(7)),c=a(n(8)),f=a(n(1)),d={story:{display:"flex",position:"relative",overflow:"hidden"},storyContent:{width:"auto",maxWidth:"100%",maxHeight:"100%",margin:"auto"}};t.default=function(e){var t=o(u.useState(!1),2),n=t[0],i=t[1],a=o(u.useState(!1),2),p=a[0],h=a[1],y=u.useContext(f.default),m=y.width,v=y.height,b=y.loader,g=y.header,_=y.storyStyles;u.useEffect((function(){h(!1),"object"===r(e.story)&&e.story.content?(i(!0),e.action("play",!0)):(i(!1),e.action("pause",!0),x.current&&x.current.addEventListener("waiting",(function(){e.action("pause",!0)})),x.current&&x.current.addEventListener("playing",(function(){e.action("play",!0)})))}),[e.story]);var x=u.useRef(null);u.useEffect((function(){x.current&&(e.playState?x.current.pause():x.current.play().catch((function(e){return console.log(e)})))}),[e.playState]);var w=function(){try{i(!0),e.action("play",!0)}catch(e){console.log(e)}},S=function(){try{e.getVideoDuration(x.current.duration),x.current&&x.current.play().then((function(){w()})).catch((function(t){e.action("pause"),console.log(t)}))}catch(e){console.log(e)}},E="object"===r(e.story)&&e.story.header;return u.default.createElement("div",{style:Object.assign({},d.story,{width:m,height:v})},function(){var t="object"===r(e.story)&&e.story.content;if(t)return u.default.createElement(t,{action:e.action,isPaused:e.playState});var n="object"===r(e.story)?e.story.url:e.story,o="object"===r(e.story)&&e.story.styles||_||d.storyContent,i="object"===r(e.story)&&"video"===e.story.type?"video":"image";return"image"===i?u.default.createElement("img",{style:o,src:n,onLoad:w}):"video"===i?u.default.createElement("video",{ref:x,style:o,src:n,controls:!1,onLoadedData:S,autoPlay:!0,playsInline:!0}):null}(),E&&u.default.createElement("div",{style:{position:"absolute",left:12,top:20,zIndex:19}},"object"===r(e.story)?g?g(e.story.header):u.default.createElement(l.default,{heading:e.story.header.heading,subheading:e.story.header.subheading,profileImage:e.story.header.profileImage}):null),!n&&u.default.createElement("div",{style:{width:m,height:v,position:"absolute",left:0,top:0,background:"rgba(0, 0, 0, 0.9)",zIndex:9,display:"flex",justifyContent:"center",alignItems:"center",color:"#ccc"}},b||u.default.createElement("div",{className:c.default.spinner})),"object"===r(e.story)&&e.story.seeMore&&u.default.createElement("div",{style:{position:"absolute",margin:"auto",bottom:p?"unset":0,zIndex:9999,width:"100%",height:p?"100%":"auto"}},u.default.createElement(s.default,{action:e.action,toggleMore:function(t){h(t),e.action(t?"pause":"play")},showContent:p,seeMoreContent:e.story.seeMore})))}},function(e,t,n){"use strict";var r=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});var o=r(n(0)),i={main:{display:"flex",alignItems:"center"},img:{width:40,height:40,borderRadius:40,marginRight:10,filter:"drop-shadow(0 0px 2px rgba(0, 0, 0, 0.5))",border:"2px solid rgba(255, 255, 255, 0.8)"},text:{display:"flex",flexDirection:"column",filter:"drop-shadow(0 0px 3px rgba(0, 0, 0, 0.9))"},heading:{fontSize:"1rem",color:"rgba(255, 255, 255, 0.9)",margin:0,marginBottom:2},subheading:{fontSize:"0.6rem",color:"rgba(255, 255, 255, 0.8)",margin:0}};t.default=function(e){var t=e.profileImage,n=e.heading,r=e.subheading;return o.default.createElement("div",{style:i.main},t&&o.default.createElement("img",{style:i.img,src:t}),o.default.createElement("span",{style:i.text},o.default.createElement("p",{style:i.heading},n),o.default.createElement("p",{style:i.subheading},r)))}},function(e,t,n){"use strict";var r=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});var o=r(n(0));t.default=function(e){var t=e.seeMoreContent;return e.showContent?o.default.createElement("div",{style:i.seeMoreExpanded},o.default.createElement(t,{close:function(){return e.toggleMore(!1)}})):o.default.createElement("div",{onClick:function(){e.toggleMore(!0)},style:i.seeMore},o.default.createElement("span",{style:i.seeMoreIcon},"⌃"),o.default.createElement("span",{style:i.seeMoreText},"See more"))};var i={seeMore:{height:"10vh",background:"linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.2))",display:"flex",flexDirection:"column",width:"100%",alignItems:"center",justifyContent:"flex-end",bottom:0},seeMoreExpanded:{position:"absolute",top:0,left:0,width:"100%",height:"100%",boxSizing:"border-box",zIndex:99999},seeMoreText:{color:"white",textAlign:"center",letterSpacing:"0.1em",marginBottom:"2.2vh",textTransform:"capitalize",opacity:"1",fontSize:"0.8em",transition:"opacity 300ms ease-in-out"},seeMoreIcon:{color:"white",textAlign:"center",letterSpacing:"0.2em",marginBottom:"0.4vh",opacity:"1",filter:"drop-shadow(0 0 5px black)",textTransform:"capitalize",transition:"opacity 300ms ease-in-out"},seeMoreClose:{position:"absolute",filter:"drop-shadow(0 3px 2px #ccc)",right:"0.5rem",top:"0.5rem",fontSize:"1.5rem",opacity:"0.7",padding:"1rem"}}},function(e,t,n){var r=n(9);"string"==typeof r&&(r=[[e.i,r,""]]);var o={insert:"head",singleton:!1};n(11)(r,o);r.locals&&(e.exports=r.locals)},function(e,t,n){(t=e.exports=n(10)(!1)).push([e.i,"._1CK7FHVwhiOnuCiZJwiPq1 {\n\twidth: 40px;\n\theight: 40px;\n\tmargin: 100px auto;\n\tbackground-color: #fff;\n\n\tborder-radius: 100%;\n\t-webkit-animation: _1hEQ2VzIkTiZ-9jZoLI3JC 1s infinite ease-in-out;\n\tanimation: _1hEQ2VzIkTiZ-9jZoLI3JC 1s infinite ease-in-out;\n}\n\n@-webkit-keyframes _1hEQ2VzIkTiZ-9jZoLI3JC {\n\t0% {\n\t\t-webkit-transform: scale(0);\n\t}\n\t100% {\n\t\t-webkit-transform: scale(1);\n\t\topacity: 0;\n\t}\n}\n\n@keyframes _1hEQ2VzIkTiZ-9jZoLI3JC {\n\t0% {\n\t\t-webkit-transform: scale(0);\n\t\ttransform: scale(0);\n\t}\n\t100% {\n\t\t-webkit-transform: scale(1);\n\t\ttransform: scale(1);\n\t\topacity: 0;\n\t}\n}\n",""]),t.locals={spinner:"_1CK7FHVwhiOnuCiZJwiPq1","sk-scaleout":"_1hEQ2VzIkTiZ-9jZoLI3JC"}},function(e,t,n){"use strict";e.exports=function(e){var t=[];return t.toString=function(){return this.map((function(t){var n=function(e,t){var n=e[1]||"",r=e[3];if(!r)return n;if(t&&"function"==typeof btoa){var o=(a=r,u=btoa(unescape(encodeURIComponent(JSON.stringify(a)))),l="sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(u),"/*# ".concat(l," */")),i=r.sources.map((function(e){return"/*# sourceURL=".concat(r.sourceRoot).concat(e," */")}));return[n].concat(i).concat([o]).join("\n")}var a,u,l;return[n].join("\n")}(t,e);return t[2]?"@media ".concat(t[2],"{").concat(n,"}"):n})).join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var r={},o=0;o<this.length;o++){var i=this[o][0];null!=i&&(r[i]=!0)}for(var a=0;a<e.length;a++){var u=e[a];null!=u[0]&&r[u[0]]||(n&&!u[2]?u[2]=n:n&&(u[2]="(".concat(u[2],") and (").concat(n,")")),t.push(u))}},t}},function(e,t,n){"use strict";var r,o={},i=function(){return void 0===r&&(r=Boolean(window&&document&&document.all&&!window.atob)),r},a=function(){var e={};return function(t){if(void 0===e[t]){var n=document.querySelector(t);if(window.HTMLIFrameElement&&n instanceof window.HTMLIFrameElement)try{n=n.contentDocument.head}catch(e){n=null}e[t]=n}return e[t]}}();function u(e,t){for(var n=[],r={},o=0;o<e.length;o++){var i=e[o],a=t.base?i[0]+t.base:i[0],u={css:i[1],media:i[2],sourceMap:i[3]};r[a]?r[a].parts.push(u):n.push(r[a]={id:a,parts:[u]})}return n}function l(e,t){for(var n=0;n<e.length;n++){var r=e[n],i=o[r.id],a=0;if(i){for(i.refs++;a<i.parts.length;a++)i.parts[a](r.parts[a]);for(;a<r.parts.length;a++)i.parts.push(m(r.parts[a],t))}else{for(var u=[];a<r.parts.length;a++)u.push(m(r.parts[a],t));o[r.id]={id:r.id,refs:1,parts:u}}}}function s(e){var t=document.createElement("style");if(void 0===e.attributes.nonce){var r=n.nc;r&&(e.attributes.nonce=r)}if(Object.keys(e.attributes).forEach((function(n){t.setAttribute(n,e.attributes[n])})),"function"==typeof e.insert)e.insert(t);else{var o=a(e.insert||"head");if(!o)throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");o.appendChild(t)}return t}var c,f=(c=[],function(e,t){return c[e]=t,c.filter(Boolean).join("\n")});function d(e,t,n,r){var o=n?"":r.css;if(e.styleSheet)e.styleSheet.cssText=f(t,o);else{var i=document.createTextNode(o),a=e.childNodes;a[t]&&e.removeChild(a[t]),a.length?e.insertBefore(i,a[t]):e.appendChild(i)}}function p(e,t,n){var r=n.css,o=n.media,i=n.sourceMap;if(o&&e.setAttribute("media",o),i&&btoa&&(r+="\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i))))," */")),e.styleSheet)e.styleSheet.cssText=r;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(r))}}var h=null,y=0;function m(e,t){var n,r,o;if(t.singleton){var i=y++;n=h||(h=s(t)),r=d.bind(null,n,i,!1),o=d.bind(null,n,i,!0)}else n=s(t),r=p.bind(null,n,t),o=function(){!function(e){if(null===e.parentNode)return!1;e.parentNode.removeChild(e)}(n)};return r(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;r(e=t)}else o()}}e.exports=function(e,t){(t=t||{}).attributes="object"==typeof t.attributes?t.attributes:{},t.singleton||"boolean"==typeof t.singleton||(t.singleton=i());var n=u(e,t);return l(n,t),function(e){for(var r=[],i=0;i<n.length;i++){var a=n[i],s=o[a.id];s&&(s.refs--,r.push(s))}e&&l(u(e,t),t);for(var c=0;c<r.length;c++){var f=r[c];if(0===f.refs){for(var d=0;d<f.parts.length;d++)f.parts[d]();delete o[f.id]}}}}},function(e,t,n){"use strict";var r=this&&this.__importStar||function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t},o=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});var i=r(n(0)),a=o(n(13)),u=o(n(2));t.default=function(){var e=i.useContext(u.default),t=e.numArray,n=e.currentId;return i.default.createElement("div",{style:l.progressArr},t.map((function(e){return i.default.createElement(a.default,{key:e,width:1/t.length,active:e===n?1:e<n?2:0})})))};var l={progressArr:{display:"flex",justifyContent:"center",maxWidth:"100%",flexWrap:"row",position:"absolute",width:"98%",padding:5,paddingTop:7,alignSelf:"center",zIndex:99,filter:"drop-shadow(0 1px 8px #222)"}}},function(e,t,n){"use strict";var r=this&&this.__importStar||function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t},o=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});var i=r(n(0)),a=o(n(14)),u=o(n(2));t.default=function(e){var t=i.useContext(u.default),n=t.bufferAction,r=t.count,o=t.pause,s=e.width,c=e.active;return i.default.createElement(a.default,{width:s,pause:o,bufferAction:n},i.default.createElement("div",{style:Object.assign({},function(e){switch(e.active){case 2:return{width:"100%"};case 1:return{transform:"scaleX(".concat(r/100,")")};case 0:default:return{width:0}}}({active:c}),l.inner)}))};var l={inner:{background:"#fff",height:"100%",maxWidth:"100%",borderRadius:2,transformOrigin:"center left",WebkitBackfaceVisibility:"hidden",MozBackfaceVisibility:"hidden",msBackfaceVisibility:"hidden",backfaceVisibility:"hidden",WebkitPerspective:1e3,MozPerspective:1e3,msPerspective:1e3,perspective:1e3}}},function(e,t,n){"use strict";var r=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});var o=r(n(0)),i=function(e){var t=e.width,n=e.pause,r=e.bufferAction;return{width:"".concat(100*t,"%"),opacity:n&&!r?0:1}},a={progress:{height:2,maxWidth:"100%",background:"#555",margin:2,borderRadius:2,transition:"opacity 400ms ease-in-out"}};t.default=function(e){return o.default.createElement("div",{style:Object.assign({},a.progress,i(e))},e.children)}}])}));
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();

	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;

	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;

	module.exports = __webpack_require__(123);

	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ }),
/* 123 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	!(function(global) {
	  "use strict";

	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }

	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);

	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);

	    return generator;
	  }
	  runtime.wrap = wrap;

	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }

	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";

	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};

	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}

	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };

	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }

	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";

	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }

	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };

	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };

	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };

	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }

	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }

	    var previousPromise;

	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }

	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }

	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }

	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;

	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );

	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };

	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;

	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }

	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }

	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }

	      context.method = method;
	      context.arg = arg;

	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }

	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;

	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }

	          context.dispatchException(context.arg);

	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }

	        state = GenStateExecuting;

	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;

	          if (record.arg === ContinueSentinel) {
	            continue;
	          }

	          return {
	            value: record.arg,
	            done: context.done
	          };

	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }

	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;

	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);

	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }

	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }

	      return ContinueSentinel;
	    }

	    var record = tryCatch(method, delegate.iterator, context.arg);

	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }

	    var info = record.arg;

	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }

	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;

	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;

	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }

	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }

	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }

	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);

	  Gp[toStringTagSymbol] = "Generator";

	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };

	  Gp.toString = function() {
	    return "[object Generator]";
	  };

	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };

	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }

	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }

	    this.tryEntries.push(entry);
	  }

	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }

	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }

	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();

	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }

	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };

	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }

	      if (typeof iterable.next === "function") {
	        return iterable;
	      }

	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }

	          next.value = undefined;
	          next.done = true;

	          return next;
	        };

	        return next.next = next;
	      }
	    }

	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;

	  function doneResult() {
	    return { value: undefined, done: true };
	  }

	  Context.prototype = {
	    constructor: Context,

	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;

	      this.method = "next";
	      this.arg = undefined;

	      this.tryEntries.forEach(resetTryEntry);

	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },

	    stop: function() {
	      this.done = true;

	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }

	      return this.rval;
	    },

	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }

	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;

	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }

	        return !! caught;
	      }

	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;

	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }

	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");

	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }

	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },

	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }

	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }

	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;

	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }

	      return this.complete(record);
	    },

	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }

	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }

	      return ContinueSentinel;
	    },

	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },

	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }

	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },

	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };

	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }

	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(116);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(51)(content, {"singleton":true});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?sourceMap=false!../../node_modules/postcss-loader/index.js!./custom.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?sourceMap=false!../../node_modules/postcss-loader/index.js!./custom.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(117);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(51)(content, {"singleton":true});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../node_modules/css-loader/index.js?sourceMap=false!../node_modules/postcss-loader/index.js!./coca-clean.css", function() {
				var newContent = require("!!../node_modules/css-loader/index.js?sourceMap=false!../node_modules/postcss-loader/index.js!./coca-clean.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// embed.js